export const CategoryMapPaiZu = [{
    id: '1',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'wjlx',
    name: '违纪行为',
    children: [{
        id: '2',
        parentId: '1',
        petitionVal: '0101',
        sortValue: '11',
        code: 'wjlx_2',
        name: '违反政治纪律',
        children: [{
            id: '13',
            parentId: '2',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_13',
            name: '组织参加支持反党活动',
            children: []
          },
          {
            id: '14',
            parentId: '2',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_14',
            name: '发表刊登有政治问题的文章',
            children: []
          },
          {
            id: '15',
            parentId: '2',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_15',
            name: '参加非法组织',
            children: [{
                id: '65',
                parentId: '15',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_65',
                name: '组织领导或参加反动组织',
                children: []
              },
              {
                id: '66',
                parentId: '15',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_66',
                name: '组织领导或参加邪教组织',
                children: []
              }
            ]
          },
          {
            id: '16',
            parentId: '2',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_16',
            name: '不执行党和国家方针政策',
            children: []
          },
          {
            id: '17',
            parentId: '2',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_17',
            name: '非法提供情报',
            children: []
          },
          {
            id: '18',
            parentId: '2',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_18',
            name: '叛逃出走',
            children: []
          },
          {
            id: '19',
            parentId: '2',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_19',
            name: '违反其他政治纪律',
            children: [{
                id: '67',
                parentId: '19',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_67',
                name: '携带反动出版物入境',
                children: []
              },
              {
                id: '68',
                parentId: '19',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_68',
                name: '组织参加秘密集团',
                children: []
              },
              {
                id: '69',
                parentId: '19',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_69',
                name: '违反民族政策',
                children: []
              },
              {
                id: '70',
                parentId: '19',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_70',
                name: '违反宗教政策',
                children: []
              },
              {
                id: '71',
                parentId: '19',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_71',
                name: '利用宗族势力反党',
                children: []
              },
              {
                id: '72',
                parentId: '19',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_72',
                name: '造谣传播丑化党和国家形象',
                children: []
              },
              {
                id: '73',
                parentId: '19',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_73',
                name: '涉外活动造成恶劣政治影响',
                children: []
              },
              {
                id: '74',
                parentId: '19',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_74',
                name: '其他违反政治纪律行为',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '3',
        parentId: '1',
        petitionVal: '0102',
        sortValue: '10',
        code: 'wjlx_3',
        name: '违反组织人事纪律',
        children: [{
            id: '20',
            parentId: '3',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_20',
            name: '违反民主集中制',
            children: []
          },
          {
            id: '21',
            parentId: '3',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_21',
            name: '违反干部选拔任用制度',
            children: [{
                id: '75',
                parentId: '21',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_75',
                name: '违反干部选拨任用规定',
                children: []
              },
              {
                id: '76',
                parentId: '21',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_76',
                name: '违反党和国家法规',
                children: []
              },
              {
                id: '77',
                parentId: '21',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_77',
                name: '用人失察',
                children: []
              }
            ]
          },
          {
            id: '22',
            parentId: '3',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_22',
            name: '违反其他组织人事纪律',
            children: [{
                id: '78',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_78',
                name: '违规发展党员',
                children: []
              },
              {
                id: '79',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_79',
                name: '搞非组织活动',
                children: []
              },
              {
                id: '80',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_80',
                name: '不执行组织分配调动交流',
                children: []
              },
              {
                id: '81',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_81',
                name: '违反干部人事劳动规定谋取利益',
                children: []
              },
              {
                id: '82',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_82',
                name: '考试录取中弄虚作假',
                children: []
              },
              {
                id: '83',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_83',
                name: '以不正当方式谋求公款出国（境）',
                children: []
              },
              {
                id: '84',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_84',
                name: '擅改出国（境）计划',
                children: []
              },
              {
                id: '85',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_85',
                name: '擅离组织或违规交往',
                children: []
              },
              {
                id: '86',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_86',
                name: '脱离组织出走',
                children: []
              },
              {
                id: '87',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_87',
                name: '为出走提供方便',
                children: []
              },
              {
                id: '88',
                parentId: '22',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_88',
                name: '其他违反组织人事纪律行为',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '4',
        parentId: '1',
        petitionVal: '0103',
        sortValue: '9',
        code: 'wjlx_4',
        name: '违反廉洁自律规定',
        children: [{
            id: '23',
            parentId: '4',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_23',
            name: '非法占有',
            children: [{
                id: '89',
                parentId: '23',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_89',
                name: '非法占有非本人经管财务',
                children: []
              },
              {
                id: '90',
                parentId: '23',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_90',
                name: '违规报销个人费用',
                children: []
              },
              {
                id: '91',
                parentId: '23',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_91',
                name: '违规报销近亲属出国费用',
                children: []
              },
              {
                id: '92',
                parentId: '23',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_92',
                name: '非法占有公物',
                children: []
              },
              {
                id: '93',
                parentId: '23',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_93',
                name: '占用公物营利或非法活动',
                children: []
              }
            ]
          },
          {
            id: '24',
            parentId: '4',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_24',
            name: '受礼',
            children: [{
                id: '94',
                parentId: '24',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_94',
                name: '接受礼品馈赠',
                children: []
              },
              {
                id: '95',
                parentId: '24',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_95',
                name: '亲属收受财物',
                children: []
              },
              {
                id: '96',
                parentId: '24',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_96',
                name: '第三人收受财物',
                children: []
              }
            ]
          },
          {
            id: '25',
            parentId: '4',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_25',
            name: '违反从业限制规定',
            children: []
          },
          {
            id: '26',
            parentId: '4',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_26',
            name: '违规从事营利活动',
            children: [{
                id: '97',
                parentId: '26',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_97',
                name: '违规经商办企业',
                children: []
              },
              {
                id: '98',
                parentId: '26',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_98',
                name: '违规从事证券投资',
                children: []
              },
              {
                id: '99',
                parentId: '26',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_99',
                name: '有偿中介活动',
                children: []
              },
              {
                id: '100',
                parentId: '26',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_100',
                name: '国（境）外投资',
                children: []
              },
              {
                id: '101',
                parentId: '26',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_101',
                name: '为亲友经营活动谋利',
                children: []
              },
              {
                id: '102',
                parentId: '26',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_102',
                name: '违规兼职',
                children: []
              },
              {
                id: '103',
                parentId: '26',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_103',
                name: '其他违规营利活动',
                children: []
              }
            ]
          },
          {
            id: '27',
            parentId: '4',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_27',
            name: '挥霍浪费公共财产',
            children: [{
                id: '104',
                parentId: '27',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_104',
                name: '公款旅游',
                children: []
              },
              {
                id: '105',
                parentId: '27',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_105',
                name: '公款高消费娱乐',
                children: []
              },
              {
                id: '106',
                parentId: '27',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_106',
                name: '违规配备使用小汽车',
                children: []
              },
              {
                id: '107',
                parentId: '27',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_107',
                name: '其他挥霍浪费公共财产行为',
                children: []
              }
            ]
          },
          {
            id: '28',
            parentId: '4',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_28',
            name: '违反其他廉洁自律规定',
            children: [{
                id: '108',
                parentId: '28',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_108',
                name: '其他违规营利活动',
                children: []
              },
              {
                id: '109',
                parentId: '28',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_109',
                name: '违规接受宴请',
                children: []
              },
              {
                id: '110',
                parentId: '28',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_110',
                name: '违规操办婚丧喜庆事宜',
                children: []
              },
              {
                id: '111',
                parentId: '28',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_111',
                name: '其他违反廉洁自律规定行为',
                children: []
              },
              {
                id: '813',
                parentId: '28',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_813',
                name: '违反住房规定',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '5',
        parentId: '1',
        petitionVal: '0104',
        sortValue: '8',
        code: 'wjlx_5',
        name: '贪污贿赂',
        children: [{
            id: '29',
            parentId: '5',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_29',
            name: '贪污',
            children: [{
                id: '112',
                parentId: '29',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_112',
                name: '党和国家工作人员贪污',
                children: []
              },
              {
                id: '113',
                parentId: '29',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_113',
                name: '贪污特殊款物',
                children: []
              },
              {
                id: '114',
                parentId: '29',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_114',
                name: '不按规定上交礼品',
                children: []
              },
              {
                id: '115',
                parentId: '29',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_115',
                name: '基层组织党员贪污',
                children: []
              },
              {
                id: '116',
                parentId: '29',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_116',
                name: '公款购房归个人所有',
                children: []
              }
            ]
          },
          {
            id: '30',
            parentId: '5',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_30',
            name: '私分国有资产',
            children: [{
                id: '117',
                parentId: '30',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_117',
                name: '集体私分国有资产',
                children: []
              },
              {
                id: '118',
                parentId: '30',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_118',
                name: '集体私分罚没财物',
                children: []
              },
              {
                id: '119',
                parentId: '30',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_119',
                name: '集体私分应交礼品',
                children: []
              }
            ]
          },
          {
            id: '31',
            parentId: '5',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_31',
            name: '贿赂',
            children: [{
                id: '120',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_120',
                name: '索贿受贿',
                children: []
              },
              {
                id: '121',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_121',
                name: '索贿未遂刁难报复',
                children: []
              },
              {
                id: '122',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_122',
                name: '违规收受回扣手续费',
                children: []
              },
              {
                id: '123',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_123',
                name: '利用他人职务行为受贿',
                children: []
              },
              {
                id: '124',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_124',
                name: '通过亲属受贿',
                children: []
              },
              {
                id: '125',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_125',
                name: '退（离）休人员利用职务影响受贿',
                children: []
              },
              {
                id: '126',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_126',
                name: '单位受贿',
                children: []
              },
              {
                id: '127',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_127',
                name: '基层组织党员受贿',
                children: []
              },
              {
                id: '128',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_128',
                name: '行贿',
                children: []
              },
              {
                id: '129',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_129',
                name: '对单位行贿',
                children: []
              },
              {
                id: '130',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_130',
                name: '单位行贿',
                children: []
              },
              {
                id: '131',
                parentId: '31',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_131',
                name: '介绍贿赂',
                children: []
              }
            ]
          },
          {
            id: '32',
            parentId: '5',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_32',
            name: '挪用公款',
            children: [{
                id: '132',
                parentId: '32',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_132',
                name: '党和国家工作人员挪用公款',
                children: []
              },
              {
                id: '133',
                parentId: '32',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_133',
                name: '基层组织党员挪用公款',
                children: []
              }
            ]
          },
          {
            id: '33',
            parentId: '5',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_33',
            name: '巨额财产来源不明',
            children: []
          },
          {
            id: '34',
            parentId: '5',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_34',
            name: '其他贪污贿赂',
            children: []
          }
        ]
      },
      {
        id: '6',
        parentId: '1',
        petitionVal: '0105',
        sortValue: '7',
        code: 'wjlx_6',
        name: '破坏社会主义经济秩序',
        children: [{
            id: '35',
            parentId: '6',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_35',
            name: '挪用资金',
            children: [{
                id: '134',
                parentId: '35',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_134',
                name: '非国家工作人员挪用资金',
                children: []
              },
              {
                id: '135',
                parentId: '35',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_135',
                name: '单位挪用资金',
                children: []
              }
            ]
          },
          {
            id: '36',
            parentId: '6',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_36',
            name: '妨害公司企业管理秩序',
            children: [{
                id: '136',
                parentId: '36',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_136',
                name: '非国家工作人员索取收受财物',
                children: []
              },
              {
                id: '137',
                parentId: '36',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_137',
                name: '给予非国家工作人员财物',
                children: []
              },
              {
                id: '138',
                parentId: '36',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_138',
                name: '为亲友经营牟利',
                children: []
              }
            ]
          },
          {
            id: '37',
            parentId: '6',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_37',
            name: '违反金融管理法规',
            children: []
          },
          {
            id: '38',
            parentId: '6',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_38',
            name: '违反税收管理法规',
            children: [{
                id: '139',
                parentId: '38',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_139',
                name: '不履行纳税义务',
                children: []
              },
              {
                id: '140',
                parentId: '38',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_140',
                name: '违反票据管理规定',
                children: []
              }
            ]
          },
          {
            id: '39',
            parentId: '6',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_39',
            name: '违反土地管理法规',
            children: []
          },
          {
            id: '40',
            parentId: '6',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_40',
            name: '扰乱市场经济活动',
            children: [{
                id: '141',
                parentId: '40',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_141',
                name: '制售假冒伪劣产品',
                children: []
              },
              {
                id: '142',
                parentId: '40',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_142',
                name: '违规进行证券期货交易',
                children: []
              },
              {
                id: '143',
                parentId: '40',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_143',
                name: '不正当手段竞争',
                children: []
              }
            ]
          },
          {
            id: '41',
            parentId: '6',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_41',
            name: '其他破坏社会主义经济秩序',
            children: [{
                id: '144',
                parentId: '41',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_144',
                name: '走私',
                children: []
              },
              {
                id: '145',
                parentId: '41',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_145',
                name: '职务侵占',
                children: []
              },
              {
                id: '146',
                parentId: '41',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_146',
                name: '非法经营同类业务',
                children: []
              },
              {
                id: '147',
                parentId: '41',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_147',
                name: '党和国家机关违规办企业',
                children: []
              },
              {
                id: '148',
                parentId: '41',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_148',
                name: '中介组织出具虚假文件',
                children: []
              },
              {
                id: '149',
                parentId: '41',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_149',
                name: '其他破坏经济秩序行为',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '7',
        parentId: '1',
        petitionVal: '0106',
        sortValue: '6',
        code: 'wjlx_7',
        name: '违反财经纪律',
        children: [{
            id: '42',
            parentId: '7',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_42',
            name: '国有资产流失',
            children: []
          },
          {
            id: '43',
            parentId: '7',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_43',
            name: '违反收支两条线',
            children: [{
                id: '150',
                parentId: '43',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_150',
                name: '私设小金库',
                children: []
              },
              {
                id: '151',
                parentId: '43',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_151',
                name: '其他违反“收支两条线”行为',
                children: []
              }
            ]
          },
          {
            id: '44',
            parentId: '7',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_44',
            name: '违反政府采购和招投标',
            children: []
          },
          {
            id: '45',
            parentId: '7',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_45',
            name: '违反其他财经纪律',
            children: [{
                id: '152',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_152',
                name: '隐瞒截留坐支财政收入',
                children: []
              },
              {
                id: '153',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_153',
                name: '骗取国家拨款',
                children: []
              },
              {
                id: '154',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_154',
                name: '违规核拨动用国家资金',
                children: []
              },
              {
                id: '155',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_155',
                name: '借用公款不还',
                children: []
              },
              {
                id: '156',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_156',
                name: '借用公款营利或非法活动',
                children: []
              },
              {
                id: '157',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_157',
                name: '违规将公款借予他人',
                children: []
              },
              {
                id: '158',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_158',
                name: '公款私存',
                children: []
              },
              {
                id: '159',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_159',
                name: '单位收受礼品拒不交公',
                children: []
              },
              {
                id: '160',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_160',
                name: '擅自开设银行账户',
                children: []
              },
              {
                id: '161',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_161',
                name: '擅自动用查封冻结财物',
                children: []
              },
              {
                id: '162',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_162',
                name: '违规担保',
                children: []
              },
              {
                id: '163',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_163',
                name: '违反会计法规',
                children: []
              },
              {
                id: '164',
                parentId: '45',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_164',
                name: '其他违反财经纪律行为',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '8',
        parentId: '1',
        petitionVal: '0107',
        sortValue: '5',
        code: 'wjlx_8',
        name: '失职渎职',
        children: [{
            id: '46',
            parentId: '8',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_46',
            name: '行政机关失职渎职',
            children: []
          },
          {
            id: '47',
            parentId: '8',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_47',
            name: '生产经营管理失职渎职',
            children: []
          },
          {
            id: '48',
            parentId: '8',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_48',
            name: '安全事故',
            children: [{
                id: '165',
                parentId: '48',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_165',
                name: '不认真执行安全防护法律法规',
                children: []
              },
              {
                id: '166',
                parentId: '48',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_166',
                name: '组织群众性活动发生事故',
                children: []
              },
              {
                id: '167',
                parentId: '48',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_167',
                name: '公共场所事故',
                children: []
              },
              {
                id: '168',
                parentId: '48',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_168',
                name: '食品药品事故',
                children: []
              }
            ]
          },
          {
            id: '49',
            parentId: '8',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_49',
            name: '执纪执法司法失职渎职',
            children: [{
                id: '169',
                parentId: '49',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_169',
                name: '瞒案不报压案不办',
                children: []
              },
              {
                id: '170',
                parentId: '49',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_170',
                name: '对保护合法权益申请不作为',
                children: []
              },
              {
                id: '171',
                parentId: '49',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_171',
                name: '违规保全',
                children: []
              },
              {
                id: '172',
                parentId: '49',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_172',
                name: '不履行法定执行职责',
                children: []
              },
              {
                id: '173',
                parentId: '49',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_173',
                name: '不移交案件',
                children: []
              },
              {
                id: '174',
                parentId: '49',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_174',
                name: '办案安全事故',
                children: []
              },
              {
                id: '175',
                parentId: '49',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_175',
                name: '徇私舞弊枉法裁判',
                children: []
              },
              {
                id: '176',
                parentId: '49',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_176',
                name: '刑讯逼供暴力取证',
                children: []
              },
              {
                id: '177',
                parentId: '49',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_177',
                name: '不纠正冤假错案',
                children: []
              }
            ]
          },
          {
            id: '50',
            parentId: '8',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_50',
            name: '其他失职渎职',
            children: [{
                id: '178',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_178',
                name: '党组织负责人失职渎职',
                children: []
              },
              {
                id: '179',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_179',
                name: '决定基建项目失误',
                children: []
              },
              {
                id: '180',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_180',
                name: '社会管理和服务事故',
                children: []
              },
              {
                id: '181',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_181',
                name: '处理灾害事故失职',
                children: []
              },
              {
                id: '182',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_182',
                name: '瞒报谎报缓报漏报重要情况',
                children: []
              },
              {
                id: '183',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_183',
                name: '解决群众切身利益问题失职',
                children: []
              },
              {
                id: '184',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_184',
                name: '放任反党活动',
                children: []
              },
              {
                id: '185',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_185',
                name: '不认真解决问题造成重大事件',
                children: []
              },
              {
                id: '186',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_186',
                name: '不制止不查处不正之风',
                children: []
              },
              {
                id: '187',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_187',
                name: '重大事件不及时作为',
                children: []
              },
              {
                id: '188',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_188',
                name: '乱收费乱摊派',
                children: []
              },
              {
                id: '189',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_189',
                name: '强令公职人员违规行使职权',
                children: []
              },
              {
                id: '190',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_190',
                name: '强令实施违法行为',
                children: []
              },
              {
                id: '191',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_191',
                name: '失职致使所属人员叛逃出走',
                children: []
              },
              {
                id: '192',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_192',
                name: '失密泄密',
                children: []
              },
              {
                id: '193',
                parentId: '50',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_193',
                name: '其他失职渎职行为',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '9',
        parentId: '1',
        petitionVal: '0108',
        sortValue: '4',
        code: 'wjlx_9',
        name: '侵犯党员权利公民权利',
        children: [{
            id: '51',
            parentId: '9',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_51',
            name: '打击报复',
            children: []
          },
          {
            id: '52',
            parentId: '9',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_52',
            name: '侵犯民主权利',
            children: [{
                id: '194',
                parentId: '52',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_194',
                name: '压制申辩等权利',
                children: []
              },
              {
                id: '195',
                parentId: '52',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_195',
                name: '侵犯选举权被选举权表决权',
                children: []
              },
              {
                id: '196',
                parentId: '52',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_196',
                name: '妨害选举权被选举权表决权',
                children: []
              }
            ]
          },
          {
            id: '53',
            parentId: '9',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_53',
            name: '侵犯人身权利',
            children: [{
                id: '197',
                parentId: '53',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_197',
                name: '侮辱诽谤',
                children: []
              },
              {
                id: '198',
                parentId: '53',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_198',
                name: '殴打体罚非法拘禁搜查',
                children: []
              },
              {
                id: '199',
                parentId: '53',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_199',
                name: '其他侵犯人身权利行为',
                children: []
              }
            ]
          },
          {
            id: '54',
            parentId: '9',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_54',
            name: '诬告陷害',
            children: []
          },
          {
            id: '55',
            parentId: '9',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_55',
            name: '其他侵犯党员或公民权利',
            children: [{
                id: '200',
                parentId: '55',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_200',
                name: '违反劳动管理法律法规侵权',
                children: []
              },
              {
                id: '201',
                parentId: '55',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_201',
                name: '侵犯通信自由',
                children: []
              },
              {
                id: '202',
                parentId: '55',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_202',
                name: '干涉婚姻自由',
                children: []
              },
              {
                id: '203',
                parentId: '55',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_203',
                name: '其他侵权行为',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '10',
        parentId: '1',
        petitionVal: '0109',
        sortValue: '3',
        code: 'wjlx_10',
        name: '严重违反社会主义道德',
        children: [{
            id: '56',
            parentId: '10',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_56',
            name: '弄虚作假骗取荣誉',
            children: []
          },
          {
            id: '57',
            parentId: '10',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_57',
            name: '通奸重婚包养情人',
            children: [{
                id: '204',
                parentId: '57',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_204',
                name: '通奸',
                children: []
              },
              {
                id: '205',
                parentId: '57',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_205',
                name: '重婚或包养',
                children: []
              }
            ]
          },
          {
            id: '58',
            parentId: '10',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_58',
            name: '其他严重违反社会主义道德行为',
            children: [{
                id: '206',
                parentId: '58',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_206',
                name: '利用职权、教养、从属关系发生性行为',
                children: []
              },
              {
                id: '207',
                parentId: '58',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_207',
                name: '不履行抚养教育赡养义务',
                children: []
              },
              {
                id: '208',
                parentId: '58',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_208',
                name: '虐待遗弃',
                children: []
              },
              {
                id: '209',
                parentId: '58',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_209',
                name: '遇险能救不救',
                children: []
              },
              {
                id: '210',
                parentId: '58',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_210',
                name: '其他违反道德行为',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '11',
        parentId: '1',
        petitionVal: '0110',
        sortValue: '2',
        code: 'wjlx_11',
        name: '妨害社会管理秩序',
        children: [
          { id: '59', parentId: '11', petitionVal: '', sortValue: '', code: 'wjlx_59', name: '嫖娼', children: [] },
          { id: '60', parentId: '11', petitionVal: '', sortValue: '', code: 'wjlx_60', name: '赌博', children: [] },
          {
            id: '61',
            parentId: '11',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_61',
            name: '妨碍执行公务',
            children: []
          },
          {
            id: '62',
            parentId: '11',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_62',
            name: '扰乱公共秩序',
            children: []
          },
          {
            id: '63',
            parentId: '11',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_63',
            name: '违反人口与计划生育法规',
            children: []
          },
          {
            id: '64',
            parentId: '11',
            petitionVal: '',
            sortValue: '',
            code: 'wjlx_64',
            name: '妨害其他社会管理秩序',
            children: [{
                id: '211',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_211',
                name: '色情活动',
                children: []
              },
              {
                id: '212',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_212',
                name: '制黄贩黄',
                children: []
              },
              {
                id: '213',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_213',
                name: '观看淫秽影视书画表演',
                children: []
              },
              {
                id: '214',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_214',
                name: '淫乱活动',
                children: []
              },
              {
                id: '215',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_215',
                name: '猥亵侮辱妇女',
                children: []
              },
              {
                id: '216',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_216',
                name: '吸毒贩毒',
                children: []
              },
              {
                id: '217',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_217',
                name: '侵犯公私财产',
                children: []
              },
              {
                id: '218',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_218',
                name: '伪造买卖使用假公文证件',
                children: []
              },
              {
                id: '219',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_219',
                name: '违反保护环境资源文物等法律法规',
                children: []
              },
              {
                id: '220',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_220',
                name: '编造散播虚假有害信息',
                children: []
              },
              {
                id: '221',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_221',
                name: '非法侵入计算机系统',
                children: []
              },
              {
                id: '222',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_222',
                name: '包庇犯罪分子',
                children: []
              },
              {
                id: '223',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_223',
                name: '包庇恐怖分子',
                children: []
              },
              {
                id: '224',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_224',
                name: '包庇黑社会组织成员',
                children: []
              },
              {
                id: '225',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_225',
                name: '包庇违纪人员',
                children: []
              },
              {
                id: '226',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_226',
                name: '被蒙骗为犯罪行为提供便利',
                children: []
              },
              {
                id: '227',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_227',
                name: '违反驻在国法律法规',
                children: []
              },
              {
                id: '228',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_228',
                name: '偷越国（边）境',
                children: []
              },
              {
                id: '229',
                parentId: '64',
                petitionVal: '',
                sortValue: '',
                code: 'wjlx_229',
                name: '其他妨害社会管理秩序行为',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '12',
        parentId: '1',
        petitionVal: '0111',
        sortValue: '1',
        code: 'wjlx_12',
        name: '其他违纪行为',
        children: []
      }
    ]
  },
  {
    id: '230',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'lgss',
    name: '实施机关_两规',
    children: [{
        id: '231',
        parentId: '230',
        petitionVal: '',
        sortValue: '12',
        code: 'lgss_231',
        name: '中央纪委',
        children: []
      },
      {
        id: '232',
        parentId: '230',
        petitionVal: '',
        sortValue: '11',
        code: 'lgss_232',
        name: '省区市纪委',
        children: []
      },
      {
        id: '233',
        parentId: '230',
        petitionVal: '',
        sortValue: '10',
        code: 'lgss_233',
        name: '地市州纪委',
        children: []
      },
      {
        id: '234',
        parentId: '230',
        petitionVal: '',
        sortValue: '8',
        code: 'lgss_234',
        name: '县市区纪委',
        children: []
      },
      {
        id: '235',
        parentId: '230',
        petitionVal: '',
        sortValue: '8',
        code: 'lgss_235',
        name: '中央纪委派驻纪检组',
        children: []
      },
      {
        id: '1249',
        parentId: '230',
        petitionVal: '',
        sortValue: '8',
        code: 'lgss_1249',
        name: '中央企业纪委纪检组',
        children: []
      },
      {
        id: '236',
        parentId: '230',
        petitionVal: '',
        sortValue: '7',
        code: 'lgss_236',
        name: '省区市纪委派驻纪检组',
        children: []
      },
      {
        id: '237',
        parentId: '230',
        petitionVal: '',
        sortValue: '6',
        code: 'lgss_237',
        name: '地市州纪委派驻纪检组',
        children: []
      },
      {
        id: '238',
        parentId: '230',
        petitionVal: '',
        sortValue: '5',
        code: 'lgss_238',
        name: '党和国家机关内设纪检组',
        children: []
      },
      {
        id: '239',
        parentId: '230',
        petitionVal: '',
        sortValue: '4',
        code: 'lgss_239',
        name: '国有大型企业纪委纪检组',
        children: []
      },
      {
        id: '240',
        parentId: '230',
        petitionVal: '',
        sortValue: '3',
        code: 'lgss_240',
        name: '中央和国务院直属事业单位纪委',
        children: []
      },
      {
        id: '860',
        parentId: '230',
        petitionVal: '',
        sortValue: '2',
        code: 'lgss_860',
        name: '中央和国家机关直属纪工委',
        children: []
      },
      { id: '861', parentId: '230', petitionVal: '', sortValue: '1', code: 'lgss_861', name: '省级纪工委', children: [] }
    ]
  },
  {
    id: '241',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'lzss',
    name: '实施机关_两指',
    children: [
      { id: '242', parentId: '241', petitionVal: '', sortValue: '7', code: 'lzss_242', name: '监察部', children: [] },
      {
        id: '243',
        parentId: '241',
        petitionVal: '',
        sortValue: '6',
        code: 'lzss_243',
        name: '省区市监察厅局',
        children: []
      },
      {
        id: '244',
        parentId: '241',
        petitionVal: '',
        sortValue: '5',
        code: 'lzss_244',
        name: '地市州监察局',
        children: []
      },
      {
        id: '245',
        parentId: '241',
        petitionVal: '',
        sortValue: '4',
        code: 'lzss_245',
        name: '县市区监察局',
        children: []
      },
      {
        id: '246',
        parentId: '241',
        petitionVal: '',
        sortValue: '3',
        code: 'lzss_246',
        name: '监察部派驻监察局监察专员办公室',
        children: []
      },
      {
        id: '247',
        parentId: '241',
        petitionVal: '',
        sortValue: '2',
        code: 'lzss_247',
        name: '省区市监察厅（局）派驻监察室',
        children: []
      },
      {
        id: '248',
        parentId: '241',
        petitionVal: '',
        sortValue: '1',
        code: 'lzss_248',
        name: '地市州监察局派驻监察室',
        children: []
      }
    ]
  },
  {
    id: '249',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'xl',
    name: '学历',
    children: [
      { id: '1588', parentId: '249', petitionVal: '', sortValue: '8', code: 'xl_1588', name: '无', children: [] },
      { id: '250', parentId: '249', petitionVal: '', sortValue: '7', code: 'xl_250', name: '博士研究生', children: [] },
      { id: '251', parentId: '249', petitionVal: '', sortValue: '6', code: 'xl_251', name: '硕士研究生', children: [] },
      { id: '252', parentId: '249', petitionVal: '', sortValue: '5', code: 'xl_252', name: '大学本科', children: [] },
      { id: '253', parentId: '249', petitionVal: '', sortValue: '4', code: 'xl_253', name: '大专', children: [] },
      { id: '254', parentId: '249', petitionVal: '', sortValue: '3', code: 'xl_254', name: '中专', children: [] },
      { id: '255', parentId: '249', petitionVal: '', sortValue: '2', code: 'xl_255', name: '高中', children: [] },
      { id: '256', parentId: '249', petitionVal: '', sortValue: '1', code: 'xl_256', name: '初中以下', children: [] }
    ]
  },
  {
    id: '257',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'mz',
    name: '民族',
    children: [
      { id: '258', parentId: '257', petitionVal: '01', sortValue: '56', code: 'mz_258', name: '汉族', children: [] },
      { id: '259', parentId: '257', petitionVal: '02', sortValue: '55', code: 'mz_259', name: '蒙古族', children: [] },
      { id: '260', parentId: '257', petitionVal: '03', sortValue: '54', code: 'mz_260', name: '回族', children: [] },
      { id: '261', parentId: '257', petitionVal: '04', sortValue: '53', code: 'mz_261', name: '藏族', children: [] },
      {
        id: '262',
        parentId: '257',
        petitionVal: '05',
        sortValue: '52',
        code: 'mz_262',
        name: '维吾尔族',
        children: []
      },
      { id: '263', parentId: '257', petitionVal: '06', sortValue: '51', code: 'mz_263', name: '苗族', children: [] },
      { id: '264', parentId: '257', petitionVal: '07', sortValue: '50', code: 'mz_264', name: '彝族', children: [] },
      { id: '265', parentId: '257', petitionVal: '08', sortValue: '49', code: 'mz_265', name: '壮族', children: [] },
      { id: '266', parentId: '257', petitionVal: '09', sortValue: '48', code: 'mz_266', name: '布依族', children: [] },
      { id: '267', parentId: '257', petitionVal: '10', sortValue: '47', code: 'mz_267', name: '朝鲜族', children: [] },
      { id: '268', parentId: '257', petitionVal: '11', sortValue: '46', code: 'mz_268', name: '满族', children: [] },
      { id: '269', parentId: '257', petitionVal: '12', sortValue: '45', code: 'mz_269', name: '侗族', children: [] },
      { id: '270', parentId: '257', petitionVal: '13', sortValue: '44', code: 'mz_270', name: '瑶族', children: [] },
      { id: '271', parentId: '257', petitionVal: '14', sortValue: '43', code: 'mz_271', name: '白族', children: [] },
      { id: '272', parentId: '257', petitionVal: '15', sortValue: '42', code: 'mz_272', name: '土家族', children: [] },
      { id: '273', parentId: '257', petitionVal: '16', sortValue: '41', code: 'mz_273', name: '哈尼族', children: [] },
      {
        id: '274',
        parentId: '257',
        petitionVal: '17',
        sortValue: '40',
        code: 'mz_274',
        name: '哈萨克族',
        children: []
      },
      { id: '275', parentId: '257', petitionVal: '18', sortValue: '39', code: 'mz_275', name: '傣族', children: [] },
      { id: '276', parentId: '257', petitionVal: '19', sortValue: '38', code: 'mz_276', name: '黎族', children: [] },
      { id: '277', parentId: '257', petitionVal: '20', sortValue: '37', code: 'mz_277', name: '傈僳族', children: [] },
      { id: '278', parentId: '257', petitionVal: '21', sortValue: '36', code: 'mz_278', name: '佤族', children: [] },
      { id: '279', parentId: '257', petitionVal: '22', sortValue: '35', code: 'mz_279', name: '畲族', children: [] },
      { id: '280', parentId: '257', petitionVal: '23', sortValue: '34', code: 'mz_280', name: '高山族', children: [] },
      { id: '281', parentId: '257', petitionVal: '24', sortValue: '33', code: 'mz_281', name: '拉祜族', children: [] },
      { id: '282', parentId: '257', petitionVal: '25', sortValue: '32', code: 'mz_282', name: '水族', children: [] },
      { id: '283', parentId: '257', petitionVal: '26', sortValue: '31', code: 'mz_283', name: '东乡族', children: [] },
      { id: '284', parentId: '257', petitionVal: '27', sortValue: '30', code: 'mz_284', name: '纳西族', children: [] },
      { id: '285', parentId: '257', petitionVal: '28', sortValue: '29', code: 'mz_285', name: '景颇族', children: [] },
      {
        id: '286',
        parentId: '257',
        petitionVal: '29',
        sortValue: '28',
        code: 'mz_286',
        name: '柯尔克孜族',
        children: []
      },
      { id: '287', parentId: '257', petitionVal: '30', sortValue: '27', code: 'mz_287', name: '土族', children: [] },
      {
        id: '288',
        parentId: '257',
        petitionVal: '31',
        sortValue: '26',
        code: 'mz_288',
        name: '达斡尔族',
        children: []
      },
      { id: '289', parentId: '257', petitionVal: '32', sortValue: '25', code: 'mz_289', name: '仫佬族', children: [] },
      { id: '290', parentId: '257', petitionVal: '33', sortValue: '24', code: 'mz_290', name: '羌族', children: [] },
      { id: '291', parentId: '257', petitionVal: '34', sortValue: '23', code: 'mz_291', name: '布朗族', children: [] },
      { id: '292', parentId: '257', petitionVal: '35', sortValue: '22', code: 'mz_292', name: '撒拉族', children: [] },
      { id: '293', parentId: '257', petitionVal: '36', sortValue: '21', code: 'mz_293', name: '毛南族', children: [] },
      { id: '294', parentId: '257', petitionVal: '37', sortValue: '20', code: 'mz_294', name: '仡佬族', children: [] },
      { id: '295', parentId: '257', petitionVal: '38', sortValue: '19', code: 'mz_295', name: '锡伯族', children: [] },
      { id: '296', parentId: '257', petitionVal: '39', sortValue: '18', code: 'mz_296', name: '阿昌族', children: [] },
      { id: '297', parentId: '257', petitionVal: '40', sortValue: '17', code: 'mz_297', name: '普米族', children: [] },
      {
        id: '298',
        parentId: '257',
        petitionVal: '41',
        sortValue: '16',
        code: 'mz_298',
        name: '塔吉克族',
        children: []
      },
      { id: '299', parentId: '257', petitionVal: '42', sortValue: '15', code: 'mz_299', name: '怒族', children: [] },
      {
        id: '300',
        parentId: '257',
        petitionVal: '43',
        sortValue: '14',
        code: 'mz_300',
        name: '乌孜别克族',
        children: []
      },
      {
        id: '301',
        parentId: '257',
        petitionVal: '44',
        sortValue: '13',
        code: 'mz_301',
        name: '俄罗斯族',
        children: []
      },
      {
        id: '302',
        parentId: '257',
        petitionVal: '45',
        sortValue: '12',
        code: 'mz_302',
        name: '鄂温克族',
        children: []
      },
      { id: '303', parentId: '257', petitionVal: '46', sortValue: '11', code: 'mz_303', name: '德昂族', children: [] },
      { id: '304', parentId: '257', petitionVal: '47', sortValue: '10', code: 'mz_304', name: '保安族', children: [] },
      { id: '305', parentId: '257', petitionVal: '48', sortValue: '9', code: 'mz_305', name: '裕固族', children: [] },
      { id: '306', parentId: '257', petitionVal: '49', sortValue: '8', code: 'mz_306', name: '京族', children: [] },
      { id: '307', parentId: '257', petitionVal: '50', sortValue: '7', code: 'mz_307', name: '塔塔尔族', children: [] },
      { id: '308', parentId: '257', petitionVal: '51', sortValue: '6', code: 'mz_308', name: '独龙族', children: [] },
      { id: '309', parentId: '257', petitionVal: '52', sortValue: '5', code: 'mz_309', name: '鄂伦春族', children: [] },
      { id: '310', parentId: '257', petitionVal: '53', sortValue: '4', code: 'mz_310', name: '赫哲族', children: [] },
      { id: '311', parentId: '257', petitionVal: '54', sortValue: '3', code: 'mz_311', name: '门巴族', children: [] },
      { id: '312', parentId: '257', petitionVal: '55', sortValue: '2', code: 'mz_312', name: '珞巴族', children: [] },
      { id: '313', parentId: '257', petitionVal: '56', sortValue: '1', code: 'mz_313', name: '基诺族', children: [] }
    ]
  },
  {
    id: '314',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'zzmm',
    name: '政治面貌',
    children: [{
        id: '315',
        parentId: '314',
        petitionVal: '',
        sortValue: 13,
        code: 'zzmm_315',
        name: '中共党员',
        children: [{
            id: '321',
            parentId: '315',
            petitionVal: '',
            sortValue: '',
            code: 'zzmm_321',
            name: '正式党员',
            children: []
          },
          {
            id: '322',
            parentId: '315',
            petitionVal: '',
            sortValue: '',
            code: 'zzmm_322',
            name: '预备党员',
            children: []
          }
        ]
      },
      {
        id: '1584',
        parentId: '314',
        petitionVal: '',
        sortValue: 12,
        code: 'zzmm_1584',
        name: '中共预备党员',
        children: []
      },
      { id: '316', parentId: '314', petitionVal: '', sortValue: 11, code: 'zzmm_316', name: '共青团员', children: [] },
      {
        id: '1618',
        parentId: '314',
        petitionVal: '',
        sortValue: 10,
        code: 'zzmm_1618',
        name: '民革党员',
        children: []
      },
      { id: '1619', parentId: '314', petitionVal: '', sortValue: 9, code: 'zzmm_1619', name: '民盟盟员', children: [] },
      { id: '1620', parentId: '314', petitionVal: '', sortValue: 8, code: 'zzmm_1620', name: '民建会员', children: [] },
      { id: '1621', parentId: '314', petitionVal: '', sortValue: 7, code: 'zzmm_1621', name: '民进会员', children: [] },
      {
        id: '1622',
        parentId: '314',
        petitionVal: '',
        sortValue: 6,
        code: 'zzmm_1622',
        name: '农工党党员',
        children: []
      },
      {
        id: '1623',
        parentId: '314',
        petitionVal: '',
        sortValue: 5,
        code: 'zzmm_1623',
        name: '致公党党员',
        children: []
      },
      {
        id: '1624',
        parentId: '314',
        petitionVal: '',
        sortValue: 4,
        code: 'zzmm_1624',
        name: '九三学社社员',
        children: []
      },
      {
        id: '1625',
        parentId: '314',
        petitionVal: '',
        sortValue: 3,
        code: 'zzmm_1625',
        name: ' 台盟盟员',
        children: []
      },
      { id: '862', parentId: '314', petitionVal: '', sortValue: 2, code: 'zzmm_862', name: '无党派人士', children: [] },
      { id: '318', parentId: '314', petitionVal: '', sortValue: 1, code: 'zzmm_318', name: '群众', children: [] }
    ]
  },
  {
    id: '331',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'rank',
    name: '职级',
    children: [{
        id: '332',
        parentId: '331',
        petitionVal: '0200',
        sortValue: '6',
        code: 'rank_332',
        name: '省部级及以上',
        children: [{
            id: '946',
            parentId: '332',
            petitionVal: '',
            sortValue: '6',
            code: 'cluesecondrank_946',
            name: '正省部级以上',
            children: []
          },
          {
            id: '947',
            parentId: '332',
            petitionVal: '',
            sortValue: '5',
            code: 'cluesecondrank_947',
            name: '正省部级',
            children: []
          },
          {
            id: '948',
            parentId: '332',
            petitionVal: '',
            sortValue: '4',
            code: 'cluesecondrank_948',
            name: '副省部级',
            children: []
          },
          {
            id: '949',
            parentId: '332',
            petitionVal: '',
            sortValue: '3',
            code: 'cluesecondrank_949',
            name: '中管企业主要负责人',
            children: []
          },
          {
            id: '950',
            parentId: '332',
            petitionVal: '',
            sortValue: '2',
            code: 'cluesecondrank_950',
            name: '中央金融机构正职',
            children: []
          },
          {
            id: '951',
            parentId: '332',
            petitionVal: '',
            sortValue: '1',
            code: 'cluesecondrank_951',
            name: '中央金融机构副职',
            children: []
          },
          {
            id: '338',
            parentId: '332',
            petitionVal: '',
            sortValue: '',
            code: 'rank_338',
            name: '领导职务正级',
            children: []
          },
          {
            id: '339',
            parentId: '332',
            petitionVal: '',
            sortValue: '',
            code: 'rank_339',
            name: '非领导职务正级',
            children: []
          },
          {
            id: '340',
            parentId: '332',
            petitionVal: '',
            sortValue: '',
            code: 'rank_340',
            name: '领导职务副级',
            children: []
          },
          {
            id: '341',
            parentId: '332',
            petitionVal: '',
            sortValue: '',
            code: 'rank_341',
            name: '非领导职务副级',
            children: []
          },
          {
            id: '848',
            parentId: '332',
            petitionVal: '',
            sortValue: '',
            code: 'rank_848',
            name: '正级',
            children: []
          },
          {
            id: '849',
            parentId: '332',
            petitionVal: '',
            sortValue: '',
            code: 'rank_849',
            name: '副级',
            children: []
          }
        ]
      },
      {
        id: '333',
        parentId: '331',
        petitionVal: '0300',
        sortValue: '5',
        code: 'rank_333',
        name: '厅局级',
        children: [{
            id: '952',
            parentId: '333',
            petitionVal: '',
            sortValue: '2',
            code: 'cluesecondrank_952',
            name: '正地厅级',
            children: []
          },
          {
            id: '953',
            parentId: '333',
            petitionVal: '',
            sortValue: '1',
            code: 'cluesecondrank_953',
            name: '副地厅级',
            children: []
          },
          {
            id: '342',
            parentId: '333',
            petitionVal: '',
            sortValue: '',
            code: 'rank_342',
            name: '领导职务正级',
            children: []
          },
          {
            id: '343',
            parentId: '333',
            petitionVal: '',
            sortValue: '',
            code: 'rank_343',
            name: '非领导职务正级',
            children: []
          },
          {
            id: '344',
            parentId: '333',
            petitionVal: '',
            sortValue: '',
            code: 'rank_344',
            name: '领导职务副级',
            children: []
          },
          {
            id: '345',
            parentId: '333',
            petitionVal: '',
            sortValue: '',
            code: 'rank_345',
            name: '非领导职务副级',
            children: []
          },
          {
            id: '850',
            parentId: '333',
            petitionVal: '',
            sortValue: '',
            code: 'rank_850',
            name: '正级',
            children: []
          },
          {
            id: '851',
            parentId: '333',
            petitionVal: '',
            sortValue: '',
            code: 'rank_851',
            name: '副级',
            children: []
          }
        ]
      },
      {
        id: '334',
        parentId: '331',
        petitionVal: '0400',
        sortValue: '4',
        code: 'rank_334',
        name: '县处级',
        children: [{
            id: '954',
            parentId: '334',
            petitionVal: '',
            sortValue: '2',
            code: 'cluesecondrank_954',
            name: '正县处级',
            children: []
          },
          {
            id: '955',
            parentId: '334',
            petitionVal: '',
            sortValue: '1',
            code: 'cluesecondrank_955',
            name: '副县处级',
            children: []
          },
          {
            id: '346',
            parentId: '334',
            petitionVal: '',
            sortValue: '',
            code: 'rank_346',
            name: '领导职务正级',
            children: []
          },
          {
            id: '347',
            parentId: '334',
            petitionVal: '',
            sortValue: '',
            code: 'rank_347',
            name: '非领导职务正级',
            children: []
          },
          {
            id: '348',
            parentId: '334',
            petitionVal: '',
            sortValue: '',
            code: 'rank_348',
            name: '领导职务副级',
            children: []
          },
          {
            id: '349',
            parentId: '334',
            petitionVal: '',
            sortValue: '',
            code: 'rank_349',
            name: '非领导职务副级',
            children: []
          },
          {
            id: '852',
            parentId: '334',
            petitionVal: '',
            sortValue: '',
            code: 'rank_852',
            name: '正级',
            children: []
          },
          {
            id: '853',
            parentId: '334',
            petitionVal: '',
            sortValue: '',
            code: 'rank_853',
            name: '副级',
            children: []
          }
        ]
      },
      {
        id: '335',
        parentId: '331',
        petitionVal: '0500',
        sortValue: '3',
        code: 'rank_335',
        name: '乡科级',
        children: [{
            id: '956',
            parentId: '335',
            petitionVal: '',
            sortValue: '2',
            code: 'cluesecondrank_956',
            name: '正乡科级',
            children: []
          },
          {
            id: '957',
            parentId: '335',
            petitionVal: '',
            sortValue: '1',
            code: 'cluesecondrank_957',
            name: '副乡科级',
            children: []
          },
          {
            id: '350',
            parentId: '335',
            petitionVal: '',
            sortValue: '',
            code: 'rank_350',
            name: '领导职务正级',
            children: []
          },
          {
            id: '351',
            parentId: '335',
            petitionVal: '',
            sortValue: '',
            code: 'rank_351',
            name: '非领导职务正级',
            children: []
          },
          {
            id: '352',
            parentId: '335',
            petitionVal: '',
            sortValue: '',
            code: 'rank_352',
            name: '领导职务副级',
            children: []
          },
          {
            id: '353',
            parentId: '335',
            petitionVal: '',
            sortValue: '',
            code: 'rank_353',
            name: '非领导职务副级',
            children: []
          },
          {
            id: '854',
            parentId: '335',
            petitionVal: '',
            sortValue: '',
            code: 'rank_854',
            name: '正级',
            children: []
          },
          {
            id: '855',
            parentId: '335',
            petitionVal: '',
            sortValue: '',
            code: 'rank_855',
            name: '副级',
            children: []
          }
        ]
      },
      {
        id: '336',
        parentId: '331',
        petitionVal: '0600',
        sortValue: '2',
        code: 'rank_336',
        name: '一般干部',
        children: []
      },
      {
        id: '337',
        parentId: '331',
        petitionVal: '0900',
        sortValue: '1',
        code: 'rank_337',
        name: '其他人员',
        children: [{
            id: '354',
            parentId: '337',
            petitionVal: '0901',
            sortValue: '',
            code: 'rank_354',
            name: '军队',
            children: []
          },
          {
            id: '355',
            parentId: '337',
            petitionVal: '0903',
            sortValue: '',
            code: 'rank_355',
            name: '企业',
            children: []
          },
          {
            id: '356',
            parentId: '337',
            petitionVal: '0904',
            sortValue: '',
            code: 'rank_356',
            name: '农村',
            children: []
          },
          {
            id: '357',
            parentId: '337',
            petitionVal: '0905',
            sortValue: '',
            code: 'rank_357',
            name: '其他',
            children: []
          }
        ]
      }
    ]
  },
  {
    id: '358',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'deputy',
    name: '人大委员',
    children: [{
        id: '1498',
        parentId: '358',
        petitionVal: '',
        sortValue: '6',
        code: 'deputy_1498',
        name: '否',
        children: []
      },
      {
        id: '359',
        parentId: '358',
        petitionVal: '',
        sortValue: '5',
        code: 'deputy_359',
        name: '全国人大委员',
        children: []
      },
      {
        id: '360',
        parentId: '358',
        petitionVal: '',
        sortValue: '4',
        code: 'deputy_360',
        name: '省级人大委员',
        children: []
      },
      {
        id: '361',
        parentId: '358',
        petitionVal: '',
        sortValue: '3',
        code: 'deputy_361',
        name: '市级人大委员',
        children: []
      },
      {
        id: '362',
        parentId: '358',
        petitionVal: '',
        sortValue: '2',
        code: 'deputy_362',
        name: '县级人大委员',
        children: []
      },
      {
        id: '363',
        parentId: '358',
        petitionVal: '',
        sortValue: '1',
        code: 'deputy_363',
        name: '乡级人大委员',
        children: []
      }
    ]
  },
  {
    id: '364',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'commissioner',
    name: '政协委员',
    children: [{
        id: '1499',
        parentId: '364',
        petitionVal: '',
        sortValue: '5',
        code: 'commissioner_1499',
        name: '否',
        children: []
      },
      {
        id: '365',
        parentId: '364',
        petitionVal: '',
        sortValue: '4',
        code: 'commissioner_365',
        name: '全国政协委员',
        children: []
      },
      {
        id: '366',
        parentId: '364',
        petitionVal: '',
        sortValue: '3',
        code: 'commissioner_366',
        name: '省级政协委员',
        children: []
      },
      {
        id: '367',
        parentId: '364',
        petitionVal: '',
        sortValue: '2',
        code: 'commissioner_367',
        name: '市级政协委员',
        children: []
      },
      {
        id: '368',
        parentId: '364',
        petitionVal: '',
        sortValue: '1',
        code: 'commissioner_368',
        name: '县级政协委员',
        children: []
      }
    ]
  },
  {
    id: '369',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'casereso',
    name: '案件来源',
    children: [{
        id: '370',
        parentId: '369',
        petitionVal: '',
        sortValue: '9',
        code: 'casereso_370',
        name: '信访举报',
        children: []
      },
      {
        id: '859',
        parentId: '369',
        petitionVal: '',
        sortValue: '8',
        code: 'casereso_859',
        name: '领导交办',
        children: []
      },
      {
        id: '371',
        parentId: '369',
        petitionVal: '',
        sortValue: '7',
        code: 'casereso_371',
        name: '上级交办',
        children: []
      },
      {
        id: '372',
        parentId: '369',
        petitionVal: '',
        sortValue: '6',
        code: 'casereso_372',
        name: '公检法等机关移送',
        children: []
      },
      {
        id: '373',
        parentId: '369',
        petitionVal: '',
        sortValue: '5',
        code: 'casereso_373',
        name: '监督检查中发现',
        children: []
      },
      {
        id: '374',
        parentId: '369',
        petitionVal: '',
        sortValue: '4',
        code: 'casereso_374',
        name: '纪律审查中发现',
        children: []
      },
      {
        id: '375',
        parentId: '369',
        petitionVal: '',
        sortValue: '3',
        code: 'casereso_375',
        name: '审计中发现',
        children: []
      },
      {
        id: '376',
        parentId: '369',
        petitionVal: '',
        sortValue: '2',
        code: 'casereso_376',
        name: '巡视中发现',
        children: []
      },
      {
        id: '377',
        parentId: '369',
        petitionVal: '',
        sortValue: '1',
        code: 'casereso_377',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '378',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'depttype',
    name: '部门分类',
    children: [{
        id: '379',
        parentId: '378',
        petitionVal: '',
        sortValue: '11',
        code: 'depttype_379',
        name: '党务机关',
        children: [{
            id: '390',
            parentId: '379',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_390',
            name: '组织',
            children: []
          },
          {
            id: '391',
            parentId: '379',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_391',
            name: '宣传',
            children: []
          },
          {
            id: '392',
            parentId: '379',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_392',
            name: '政法委',
            children: []
          },
          {
            id: '393',
            parentId: '379',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_393',
            name: '纪检监察',
            children: []
          },
          {
            id: '857',
            parentId: '379',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_857',
            name: '统战部',
            children: []
          },
          {
            id: '858',
            parentId: '379',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_858',
            name: '机关工委',
            children: []
          }
        ]
      },
      {
        id: '380',
        parentId: '378',
        petitionVal: '',
        sortValue: '10',
        code: 'depttype_380',
        name: '政府机关',
        children: []
      },
      {
        id: '381',
        parentId: '378',
        petitionVal: '',
        sortValue: '9',
        code: 'depttype_381',
        name: '人大机关',
        children: []
      },
      {
        id: '382',
        parentId: '378',
        petitionVal: '',
        sortValue: '8',
        code: 'depttype_382',
        name: '政协机关',
        children: []
      },
      {
        id: '383',
        parentId: '378',
        petitionVal: '',
        sortValue: '7',
        code: 'depttype_383',
        name: '审判机关',
        children: []
      },
      {
        id: '384',
        parentId: '378',
        petitionVal: '',
        sortValue: '6',
        code: 'depttype_384',
        name: '检察机关',
        children: []
      },
      {
        id: '385',
        parentId: '378',
        petitionVal: '',
        sortValue: '5',
        code: 'depttype_385',
        name: '人民团体',
        children: [{
            id: '394',
            parentId: '385',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_394',
            name: '工会',
            children: []
          },
          {
            id: '395',
            parentId: '385',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_395',
            name: '共青团',
            children: []
          },
          {
            id: '396',
            parentId: '385',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_396',
            name: '妇联',
            children: []
          },
          {
            id: '397',
            parentId: '385',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_397',
            name: '民主党派',
            children: []
          },
          {
            id: '398',
            parentId: '385',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_398',
            name: '工商联',
            children: []
          },
          {
            id: '399',
            parentId: '385',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_399',
            name: '残联',
            children: []
          },
          {
            id: '400',
            parentId: '385',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_400',
            name: '其他群众性组织',
            children: []
          }
        ]
      },
      {
        id: '386',
        parentId: '378',
        petitionVal: '',
        sortValue: '4',
        code: 'depttype_386',
        name: '事业单位',
        children: [{
            id: '401',
            parentId: '386',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_401',
            name: '中央或国务院直属',
            children: []
          },
          {
            id: '402',
            parentId: '386',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_402',
            name: '非中央或国务院直属',
            children: []
          }
        ]
      },
      {
        id: '387',
        parentId: '378',
        petitionVal: '',
        sortValue: '3',
        code: 'depttype_387',
        name: '企业单位',
        children: []
      },
      {
        id: '388',
        parentId: '378',
        petitionVal: '',
        sortValue: '2',
        code: 'depttype_388',
        name: '农村',
        children: [{
            id: '403',
            parentId: '388',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_403',
            name: '村支书村主任',
            children: []
          },
          {
            id: '404',
            parentId: '388',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_404',
            name: '其他村组干部',
            children: []
          },
          {
            id: '405',
            parentId: '388',
            petitionVal: '',
            sortValue: '',
            code: 'depttype_405',
            name: '其他党员干部',
            children: []
          }
        ]
      },
      {
        id: '389',
        parentId: '378',
        petitionVal: '',
        sortValue: '1',
        code: 'depttype_389',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '406',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'depttypenew',
    name: '部门分类二',
    children: [{
        id: '407',
        parentId: '406',
        petitionVal: '',
        sortValue: '29',
        code: 'depttypenew_407',
        name: '教育',
        children: []
      },
      {
        id: '408',
        parentId: '406',
        petitionVal: '',
        sortValue: '28',
        code: 'depttypenew_408',
        name: '财政',
        children: []
      },
      {
        id: '409',
        parentId: '406',
        petitionVal: '',
        sortValue: '27',
        code: 'depttypenew_409',
        name: '司法',
        children: []
      },
      {
        id: '410',
        parentId: '406',
        petitionVal: '',
        sortValue: '26',
        code: 'depttypenew_410',
        name: '人力资源和社会保障',
        children: []
      },
      {
        id: '411',
        parentId: '406',
        petitionVal: '',
        sortValue: '25',
        code: 'depttypenew_411',
        name: '文化',
        children: []
      },
      {
        id: '412',
        parentId: '406',
        petitionVal: '',
        sortValue: '24',
        code: 'depttypenew_412',
        name: '科技',
        children: []
      },
      {
        id: '413',
        parentId: '406',
        petitionVal: '',
        sortValue: '23',
        code: 'depttypenew_413',
        name: '国土资源',
        children: []
      },
      {
        id: '414',
        parentId: '406',
        petitionVal: '',
        sortValue: '22',
        code: 'depttypenew_414',
        name: '建设',
        children: []
      },
      {
        id: '415',
        parentId: '406',
        petitionVal: '',
        sortValue: '21',
        code: 'depttypenew_415',
        name: '交通',
        children: []
      },
      {
        id: '416',
        parentId: '406',
        petitionVal: '',
        sortValue: '20',
        code: 'depttypenew_416',
        name: '信息产业',
        children: []
      },
      {
        id: '417',
        parentId: '406',
        petitionVal: '',
        sortValue: '19',
        code: 'depttypenew_417',
        name: '卫生',
        children: []
      },
      {
        id: '418',
        parentId: '406',
        petitionVal: '',
        sortValue: '18',
        code: 'depttypenew_418',
        name: '食品药品监督',
        children: []
      },
      {
        id: '419',
        parentId: '406',
        petitionVal: '',
        sortValue: '17',
        code: 'depttypenew_419',
        name: '环保',
        children: []
      },
      {
        id: '420',
        parentId: '406',
        petitionVal: '',
        sortValue: '16',
        code: 'depttypenew_420',
        name: '税务',
        children: []
      },
      {
        id: '421',
        parentId: '406',
        petitionVal: '',
        sortValue: '15',
        code: 'depttypenew_421',
        name: '工商',
        children: []
      },
      {
        id: '422',
        parentId: '406',
        petitionVal: '',
        sortValue: '14',
        code: 'depttypenew_422',
        name: '安监',
        children: []
      },
      {
        id: '423',
        parentId: '406',
        petitionVal: '',
        sortValue: '13',
        code: 'depttypenew_423',
        name: '公安',
        children: []
      },
      {
        id: '424',
        parentId: '406',
        petitionVal: '',
        sortValue: '12',
        code: 'depttypenew_424',
        name: '民政',
        children: []
      },
      {
        id: '425',
        parentId: '406',
        petitionVal: '',
        sortValue: '11',
        code: 'depttypenew_425',
        name: '统计',
        children: []
      },
      {
        id: '426',
        parentId: '406',
        petitionVal: '',
        sortValue: '10',
        code: 'depttypenew_426',
        name: '审计',
        children: []
      },
      {
        id: '427',
        parentId: '406',
        petitionVal: '',
        sortValue: '9',
        code: 'depttypenew_427',
        name: '旅游',
        children: []
      },
      {
        id: '428',
        parentId: '406',
        petitionVal: '',
        sortValue: '8',
        code: 'depttypenew_428',
        name: '地质',
        children: []
      },
      {
        id: '429',
        parentId: '406',
        petitionVal: '',
        sortValue: '7',
        code: 'depttypenew_429',
        name: '能源',
        children: []
      },
      {
        id: '430',
        parentId: '406',
        petitionVal: '',
        sortValue: '6',
        code: 'depttypenew_430',
        name: '经贸',
        children: []
      },
      {
        id: '431',
        parentId: '406',
        petitionVal: '',
        sortValue: '5',
        code: 'depttypenew_431',
        name: '金融',
        children: []
      },
      {
        id: '432',
        parentId: '406',
        petitionVal: '',
        sortValue: '4',
        code: 'depttypenew_432',
        name: '体育',
        children: []
      },
      {
        id: '433',
        parentId: '406',
        petitionVal: '',
        sortValue: '3',
        code: 'depttypenew_433',
        name: '水利',
        children: []
      },
      {
        id: '434',
        parentId: '406',
        petitionVal: '',
        sortValue: '2',
        code: 'depttypenew_434',
        name: '海关',
        children: []
      },
      {
        id: '435',
        parentId: '406',
        petitionVal: '',
        sortValue: '1',
        code: 'depttypenew_435',
        name: '代理服务',
        children: []
      }
    ]
  },
  {
    id: '436',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'deptowner',
    name: '企业性质',
    children: [{
        id: '437',
        parentId: '436',
        petitionVal: '',
        sortValue: '5',
        code: 'deptowner_437',
        name: '国有或国有控股企业',
        children: [{
            id: '442',
            parentId: '437',
            petitionVal: '',
            sortValue: '',
            code: 'deptowner_442',
            name: '中央管理正职企业',
            children: []
          },
          {
            id: '443',
            parentId: '437',
            petitionVal: '',
            sortValue: '',
            code: 'deptowner_443',
            name: '国务院国资委管理正职企业',
            children: []
          },
          {
            id: '444',
            parentId: '437',
            petitionVal: '',
            sortValue: '',
            code: 'deptowner_444',
            name: '省委管理正职企业',
            children: []
          },
          {
            id: '445',
            parentId: '437',
            petitionVal: '',
            sortValue: '',
            code: 'deptowner_445',
            name: '省国资委管理正职企业',
            children: []
          },
          {
            id: '446',
            parentId: '437',
            petitionVal: '',
            sortValue: '',
            code: 'deptowner_446',
            name: '市委管理正职企业',
            children: []
          },
          {
            id: '447',
            parentId: '437',
            petitionVal: '',
            sortValue: '',
            code: 'deptowner_447',
            name: '市国资委管理正职企业',
            children: []
          },
          {
            id: '448',
            parentId: '437',
            petitionVal: '',
            sortValue: '',
            code: 'deptowner_448',
            name: '中央金融机构',
            children: []
          },
          {
            id: '449',
            parentId: '437',
            petitionVal: '',
            sortValue: '',
            code: 'deptowner_449',
            name: '其他',
            children: []
          }
        ]
      },
      {
        id: '438',
        parentId: '436',
        petitionVal: '',
        sortValue: '4',
        code: 'deptowner_438',
        name: '集体企业',
        children: []
      },
      {
        id: '439',
        parentId: '436',
        petitionVal: '',
        sortValue: '3',
        code: 'deptowner_439',
        name: '私营企业',
        children: []
      },
      {
        id: '440',
        parentId: '436',
        petitionVal: '',
        sortValue: '2',
        code: 'deptowner_440',
        name: '其他内资企业',
        children: []
      },
      {
        id: '441',
        parentId: '436',
        petitionVal: '',
        sortValue: '1',
        code: 'deptowner_441',
        name: '外商及港澳台投资企业',
        children: []
      }
    ]
  },
  {
    id: '450',
    parentId: '',
    petitionVal: '3',
    sortValue: '',
    code: 'ranktype',
    name: '企业人员类别',
    children: [{
        id: '451',
        parentId: '450',
        petitionVal: '2',
        sortValue: '3',
        code: 'ranktype_451',
        name: '企业领导人员',
        children: [{
            id: '454',
            parentId: '451',
            petitionVal: '',
            sortValue: '',
            code: 'ranktype_454',
            name: '中管干部',
            children: []
          },
          {
            id: '455',
            parentId: '451',
            petitionVal: '',
            sortValue: '',
            code: 'ranktype_455',
            name: '省管干部',
            children: []
          },
          {
            id: '456',
            parentId: '451',
            petitionVal: '',
            sortValue: '',
            code: 'ranktype_456',
            name: '市管干部',
            children: []
          },
          {
            id: '457',
            parentId: '451',
            petitionVal: '',
            sortValue: '',
            code: 'ranktype_457',
            name: '县管干部',
            children: []
          }
        ]
      },
      {
        id: '452',
        parentId: '450',
        petitionVal: '4',
        sortValue: '2',
        code: 'ranktype_452',
        name: '中层管理人员',
        children: []
      },
      {
        id: '453',
        parentId: '450',
        petitionVal: '9',
        sortValue: '1',
        code: 'ranktype_453',
        name: '其他人员',
        children: []
      }
    ]
  },
  {
    id: '458',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'partypunis',
    name: '党纪处分',
    children: [{
        id: '463',
        parentId: '458',
        petitionVal: '',
        sortValue: '5',
        code: 'partypunis_463',
        name: '开除党籍',
        children: []
      },
      {
        id: '462',
        parentId: '458',
        petitionVal: '',
        sortValue: '4',
        code: 'partypunis_462',
        name: '留党察看',
        children: []
      },
      {
        id: '461',
        parentId: '458',
        petitionVal: '',
        sortValue: '3',
        code: 'partypunis_461',
        name: '撤销党内职务',
        children: []
      },
      {
        id: '460',
        parentId: '458',
        petitionVal: '',
        sortValue: '2',
        code: 'partypunis_460',
        name: '严重警告',
        children: []
      },
      {
        id: '459',
        parentId: '458',
        petitionVal: '',
        sortValue: '1',
        code: 'partypunis_459',
        name: '警告',
        children: []
      }
    ]
  },
  {
    id: '464',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'adminpunis',
    name: '政纪处分',
    children: [{
        id: '472',
        parentId: '464',
        petitionVal: '',
        sortValue: '8',
        code: 'adminpunis_472',
        name: '开除',
        children: []
      },
      {
        id: '471',
        parentId: '464',
        petitionVal: '',
        sortValue: '7',
        code: 'adminpunis_471',
        name: '留用察看',
        children: []
      },
      {
        id: '470',
        parentId: '464',
        petitionVal: '',
        sortValue: '6',
        code: 'adminpunis_470',
        name: '撤职',
        children: []
      },
      {
        id: '469',
        parentId: '464',
        petitionVal: '',
        sortValue: '5',
        code: 'adminpunis_469',
        name: '降职',
        children: []
      },
      {
        id: '468',
        parentId: '464',
        petitionVal: '',
        sortValue: '4',
        code: 'adminpunis_468',
        name: '降级',
        children: []
      },
      {
        id: '467',
        parentId: '464',
        petitionVal: '',
        sortValue: '3',
        code: 'adminpunis_467',
        name: '记大过',
        children: []
      },
      {
        id: '466',
        parentId: '464',
        petitionVal: '',
        sortValue: '2',
        code: 'adminpunis_466',
        name: '记过',
        children: []
      },
      {
        id: '465',
        parentId: '464',
        petitionVal: '',
        sortValue: '1',
        code: 'adminpunis_465',
        name: '警告',
        children: []
      }
    ]
  },
  {
    id: '473',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'rebukeresu',
    name: '申诉结论',
    children: [{
        id: '474',
        parentId: '473',
        petitionVal: '',
        sortValue: '4',
        code: 'rebukeresu_474',
        name: '维持',
        children: []
      },
      {
        id: '475',
        parentId: '473',
        petitionVal: '',
        sortValue: '3',
        code: 'rebukeresu_475',
        name: '变更',
        children: []
      },
      {
        id: '476',
        parentId: '473',
        petitionVal: '',
        sortValue: '2',
        code: 'rebukeresu_476',
        name: '撤销',
        children: []
      },
      {
        id: '477',
        parentId: '473',
        petitionVal: '',
        sortValue: '1',
        code: 'rebukeresu_477',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '478',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'rebukemode',
    name: '申诉类别',
    children: [{
        id: '479',
        parentId: '478',
        petitionVal: '',
        sortValue: '4',
        code: 'rebukemode_479',
        name: '党纪申诉',
        children: []
      },
      {
        id: '480',
        parentId: '478',
        petitionVal: '',
        sortValue: '3',
        code: 'rebukemode_480',
        name: '政纪申诉',
        children: []
      },
      {
        id: '481',
        parentId: '478',
        petitionVal: '',
        sortValue: '2',
        code: 'rebukemode_481',
        name: '双重申诉',
        children: []
      },
      {
        id: '482',
        parentId: '478',
        petitionVal: '',
        sortValue: '1',
        code: 'rebukemode_482',
        name: '其他申诉',
        children: []
      }
    ]
  },
  {
    id: '483',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'source',
    name: '线索来源',
    children: [{
        id: '484',
        parentId: '483',
        petitionVal: '',
        sortValue: '8',
        code: 'source_484',
        name: '信访举报',
        children: [{
            id: '492',
            parentId: '484',
            petitionVal: '1',
            sortValue: '',
            code: 'report_type_492',
            name: '实名举报',
            children: [{
                id: '494',
                parentId: '492',
                petitionVal: '1',
                sortValue: '',
                code: 'report method_real_494',
                name: '来信',
                children: []
              },
              {
                id: '495',
                parentId: '492',
                petitionVal: '3',
                sortValue: '',
                code: 'report method_real_495',
                name: '来电',
                children: []
              },
              {
                id: '496',
                parentId: '492',
                petitionVal: '2',
                sortValue: '',
                code: 'report method_real_496',
                name: '来访',
                children: []
              },
              {
                id: '497',
                parentId: '492',
                petitionVal: '4',
                sortValue: '',
                code: 'report method_real_497',
                name: '网络举报',
                children: []
              },
              {
                id: '498',
                parentId: '492',
                petitionVal: '9',
                sortValue: '',
                code: 'report method_real_498',
                name: '其他',
                children: []
              }
            ]
          },
          {
            id: '493',
            parentId: '484',
            petitionVal: '2',
            sortValue: '',
            code: 'report_type_493',
            name: '匿名举报',
            children: [{
                id: '499',
                parentId: '493',
                petitionVal: '1',
                sortValue: '',
                code: 'report method_anonymous_499',
                name: '来信',
                children: []
              },
              {
                id: '500',
                parentId: '493',
                petitionVal: '3',
                sortValue: '',
                code: 'report method_anonymous_500',
                name: '来电',
                children: []
              },
              {
                id: '501',
                parentId: '493',
                petitionVal: '2',
                sortValue: '',
                code: 'report method_anonymous_501',
                name: '来访',
                children: []
              },
              {
                id: '502',
                parentId: '493',
                petitionVal: '4',
                sortValue: '',
                code: 'report method_anonymous_502',
                name: '网络举报',
                children: []
              },
              {
                id: '503',
                parentId: '493',
                petitionVal: '5',
                sortValue: '',
                code: 'report method_anonymous_503',
                name: '其他',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '485',
        parentId: '483',
        petitionVal: '',
        sortValue: '7',
        code: 'source_485',
        name: '上级交办',
        children: []
      },
      {
        id: '486',
        parentId: '483',
        petitionVal: '',
        sortValue: '6',
        code: 'source_486',
        name: '公检法等机关移送',
        children: []
      },
      {
        id: '487',
        parentId: '483',
        petitionVal: '',
        sortValue: '5',
        code: 'source_487',
        name: '监督检查中发现',
        children: []
      },
      {
        id: '488',
        parentId: '483',
        petitionVal: '',
        sortValue: '4',
        code: 'source_488',
        name: '纪律审查中发现',
        children: []
      },
      {
        id: '489',
        parentId: '483',
        petitionVal: '',
        sortValue: '3',
        code: 'source_489',
        name: '审计中发现',
        children: []
      },
      {
        id: '490',
        parentId: '483',
        petitionVal: '',
        sortValue: '2',
        code: 'source_490',
        name: '巡视中发现',
        children: []
      },
      { id: '491', parentId: '483', petitionVal: '', sortValue: '1', code: 'source_491', name: '其他', children: [] }
    ]
  },
  {
    id: '504',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'rerebcreas',
    name: '变更、撤消理由',
    children: [{
        id: '505',
        parentId: '504',
        petitionVal: '',
        sortValue: '5',
        code: 'rerebcreas_505',
        name: '事实不符',
        children: []
      },
      {
        id: '506',
        parentId: '504',
        petitionVal: '',
        sortValue: '4',
        code: 'rerebcreas_506',
        name: '证据不足',
        children: []
      },
      {
        id: '507',
        parentId: '504',
        petitionVal: '',
        sortValue: '3',
        code: 'rerebcreas_507',
        name: '定性不准',
        children: []
      },
      {
        id: '508',
        parentId: '504',
        petitionVal: '',
        sortValue: '2',
        code: 'rerebcreas_508',
        name: '处分不当',
        children: []
      },
      {
        id: '509',
        parentId: '504',
        petitionVal: '',
        sortValue: '1',
        code: 'rerebcreas_509',
        name: '违反程序',
        children: []
      }
    ]
  },
  {
    id: '510',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'lgplacetype',
    name: '采取措施地点分类',
    children: [{
        id: '511',
        parentId: '510',
        petitionVal: '',
        sortValue: '4',
        code: 'lgplacetype_511',
        name: '自建办案点',
        children: []
      },
      {
        id: '512',
        parentId: '510',
        petitionVal: '',
        sortValue: '3',
        code: 'lgplacetype_512',
        name: '租用宾馆',
        children: []
      },
      {
        id: '513',
        parentId: '510',
        petitionVal: '',
        sortValue: '2',
        code: 'lgplacetype_513',
        name: '使用上级纪检机关办案点',
        children: []
      },
      {
        id: '514',
        parentId: '510',
        petitionVal: '',
        sortValue: '1',
        code: 'lgplacetype_514',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '515',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'sfcl',
    name: '公检法等机关处理',
    children: [{
        id: '516',
        parentId: '515',
        petitionVal: '',
        sortValue: '2',
        code: 'sfcl_516',
        name: '刑事处理',
        children: [{
            id: '518',
            parentId: '516',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_518',
            name: '死刑立即执行',
            children: []
          },
          {
            id: '519',
            parentId: '516',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_519',
            name: '死刑缓期执行',
            children: []
          },
          {
            id: '520',
            parentId: '516',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_520',
            name: '无期徒刑',
            children: []
          },
          {
            id: '521',
            parentId: '516',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_521',
            name: '有期徒刑',
            children: []
          },
          {
            id: '522',
            parentId: '516',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_522',
            name: '管制',
            children: []
          },
          {
            id: '523',
            parentId: '516',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_523',
            name: '拘役',
            children: []
          },
          {
            id: '524',
            parentId: '516',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_524',
            name: '罚金',
            children: []
          },
          {
            id: '525',
            parentId: '516',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_525',
            name: '剥夺政治权利',
            children: []
          },
          {
            id: '526',
            parentId: '516',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_526',
            name: '没收财产',
            children: []
          }
        ]
      },
      {
        id: '517',
        parentId: '515',
        petitionVal: '',
        sortValue: '1',
        code: 'sfcl_517',
        name: '其他处罚',
        children: [{
            id: '527',
            parentId: '517',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_527',
            name: '不起诉',
            children: []
          },
          {
            id: '528',
            parentId: '517',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_528',
            name: '免予刑事处罚',
            children: []
          },
          {
            id: '529',
            parentId: '517',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_529',
            name: '行政拘留',
            children: []
          },
          {
            id: '530',
            parentId: '517',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_530',
            name: '劳动教养',
            children: []
          },
          {
            id: '531',
            parentId: '517',
            petitionVal: '',
            sortValue: '',
            code: 'sfcl_531',
            name: '其他',
            children: []
          }
        ]
      }
    ]
  },
  {
    id: '532',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'verifyresu',
    name: '核实结果',
    children: [{
        id: '533',
        parentId: '532',
        petitionVal: '',
        sortValue: '3',
        code: 'verifyresu_533',
        name: '转本级立案',
        children: []
      },
      {
        id: '534',
        parentId: '532',
        petitionVal: '',
        sortValue: '2',
        code: 'verifyresu_534',
        name: '了结',
        children: []
      },
      {
        id: '535',
        parentId: '532',
        petitionVal: '',
        sortValue: '1',
        code: 'verifyresu_535',
        name: '转下级立案',
        children: []
      }
    ]
  },
  {
    id: '536',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'censorate',
    name: '联合办案',
    children: [{
        id: '537',
        parentId: '536',
        petitionVal: '',
        sortValue: '3',
        code: 'censorate_537',
        name: '检察院',
        children: []
      },
      {
        id: '538',
        parentId: '536',
        petitionVal: '',
        sortValue: '2',
        code: 'censorate_538',
        name: '公安',
        children: []
      },
      {
        id: '539',
        parentId: '536',
        petitionVal: '',
        sortValue: '1',
        code: 'censorate_539',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '540',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'conclusion',
    name: '了结结论',
    children: [{
        id: '863',
        parentId: '540',
        petitionVal: '',
        sortValue: '3',
        code: 'conclusion_863',
        name: '查无实据',
        children: []
      },
      {
        id: '541',
        parentId: '540',
        petitionVal: '',
        sortValue: '2',
        code: 'conclusion_541',
        name: '失实',
        children: []
      },
      {
        id: '542',
        parentId: '540',
        petitionVal: '',
        sortValue: '1',
        code: 'conclusion_542',
        name: '适当处理',
        children: []
      }
    ]
  },
  {
    id: '543',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'phcondition',
    name: '陪护人员情况',
    children: [{
        id: '544',
        parentId: '543',
        petitionVal: '',
        sortValue: '3',
        code: 'phcondition_544',
        name: '武警',
        children: []
      },
      {
        id: '545',
        parentId: '543',
        petitionVal: '',
        sortValue: '2',
        code: 'phcondition_545',
        name: '党和国家机关工作人员',
        children: []
      },
      {
        id: '546',
        parentId: '543',
        petitionVal: '',
        sortValue: '1',
        code: 'phcondition_546',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '547',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'punishment',
    name: '其他处罚',
    children: [{
        id: '548',
        parentId: '547',
        petitionVal: '',
        sortValue: '5',
        code: 'punishment_548',
        name: '不起诉',
        children: []
      },
      {
        id: '549',
        parentId: '547',
        petitionVal: '',
        sortValue: '4',
        code: 'punishment_549',
        name: '免予刑事处罚',
        children: []
      },
      {
        id: '550',
        parentId: '547',
        petitionVal: '',
        sortValue: '3',
        code: 'punishment_550',
        name: '行政拘留',
        children: []
      },
      {
        id: '552',
        parentId: '547',
        petitionVal: '',
        sortValue: '1',
        code: 'punishment_552',
        name: '其它行政处罚',
        children: []
      }
    ]
  },
  {
    id: '553',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'othertreat',
    name: '其他处理',
    children: [{
        id: '554',
        parentId: '553',
        petitionVal: '',
        sortValue: '6',
        code: 'othertreat_554',
        name: '免予党纪处分',
        children: []
      },
      {
        id: '555',
        parentId: '553',
        petitionVal: '',
        sortValue: '5',
        code: 'othertreat_555',
        name: '免予政纪处分',
        children: []
      },
      {
        id: '556',
        parentId: '553',
        petitionVal: '',
        sortValue: '4',
        code: 'othertreat_556',
        name: '不予处分',
        children: []
      },
      {
        id: '557',
        parentId: '553',
        petitionVal: '',
        sortValue: '3',
        code: 'othertreat_557',
        name: '改组党组织',
        children: []
      },
      {
        id: '558',
        parentId: '553',
        petitionVal: '',
        sortValue: '2',
        code: 'othertreat_558',
        name: '解散党组织',
        children: []
      },
      {
        id: '559',
        parentId: '553',
        petitionVal: '',
        sortValue: '1',
        code: 'othertreat_559',
        name: '处分有关人员',
        children: []
      }
    ]
  },
  {
    id: '560',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'othertrea2',
    name: '其他处理二',
    children: [{
        id: '564',
        parentId: '560',
        petitionVal: '',
        sortValue: '33',
        code: 'othertrea2_564',
        name: '调整职务(岗位)',
        children: []
      },
      {
        id: '565',
        parentId: '560',
        petitionVal: '',
        sortValue: '32',
        code: 'othertrea2_565',
        name: '免职',
        children: []
      },
      {
        id: '573',
        parentId: '560',
        petitionVal: '',
        sortValue: '31',
        code: 'othertrea2_573',
        name: '降职',
        children: []
      },
      {
        id: '568',
        parentId: '560',
        petitionVal: '',
        sortValue: '30',
        code: 'othertrea2_568',
        name: '停职（检查）',
        children: []
      },
      {
        id: '570',
        parentId: '560',
        petitionVal: '',
        sortValue: '29',
        code: 'othertrea2_570',
        name: '引咎辞职',
        children: []
      },
      {
        id: '571',
        parentId: '560',
        petitionVal: '',
        sortValue: '28',
        code: 'othertrea2_571',
        name: '责令辞职',
        children: []
      },
      {
        id: '562',
        parentId: '560',
        petitionVal: '',
        sortValue: '27',
        code: 'othertrea2_562',
        name: '解聘',
        children: []
      },
      {
        id: '563',
        parentId: '560',
        petitionVal: '',
        sortValue: '26',
        code: 'othertrea2_563',
        name: '辞退',
        children: []
      },
      {
        id: '1263',
        parentId: '560',
        petitionVal: '',
        sortValue: '25',
        code: 'othertrea2_1263',
        name: '留用察看',
        children: []
      },
      {
        id: '574',
        parentId: '560',
        petitionVal: '',
        sortValue: '24',
        code: 'othertrea2_574',
        name: '终止党代表资格',
        children: []
      },
      {
        id: '575',
        parentId: '560',
        petitionVal: '',
        sortValue: '23',
        code: 'othertrea2_575',
        name: '终止人大代表资格',
        children: []
      },
      {
        id: '1250',
        parentId: '560',
        petitionVal: '',
        sortValue: '22',
        code: 'othertrea2_1250',
        name: '撤销政协委员资格',
        children: []
      },
      {
        id: '566',
        parentId: '560',
        petitionVal: '',
        sortValue: '21',
        code: 'othertrea2_566',
        name: '取消预备党员资格',
        children: []
      },
      {
        id: '1251',
        parentId: '560',
        petitionVal: '',
        sortValue: '20',
        code: 'othertrea2_1251',
        name: '取消当选资格(罢免)',
        children: []
      },
      {
        id: '1253',
        parentId: '560',
        petitionVal: '',
        sortValue: '19',
        code: 'othertrea2_1253',
        name: '改任非领导职务',
        children: []
      },
      {
        id: '1252',
        parentId: '560',
        petitionVal: '',
        sortValue: '18',
        code: 'othertrea2_1252',
        name: '安排提前退休',
        children: []
      },
      {
        id: '1264',
        parentId: '560',
        petitionVal: '',
        sortValue: '17',
        code: 'othertrea2_1264',
        name: '组织除名（劝退）',
        children: []
      },
      {
        id: '1265',
        parentId: '560',
        petitionVal: '',
        sortValue: '16',
        code: 'othertrea2_1265',
        name: '停止党籍',
        children: []
      },
      {
        id: '1266',
        parentId: '560',
        petitionVal: '',
        sortValue: '15',
        code: 'othertrea2_1266',
        name: '解除劳动合同',
        children: []
      },
      {
        id: '1267',
        parentId: '560',
        petitionVal: '',
        sortValue: '14',
        code: 'othertrea2_1267',
        name: '取消退休待遇（降低）',
        children: []
      },
      {
        id: '1262',
        parentId: '560',
        petitionVal: '',
        sortValue: '13',
        code: 'othertrea2_1262',
        name: '取消名誉称号',
        children: []
      },
      {
        id: '561',
        parentId: '560',
        petitionVal: '',
        sortValue: '12',
        code: 'othertrea2_561',
        name: '通报批评',
        children: []
      },
      {
        id: '569',
        parentId: '560',
        petitionVal: '',
        sortValue: '11',
        code: 'othertrea2_569',
        name: '责令公开道歉（检讨）',
        children: []
      },
      {
        id: '1254',
        parentId: '560',
        petitionVal: '',
        sortValue: '10',
        code: 'othertrea2_1254',
        name: '纠正或责令停止违纪行为',
        children: []
      },
      {
        id: '1255',
        parentId: '560',
        petitionVal: '',
        sortValue: '9',
        code: 'othertrea2_1255',
        name: '责成退出违纪所得',
        children: []
      },
      {
        id: '1256',
        parentId: '560',
        petitionVal: '',
        sortValue: '8',
        code: 'othertrea2_1256',
        name: '批评教育',
        children: []
      },
      {
        id: '1257',
        parentId: '560',
        petitionVal: '',
        sortValue: '7',
        code: 'othertrea2_1257',
        name: '提醒谈话',
        children: []
      },
      {
        id: '567',
        parentId: '560',
        petitionVal: '',
        sortValue: '6',
        code: 'othertrea2_567',
        name: '诫勉谈话',
        children: []
      },
      {
        id: '1258',
        parentId: '560',
        petitionVal: '',
        sortValue: '5',
        code: 'othertrea2_1258',
        name: '警示谈话',
        children: []
      },
      {
        id: '1259',
        parentId: '560',
        petitionVal: '',
        sortValue: '4',
        code: 'othertrea2_1259',
        name: '召开民主生活会批评帮助',
        children: []
      },
      {
        id: '1260',
        parentId: '560',
        petitionVal: '',
        sortValue: '3',
        code: 'othertrea2_1260',
        name: '责令作出口头或书面检查',
        children: []
      },
      {
        id: '1261',
        parentId: '560',
        petitionVal: '',
        sortValue: '2',
        code: 'othertrea2_1261',
        name: '限期整改',
        children: []
      },
      {
        id: '572',
        parentId: '560',
        petitionVal: '',
        sortValue: '1',
        code: 'othertrea2_572',
        name: '其他组织处理',
        children: []
      }
    ]
  },
  {
    id: '576',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'lgtype',
    name: '使用措施',
    children: [
      { id: '577', parentId: '576', petitionVal: '', sortValue: '2', code: 'lgtype_577', name: '两规', children: [] },
      { id: '578', parentId: '576', petitionVal: '', sortValue: '1', code: 'lgtype_578', name: '两指', children: [] }
    ]
  },
  {
    id: '579',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'waca',
    name: '窝案串案',
    children: [
      { id: '580', parentId: '579', petitionVal: '', sortValue: '2', code: 'waca_580', name: '窝案', children: [] },
      { id: '581', parentId: '579', petitionVal: '', sortValue: '1', code: 'waca_581', name: '串案', children: [] }
    ]
  },
  {
    id: '582',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'wadetail',
    name: '窝案细节',
    children: [{
        id: '583',
        parentId: '582',
        petitionVal: '',
        sortValue: '2',
        code: 'wadetail_583',
        name: '主要涉案人',
        children: []
      },
      {
        id: '584',
        parentId: '582',
        petitionVal: '',
        sortValue: '1',
        code: 'wadetail_584',
        name: '次要涉案人',
        children: []
      }
    ]
  },
  {
    id: '585',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'handledept',
    name: '受理机关',
    children: [{
        id: '586',
        parentId: '585',
        petitionVal: '',
        sortValue: '13',
        code: 'handledept_586',
        name: '中央纪委监察部',
        children: []
      },
      {
        id: '587',
        parentId: '585',
        petitionVal: '',
        sortValue: '12',
        code: 'handledept_587',
        name: '省区市纪委监察厅局',
        children: []
      },
      {
        id: '588',
        parentId: '585',
        petitionVal: '',
        sortValue: '11',
        code: 'handledept_588',
        name: '地市州纪委监察局',
        children: []
      },
      {
        id: '589',
        parentId: '585',
        petitionVal: '',
        sortValue: '10',
        code: 'handledept_589',
        name: '县市区纪委监察局',
        children: []
      },
      {
        id: '590',
        parentId: '585',
        petitionVal: '',
        sortValue: '9',
        code: 'handledept_590',
        name: '乡镇纪委',
        children: []
      },
      {
        id: '591',
        parentId: '585',
        petitionVal: '',
        sortValue: '8',
        code: 'handledept_591',
        name: '军队纪委',
        children: []
      },
      {
        id: '592',
        parentId: '585',
        petitionVal: '',
        sortValue: '7',
        code: 'handledept_592',
        name: '中央纪委派驻纪检组',
        children: []
      },
      {
        id: '593',
        parentId: '585',
        petitionVal: '',
        sortValue: '6',
        code: 'handledept_593',
        name: '省区市纪委派驻纪检组',
        children: []
      },
      {
        id: '594',
        parentId: '585',
        petitionVal: '',
        sortValue: '5',
        code: 'handledept_594',
        name: '地市州纪委派驻纪检组',
        children: []
      },
      {
        id: '595',
        parentId: '585',
        petitionVal: '',
        sortValue: '4',
        code: 'handledept_595',
        name: '县市区纪委派驻纪检组',
        children: []
      },
      {
        id: '596',
        parentId: '585',
        petitionVal: '',
        sortValue: '3',
        code: 'handledept_596',
        name: '企业单位纪检监察机构',
        children: []
      },
      {
        id: '597',
        parentId: '585',
        petitionVal: '',
        sortValue: '2',
        code: 'handledept_597',
        name: '事业单位纪检监察机构',
        children: []
      },
      {
        id: '598',
        parentId: '585',
        petitionVal: '',
        sortValue: '1',
        code: 'handledept_598',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '599',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'beleader',
    name: '一把手违纪',
    children: [{
        id: '600',
        parentId: '599',
        petitionVal: '1',
        sortValue: '3',
        code: 'beleader_600',
        name: '查处时任一把手',
        children: []
      },
      {
        id: '601',
        parentId: '599',
        petitionVal: '0',
        sortValue: '2',
        code: 'beleader_601',
        name: '违纪时任一把手',
        children: []
      },
      {
        id: '602',
        parentId: '599',
        petitionVal: '0',
        sortValue: '1',
        code: 'beleader_602',
        name: '查处时违纪时均任一把手',
        children: []
      }
    ]
  },
  {
    id: '603',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'leaderdetail',
    name: '一把手细节',
    children: [{
        id: '604',
        parentId: '603',
        petitionVal: '',
        sortValue: '5',
        code: 'leaderdetail_604',
        name: '中央',
        children: []
      },
      {
        id: '605',
        parentId: '603',
        petitionVal: '',
        sortValue: '4',
        code: 'leaderdetail_605',
        name: '省区市',
        children: []
      },
      {
        id: '606',
        parentId: '603',
        petitionVal: '',
        sortValue: '3',
        code: 'leaderdetail_606',
        name: '地市州',
        children: []
      },
      {
        id: '607',
        parentId: '603',
        petitionVal: '',
        sortValue: '2',
        code: 'leaderdetail_607',
        name: '县市区',
        children: []
      },
      {
        id: '608',
        parentId: '603',
        petitionVal: '',
        sortValue: '1',
        code: 'leaderdetail_608',
        name: '乡镇',
        children: []
      }
    ]
  },
  {
    id: '609',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'leaderdetail1',
    name: '一把手细节二',
    children: [{
        id: '610',
        parentId: '609',
        petitionVal: '',
        sortValue: '4',
        code: 'leaderdetail1_610',
        name: '党委',
        children: []
      },
      {
        id: '611',
        parentId: '609',
        petitionVal: '',
        sortValue: '3',
        code: 'leaderdetail1_611',
        name: '党委所属部委办局',
        children: []
      },
      {
        id: '612',
        parentId: '609',
        petitionVal: '',
        sortValue: '2',
        code: 'leaderdetail1_612',
        name: '政府',
        children: []
      },
      {
        id: '613',
        parentId: '609',
        petitionVal: '',
        sortValue: '1',
        code: 'leaderdetail1_613',
        name: '政府所属部委办局',
        children: []
      }
    ]
  },
  {
    id: '614',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'specstat',
    name: '专项统计',
    children: [{
        id: '615',
        parentId: '614',
        petitionVal: '',
        sortValue: '18',
        code: 'specstat_615',
        name: '商业贿赂',
        children: []
      },
      {
        id: '616',
        parentId: '614',
        petitionVal: '',
        sortValue: '17',
        code: 'specstat_616',
        name: '土地征用',
        children: []
      },
      {
        id: '617',
        parentId: '614',
        petitionVal: '',
        sortValue: '16',
        code: 'specstat_617',
        name: '房屋拆迁',
        children: []
      },
      {
        id: '618',
        parentId: '614',
        petitionVal: '',
        sortValue: '15',
        code: 'specstat_618',
        name: '企业改制、破产',
        children: []
      },
      {
        id: '619',
        parentId: '614',
        petitionVal: '',
        sortValue: '14',
        code: 'specstat_619',
        name: '买官卖官',
        children: []
      },
      {
        id: '620',
        parentId: '614',
        petitionVal: '',
        sortValue: '13',
        code: 'specstat_620',
        name: '拉票贿选',
        children: []
      },
      {
        id: '621',
        parentId: '614',
        petitionVal: '',
        sortValue: '12',
        code: 'specstat_621',
        name: '生活作风问题',
        children: []
      },
      {
        id: '622',
        parentId: '614',
        petitionVal: '',
        sortValue: '11',
        code: 'specstat_622',
        name: '官商勾结',
        children: []
      },
      {
        id: '623',
        parentId: '614',
        petitionVal: '',
        sortValue: '10',
        code: 'specstat_623',
        name: '工程建设领域',
        children: []
      },
      {
        id: '624',
        parentId: '614',
        petitionVal: '',
        sortValue: '9',
        code: 'specstat_624',
        name: '提出问责建议',
        children: []
      },
      {
        id: '625',
        parentId: '614',
        petitionVal: '',
        sortValue: '8',
        code: 'specstat_625',
        name: '设立小金库和使用小金库款项案件',
        children: []
      },
      {
        id: '626',
        parentId: '614',
        petitionVal: '',
        sortValue: '7',
        code: 'specstat_626',
        name: '重大责任事故涉及的失职渎职和背后的腐败问题',
        children: []
      },
      {
        id: '627',
        parentId: '614',
        petitionVal: '',
        sortValue: '6',
        code: 'specstat_627',
        name: '群体性事件涉及的失职渎职和背后的腐败问题',
        children: []
      },
      {
        id: '1289',
        parentId: '614',
        petitionVal: '',
        sortValue: '5',
        code: 'specstat_1289',
        name: '类别一',
        children: []
      },
      {
        id: '1290',
        parentId: '614',
        petitionVal: '',
        sortValue: '4',
        code: 'specstat_1290',
        name: '类别二',
        children: []
      },
      {
        id: '1291',
        parentId: '614',
        petitionVal: '',
        sortValue: '3',
        code: 'specstat_1291',
        name: '类别三',
        children: []
      },
      {
        id: '1292',
        parentId: '614',
        petitionVal: '',
        sortValue: '2',
        code: 'specstat_1292',
        name: '类别四',
        children: []
      },
      {
        id: '1293',
        parentId: '614',
        petitionVal: '',
        sortValue: '1',
        code: 'specstat_1293',
        name: '类别五',
        children: []
      }
    ]
  },
  {
    id: '628',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'integritypoint',
    name: '违反廉洁从政行为规范',
    children: [{
        id: '629',
        parentId: '628',
        petitionVal: '',
        sortValue: '8',
        code: 'integritypoint_629',
        name: '利用职权和职务上的影响谋取不正当利益',
        children: [{
            id: '637',
            parentId: '629',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_637',
            name: '索取接受或以借为名占用财物',
            children: []
          },
          {
            id: '638',
            parentId: '629',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_638',
            name: '接受可能影响公正执行公务的礼品宴请以及活动安排',
            children: []
          },
          {
            id: '639',
            parentId: '629',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_639',
            name: '在公务活动中接受礼金和各种有价证券支付凭证',
            children: []
          },
          {
            id: '640',
            parentId: '629',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_640',
            name: '以交易委托理财等形式谋取不正当利益',
            children: []
          },
          {
            id: '641',
            parentId: '629',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_641',
            name: '利用知悉或者掌握的内幕信息谋取利益',
            children: []
          },
          {
            id: '642',
            parentId: '629',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_642',
            name: '违规多占住房或者买卖保障性住房',
            children: []
          }
        ]
      },
      {
        id: '630',
        parentId: '628',
        petitionVal: '',
        sortValue: '7',
        code: 'integritypoint_630',
        name: '私自从事营利性活动',
        children: [{
            id: '643',
            parentId: '630',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_643',
            name: '个人或者借他人名义经商办企业',
            children: []
          },
          {
            id: '644',
            parentId: '630',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_644',
            name: '违规拥有非上市公司（企业）的股份或者证券',
            children: []
          },
          {
            id: '645',
            parentId: '630',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_645',
            name: '违规买卖股票或者进行其他证券投资',
            children: []
          },
          {
            id: '646',
            parentId: '630',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_646',
            name: '个人在国（境）外注册公司或者投资入股',
            children: []
          },
          {
            id: '647',
            parentId: '630',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_647',
            name: '违规兼职或者兼职取酬以及从事有偿中介活动',
            children: []
          },
          {
            id: '648',
            parentId: '630',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_648',
            name: '离职或者退休后违规从事营利性活动',
            children: []
          }
        ]
      },
      {
        id: '631',
        parentId: '628',
        petitionVal: '',
        sortValue: '6',
        code: 'integritypoint_631',
        name: '违反公共财物管理和使用的规定假公济私化公为私',
        children: [{
            id: '649',
            parentId: '631',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_649',
            name: '用公款报销或者支付应由个人负担的费用',
            children: []
          },
          {
            id: '650',
            parentId: '631',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_650',
            name: '违规借用公款公物或者将公款公物借给他人',
            children: []
          },
          {
            id: '651',
            parentId: '631',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_651',
            name: '私存私放公款',
            children: []
          },
          {
            id: '652',
            parentId: '631',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_652',
            name: '用公款旅游或者变相用公款旅游',
            children: []
          },
          {
            id: '653',
            parentId: '631',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_653',
            name: '用公款参与高消费娱乐健身活动和获取俱乐部会员资格',
            children: []
          },
          {
            id: '654',
            parentId: '631',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_654',
            name: '违规用公款购买商业保险缴纳住房公积金滥发津贴补贴奖金等',
            children: []
          },
          {
            id: '655',
            parentId: '631',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_655',
            name: '非法占有公共财物',
            children: []
          },
          {
            id: '656',
            parentId: '631',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_656',
            name: '挪用或者拆借公共资金或者其他财政资金',
            children: []
          }
        ]
      },
      {
        id: '632',
        parentId: '628',
        petitionVal: '',
        sortValue: '5',
        code: 'integritypoint_632',
        name: '违反规定选拔任用干部',
        children: [{
            id: '657',
            parentId: '632',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_657',
            name: '采取不正当手段为本人或者他人谋取职位',
            children: []
          },
          {
            id: '658',
            parentId: '632',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_658',
            name: '不按照规定程序推荐考察酝酿讨论决定任免干部',
            children: []
          },
          {
            id: '659',
            parentId: '632',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_659',
            name: '私自泄露民主推荐民主测评考察酝酿讨论决定干部等有关情况',
            children: []
          },
          {
            id: '660',
            parentId: '632',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_660',
            name: '在干部考察工作中隐瞒或者歪曲事实真相',
            children: []
          },
          {
            id: '661',
            parentId: '632',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_661',
            name: '在民主推荐民主测评组织考察和选举中搞拉票等非组织活动',
            children: []
          },
          {
            id: '662',
            parentId: '632',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_662',
            name: '利用职务便利私自干预下级或者原任职地区单位干部选拔任用工作',
            children: []
          },
          {
            id: '663',
            parentId: '632',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_663',
            name: '在工作调动机构变动时突击提拔调整干部',
            children: []
          },
          {
            id: '664',
            parentId: '632',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_664',
            name: '在干部选拔任用工作中封官许愿任人唯亲营私舞弊',
            children: []
          }
        ]
      },
      {
        id: '633',
        parentId: '628',
        petitionVal: '',
        sortValue: '4',
        code: 'integritypoint_633',
        name: '利用职权和职务上的影响为亲属及身边工作人员谋取利益',
        children: [{
            id: '665',
            parentId: '633',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_665',
            name: '要求或者指使提拔亲属及身边工作人员',
            children: []
          },
          {
            id: '666',
            parentId: '633',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_666',
            name: '用公款支付亲属学习等费用或为亲属索取资助',
            children: []
          },
          {
            id: '667',
            parentId: '633',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_667',
            name: '妨碍涉及亲属及身边工作人员案件的调查处理',
            children: []
          },
          {
            id: '668',
            parentId: '633',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_668',
            name: '利用职务之便为他人谋利其亲属以及其他特定关系人收受对方财物',
            children: []
          },
          {
            id: '669',
            parentId: '633',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_669',
            name: '默许纵容授意亲属及身边工作人员以本人名义谋取私利',
            children: []
          },
          {
            id: '670',
            parentId: '633',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_670',
            name: '为亲属或相互为对方亲属经商办企业提供便利条件',
            children: []
          },
          {
            id: '671',
            parentId: '633',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_671',
            name: '允许纵容亲属在本人管辖范围内违规从事经营活动等',
            children: []
          },
          {
            id: '672',
            parentId: '633',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_672',
            name: '允许纵容亲属在异地工商注册登记后到本人管辖范围内违规从事经营活动',
            children: []
          }
        ]
      },
      {
        id: '634',
        parentId: '628',
        petitionVal: '',
        sortValue: '3',
        code: 'integritypoint_634',
        name: '讲排场比阔气挥霍公款铺张浪费',
        children: [{
            id: '673',
            parentId: '634',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_673',
            name: '提供或者接受超标接待或者超标报销相关费用',
            children: []
          },
          {
            id: '674',
            parentId: '634',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_674',
            name: '违规兴建装修楼堂馆所或超标配备使用办公用房和办公用品',
            children: []
          },
          {
            id: '675',
            parentId: '634',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_675',
            name: '擅自用公款包租占用客房供个人使用',
            children: []
          },
          {
            id: '676',
            parentId: '634',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_676',
            name: '违规配备购买更换装饰或者使用小汽车',
            children: []
          },
          {
            id: '677',
            parentId: '634',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_677',
            name: '违规举办各类庆典活动',
            children: []
          }
        ]
      },
      {
        id: '635',
        parentId: '628',
        petitionVal: '',
        sortValue: '2',
        code: 'integritypoint_635',
        name: '干预和插手建设工程项目承发包等市场经济活动',
        children: [{
            id: '678',
            parentId: '635',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_678',
            name: '干预和插手建设工程项目承发包等市场经济活动',
            children: []
          },
          {
            id: '679',
            parentId: '635',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_679',
            name: '干预和插手国有企业重组改制等事项',
            children: []
          },
          {
            id: '680',
            parentId: '635',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_680',
            name: '干预和插手批办各类行政许可和资金借贷等事项',
            children: []
          },
          {
            id: '681',
            parentId: '635',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_681',
            name: '干预和插手经济纠纷',
            children: []
          },
          {
            id: '682',
            parentId: '635',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_682',
            name: '干预和插手农村集体三资使用分配承包租赁等事项',
            children: []
          }
        ]
      },
      {
        id: '636',
        parentId: '628',
        petitionVal: '',
        sortValue: '1',
        code: 'integritypoint_636',
        name: '脱离实际弄虚作假损害群众利益和党群干群关系',
        children: [{
            id: '683',
            parentId: '636',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_683',
            name: '搞形象工程和政绩工程',
            children: []
          },
          {
            id: '684',
            parentId: '636',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_684',
            name: '虚报工作业绩',
            children: []
          },
          {
            id: '685',
            parentId: '636',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_685',
            name: '大办婚丧喜庆事宜或者借机敛财',
            children: []
          },
          {
            id: '686',
            parentId: '636',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_686',
            name: '在社会保障等事项中优亲厚友显失公平',
            children: []
          },
          {
            id: '687',
            parentId: '636',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_687',
            name: '以不正当手段获取荣誉职称学历学位等利益',
            children: []
          },
          {
            id: '688',
            parentId: '636',
            petitionVal: '',
            sortValue: '',
            code: 'integritypoint_688',
            name: '从事有悖社会公德职业道德家庭美德的活动',
            children: []
          }
        ]
      }
    ]
  },
  {
    id: '689',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'enterpriserank',
    name: '企业级别',
    children: [{
        id: '690',
        parentId: '689',
        petitionVal: '',
        sortValue: '4',
        code: 'enterpriserank_690',
        name: '一级企业',
        children: []
      },
      {
        id: '691',
        parentId: '689',
        petitionVal: '',
        sortValue: '3',
        code: 'enterpriserank_691',
        name: '二级企业',
        children: []
      },
      {
        id: '692',
        parentId: '689',
        petitionVal: '',
        sortValue: '2',
        code: 'enterpriserank_692',
        name: '三级企业',
        children: []
      },
      {
        id: '693',
        parentId: '689',
        petitionVal: '',
        sortValue: '1',
        code: 'enterpriserank_693',
        name: '其他企业',
        children: []
      }
    ]
  },
  {
    id: '694',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'combriberyfield',
    name: '商业贿赂涉及领域',
    children: [{
        id: '695',
        parentId: '694',
        petitionVal: '',
        sortValue: '7',
        code: 'combriberyfield_695',
        name: '工程建设',
        children: []
      },
      {
        id: '696',
        parentId: '694',
        petitionVal: '',
        sortValue: '6',
        code: 'combriberyfield_696',
        name: '土地出让',
        children: []
      },
      {
        id: '697',
        parentId: '694',
        petitionVal: '',
        sortValue: '5',
        code: 'combriberyfield_697',
        name: '产权交易',
        children: []
      },
      {
        id: '698',
        parentId: '694',
        petitionVal: '',
        sortValue: '4',
        code: 'combriberyfield_698',
        name: '政府采购',
        children: []
      },
      {
        id: '699',
        parentId: '694',
        petitionVal: '',
        sortValue: '3',
        code: 'combriberyfield_699',
        name: '医药购销',
        children: []
      },
      {
        id: '700',
        parentId: '694',
        petitionVal: '',
        sortValue: '2',
        code: 'combriberyfield_700',
        name: '资源开发和经销',
        children: []
      },
      {
        id: '701',
        parentId: '694',
        petitionVal: '',
        sortValue: '1',
        code: 'combriberyfield_701',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '702',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'elopetrace',
    name: '潜逃去向',
    children: [{
        id: '703',
        parentId: '702',
        petitionVal: '',
        sortValue: '3',
        code: 'elopetrace_703',
        name: '国（境）内',
        children: []
      },
      {
        id: '704',
        parentId: '702',
        petitionVal: '',
        sortValue: '2',
        code: 'elopetrace_704',
        name: '国（境）外',
        children: []
      },
      {
        id: '705',
        parentId: '702',
        petitionVal: '',
        sortValue: '1',
        code: 'elopetrace_705',
        name: '去向不明',
        children: []
      }
    ]
  },
  {
    id: '706',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'sjje',
    name: '涉及金额分段',
    children: [{
        id: '707',
        parentId: '706',
        petitionVal: '',
        sortValue: '8',
        code: 'sjje_707',
        name: '500万元-1000万元',
        children: []
      },
      {
        id: '708',
        parentId: '706',
        petitionVal: '',
        sortValue: '7',
        code: 'sjje_708',
        name: '1000万元-1亿元',
        children: []
      },
      {
        id: '709',
        parentId: '706',
        petitionVal: '',
        sortValue: '6',
        code: 'sjje_709',
        name: '1亿元以上',
        children: []
      },
      {
        id: '710',
        parentId: '706',
        petitionVal: '',
        sortValue: '5',
        code: 'sjje_710',
        name: '10万元-50万元',
        children: []
      },
      {
        id: '711',
        parentId: '706',
        petitionVal: '',
        sortValue: '4',
        code: 'sjje_711',
        name: '50万元-100万元',
        children: []
      },
      {
        id: '712',
        parentId: '706',
        petitionVal: '',
        sortValue: '3',
        code: 'sjje_712',
        name: '100万元-500万元',
        children: []
      },
      {
        id: '713',
        parentId: '706',
        petitionVal: '',
        sortValue: '2',
        code: 'sjje_713',
        name: '1万元以下',
        children: []
      },
      {
        id: '714',
        parentId: '706',
        petitionVal: '',
        sortValue: '1',
        code: 'sjje_714',
        name: '1万元-10万元',
        children: []
      }
    ]
  },
  {
    id: '715',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'agef',
    name: '年龄分段',
    children: [{
        id: '716',
        parentId: '715',
        petitionVal: '',
        sortValue: '5',
        code: 'agef_716',
        name: '30岁以下',
        children: []
      },
      {
        id: '717',
        parentId: '715',
        petitionVal: '',
        sortValue: '4',
        code: 'agef_717',
        name: '31岁-45岁',
        children: []
      },
      {
        id: '718',
        parentId: '715',
        petitionVal: '',
        sortValue: '3',
        code: 'agef_718',
        name: '46岁-54岁',
        children: []
      },
      {
        id: '719',
        parentId: '715',
        petitionVal: '',
        sortValue: '2',
        code: 'agef_719',
        name: '55岁-59岁',
        children: []
      },
      { id: '720', parentId: '715', petitionVal: '', sortValue: '1', code: 'agef_720', name: '60岁以上', children: [] }
    ]
  },
  {
    id: '721',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'clueparty',
    name: '政治面貌（线索用）',
    children: [{
        id: '722',
        parentId: '721',
        petitionVal: '',
        sortValue: '6',
        code: 'clueparty_722',
        name: '中共党员',
        children: []
      },
      {
        id: '723',
        parentId: '721',
        petitionVal: '',
        sortValue: '5',
        code: 'clueparty_723',
        name: '共青团员',
        children: []
      },
      {
        id: '724',
        parentId: '721',
        petitionVal: '',
        sortValue: '4',
        code: 'clueparty_724',
        name: '民主党派',
        children: [{
            id: '728',
            parentId: '724',
            petitionVal: '',
            sortValue: '',
            code: 'clueparty_728',
            name: '民革',
            children: []
          },
          {
            id: '729',
            parentId: '724',
            petitionVal: '',
            sortValue: '',
            code: 'clueparty_729',
            name: '民盟',
            children: []
          },
          {
            id: '730',
            parentId: '724',
            petitionVal: '',
            sortValue: '',
            code: 'clueparty_730',
            name: '民建',
            children: []
          },
          {
            id: '731',
            parentId: '724',
            petitionVal: '',
            sortValue: '',
            code: 'clueparty_731',
            name: '民进',
            children: []
          },
          {
            id: '732',
            parentId: '724',
            petitionVal: '',
            sortValue: '',
            code: 'clueparty_732',
            name: '农工党',
            children: []
          },
          {
            id: '733',
            parentId: '724',
            petitionVal: '',
            sortValue: '',
            code: 'clueparty_733',
            name: '致公党',
            children: []
          },
          {
            id: '734',
            parentId: '724',
            petitionVal: '',
            sortValue: '',
            code: 'clueparty_734',
            name: '九三学社',
            children: []
          },
          {
            id: '735',
            parentId: '724',
            petitionVal: '',
            sortValue: '',
            code: 'clueparty_735',
            name: '台盟',
            children: []
          }
        ]
      },
      {
        id: '725',
        parentId: '721',
        petitionVal: '',
        sortValue: '3',
        code: 'clueparty_725',
        name: '党组织',
        children: []
      },
      {
        id: '726',
        parentId: '721',
        petitionVal: '',
        sortValue: '2',
        code: 'clueparty_726',
        name: '法人',
        children: []
      },
      {
        id: '727',
        parentId: '721',
        petitionVal: '',
        sortValue: '1',
        code: 'clueparty_727',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '736',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'cluerank',
    name: '职级（线索用）',
    children: [{
        id: '737',
        parentId: '736',
        petitionVal: '',
        sortValue: '8',
        code: 'cluerank_737',
        name: '正省部级',
        children: []
      },
      {
        id: '738',
        parentId: '736',
        petitionVal: '',
        sortValue: '7',
        code: 'cluerank_738',
        name: '副省部级',
        children: []
      },
      {
        id: '739',
        parentId: '736',
        petitionVal: '',
        sortValue: '7',
        code: 'cluerank_739',
        name: '正地厅级',
        children: []
      },
      {
        id: '740',
        parentId: '736',
        petitionVal: '',
        sortValue: '6',
        code: 'cluerank_740',
        name: '副地厅级',
        children: []
      },
      {
        id: '1587',
        parentId: '736',
        petitionVal: '',
        sortValue: '5',
        code: 'cluerank_1587',
        name: '副局级',
        children: []
      },
      {
        id: '741',
        parentId: '736',
        petitionVal: '',
        sortValue: '4',
        code: 'cluerank_741',
        name: '县处级',
        children: []
      },
      {
        id: '742',
        parentId: '736',
        petitionVal: '',
        sortValue: '3',
        code: 'cluerank_742',
        name: '乡科级',
        children: []
      },
      {
        id: '743',
        parentId: '736',
        petitionVal: '',
        sortValue: '2',
        code: 'cluerank_743',
        name: '一般干部',
        children: []
      },
      {
        id: '744',
        parentId: '736',
        petitionVal: '',
        sortValue: '1',
        code: 'cluerank_744',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '745',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'transacmode',
    name: '办理方式',
    children: [{
        id: '746',
        parentId: '745',
        petitionVal: '',
        sortValue: '3',
        code: 'transacmode_746',
        name: '本委办理',
        children: [{
            id: '864',
            parentId: '746',
            petitionVal: '',
            sortValue: '5',
            code: 'transacmode_864',
            name: '拟立案',
            children: [{
                id: '879',
                parentId: '864',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_879',
                name: '本级立案',
                children: []
              },
              {
                id: '880',
                parentId: '864',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_880',
                name: '转下级立案',
                children: []
              }
            ]
          },
          {
            id: '865',
            parentId: '746',
            petitionVal: '',
            sortValue: '4',
            code: 'transacmode_865',
            name: '初步核实',
            children: [{
                id: '869',
                parentId: '865',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_869',
                name: '直接核实',
                children: []
              },
              {
                id: '962',
                parentId: '865',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_962',
                name: '委托了解和查询等',
                children: []
              }
            ]
          },
          {
            id: '963',
            parentId: '746',
            petitionVal: '',
            sortValue: '3',
            code: 'transacmode_963',
            name: '谈话函询',
            children: [{
                id: '964',
                parentId: '963',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_964',
                name: '发函请作情况说明',
                children: []
              },
              {
                id: '965',
                parentId: '963',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_965',
                name: '分管领导或室领导与其谈话',
                children: []
              },
              {
                id: '966',
                parentId: '963',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_966',
                name: '请党委主要负责人与其谈话',
                children: []
              },
              {
                id: '967',
                parentId: '963',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_967',
                name: '委托下级纪检监察机关谈话',
                children: []
              }
            ]
          },
          {
            id: '866',
            parentId: '746',
            petitionVal: '',
            sortValue: '2',
            code: 'transacmode_866',
            name: '暂存',
            children: [{
                id: '968',
                parentId: '866',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_968',
                name: '因时机等因素不便马上核查',
                children: []
              },
              {
                id: '969',
                parentId: '866',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_969',
                name: '重要涉案人一时难以找到',
                children: []
              },
              {
                id: '970',
                parentId: '866',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_970',
                name: '曾初核或谈话函询尚不能否定问题存在',
                children: []
              },
              {
                id: '971',
                parentId: '866',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_971',
                name: '被反映人年龄过大',
                children: []
              },
              {
                id: '972',
                parentId: '866',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_972',
                name: '问题久远且没有新问题举报',
                children: []
              },
              {
                id: '975',
                parentId: '866',
                petitionVal: '',
                sortValue: '',
                code: 'transacmode_975',
                name: '其他',
                children: []
              }
            ]
          },
          {
            id: '868',
            parentId: '746',
            petitionVal: '',
            sortValue: '1',
            code: 'transacmode_868',
            name: '了结',
            children: [{
                id: '882',
                parentId: '868',
                petitionVal: '',
                sortValue: '5',
                code: 'transacmode_882',
                name: '经过初核失实',
                children: []
              },
              {
                id: '973',
                parentId: '868',
                petitionVal: '',
                sortValue: '4',
                code: 'transacmode_973',
                name: '经过谈话函询问题未能确定',
                children: []
              },
              {
                id: '883',
                parentId: '868',
                petitionVal: '',
                sortValue: '3',
                code: 'transacmode_883',
                name: '适当处理',
                children: [{
                    id: '1596',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '36',
                    code: 'transacmode_1596',
                    name: '初步核实了结',
                    children: []
                  },
                  {
                    id: '1595',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '35',
                    code: 'transacmode_1595',
                    name: '谈话函询了结',
                    children: []
                  },
                  {
                    id: '1556',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '34',
                    code: 'transacmode_1556',
                    name: '提醒谈话',
                    children: []
                  },
                  {
                    id: '1557',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '33',
                    code: 'transacmode_1557',
                    name: '警示谈话',
                    children: []
                  },
                  {
                    id: '1555',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '32',
                    code: 'transacmode_1555',
                    name: '批评教育',
                    children: []
                  },
                  {
                    id: '1553',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '31',
                    code: 'transacmode_1553',
                    name: '纠正或责令停止违纪行为',
                    children: []
                  },
                  {
                    id: '1554',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '30',
                    code: 'transacmode_1554',
                    name: '责成退出违纪所得',
                    children: []
                  },
                  {
                    id: '1560',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '29',
                    code: 'transacmode_1560',
                    name: '限期整改',
                    children: []
                  },
                  {
                    id: '1559',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '28',
                    code: 'transacmode_1559',
                    name: '责令作出口头或书面检查',
                    children: []
                  },
                  {
                    id: '1558',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '27',
                    code: 'transacmode_1558',
                    name: '召开民主生活会批评帮助',
                    children: []
                  },
                  {
                    id: '1543',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '26',
                    code: 'transacmode_1543',
                    name: '责令公开道歉（检讨）',
                    children: []
                  },
                  {
                    id: '1535',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '25',
                    code: 'transacmode_1535',
                    name: '通报（通报批评）',
                    children: []
                  },
                  {
                    id: '1541',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '24',
                    code: 'transacmode_1541',
                    name: '诫勉（诫勉谈话）',
                    children: []
                  },
                  {
                    id: '1546',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '23',
                    code: 'transacmode_1546',
                    name: '其它批评教育类措施',
                    children: []
                  },
                  {
                    id: '1561',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '22',
                    code: 'transacmode_1561',
                    name: '取消荣誉称号',
                    children: []
                  },
                  {
                    id: '1549',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '21',
                    code: 'transacmode_1549',
                    name: '撤销政协委员资格',
                    children: []
                  },
                  {
                    id: '1548',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '20',
                    code: 'transacmode_1548',
                    name: '终止（罢免、撤销、责令辞去）人大代 ',
                    children: []
                  },
                  {
                    id: '1540',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '19',
                    code: 'transacmode_1540',
                    name: '取消预备党员资格',
                    children: []
                  },
                  {
                    id: '1550',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '18',
                    code: 'transacmode_1550',
                    name: '取消（罢免）当选资格',
                    children: []
                  },
                  {
                    id: '1547',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '17',
                    code: 'transacmode_1547',
                    name: '终止党代表资格',
                    children: []
                  },
                  {
                    id: '1542',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '16',
                    code: 'transacmode_1542',
                    name: '停职（停职检查）',
                    children: []
                  },
                  {
                    id: '1538',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '15',
                    code: 'transacmode_1538',
                    name: '调整（调离）职务（岗位）',
                    children: []
                  },
                  {
                    id: '1539',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '14',
                    code: 'transacmode_1539',
                    name: '免职',
                    children: []
                  },
                  {
                    id: '1544',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '13',
                    code: 'transacmode_1544',
                    name: '引咎辞职',
                    children: []
                  },
                  {
                    id: '1545',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '12',
                    code: 'transacmode_1545',
                    name: '责令辞职',
                    children: []
                  },
                  {
                    id: '1552',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '11',
                    code: 'transacmode_1552',
                    name: '改任非领导职务',
                    children: []
                  },
                  {
                    id: '1551',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '10',
                    code: 'transacmode_1551',
                    name: '安排提前退休',
                    children: []
                  },
                  {
                    id: '1566',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '9',
                    code: 'transacmode_1566',
                    name: '降低退休待遇',
                    children: []
                  },
                  {
                    id: '1568',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '8',
                    code: 'transacmode_1568',
                    name: '其它组织调整类措施',
                    children: []
                  },
                  {
                    id: '1562',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '7',
                    code: 'transacmode_1562',
                    name: '降职',
                    children: []
                  },
                  {
                    id: '1567',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '6',
                    code: 'transacmode_1567',
                    name: '取消退休待遇',
                    children: []
                  },
                  {
                    id: '1536',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '5',
                    code: 'transacmode_1536',
                    name: '解聘',
                    children: []
                  },
                  {
                    id: '1565',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '4',
                    code: 'transacmode_1565',
                    name: '解除劳动合同',
                    children: []
                  },
                  {
                    id: '1537',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '3',
                    code: 'transacmode_1537',
                    name: '辞退',
                    children: []
                  },
                  {
                    id: '1564',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '2',
                    code: 'transacmode_1564',
                    name: '组织除名（劝退）',
                    children: []
                  },
                  {
                    id: '1563',
                    parentId: '883',
                    petitionVal: '',
                    sortValue: '1',
                    code: 'transacmode_1563',
                    name: '其它重大职务调整类措施',
                    children: []
                  }
                ]
              },
              {
                id: '974',
                parentId: '868',
                petitionVal: '',
                sortValue: '2',
                code: 'transacmode_974',
                name: '被反映人已离休或去世',
                children: []
              },
              {
                id: '884',
                parentId: '868',
                petitionVal: '',
                sortValue: '1',
                code: 'transacmode_884',
                name: '其他',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '747',
        parentId: '745',
        petitionVal: '',
        sortValue: '2',
        code: 'transacmode_747',
        name: '协办',
        children: []
      },
      {
        id: '748',
        parentId: '745',
        petitionVal: '',
        sortValue: '1',
        code: 'transacmode_748',
        name: '转下级办理',
        children: [{
            id: '753',
            parentId: '748',
            petitionVal: '',
            sortValue: '',
            code: 'transacmode_753',
            name: '转办要结果件',
            children: []
          },
          {
            id: '754',
            parentId: '748',
            petitionVal: '',
            sortValue: '',
            code: 'transacmode_754',
            name: '转办不要结果件',
            children: []
          },
          {
            id: '755',
            parentId: '748',
            petitionVal: '',
            sortValue: '',
            code: 'transacmode_755',
            name: '转办其他',
            children: []
          }
        ]
      }
    ]
  },
  {
    id: '756',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'reportkind',
    name: '举报类型（线索用）',
    children: [{
        id: '757',
        parentId: '756',
        petitionVal: '2',
        sortValue: '2',
        code: 'reportkind_757',
        name: '匿名举报',
        children: []
      },
      {
        id: '758',
        parentId: '756',
        petitionVal: '1',
        sortValue: '1',
        code: 'reportkind_758',
        name: '实名举报',
        children: []
      }
    ]
  },
  {
    id: '759',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'reportmode',
    name: '举报方式（线索用）',
    children: [{
        id: '760',
        parentId: '759',
        petitionVal: '1',
        sortValue: '5',
        code: 'reportmode_760',
        name: '来信',
        children: []
      },
      {
        id: '761',
        parentId: '759',
        petitionVal: '3',
        sortValue: '4',
        code: 'reportmode_761',
        name: '来电',
        children: []
      },
      {
        id: '762',
        parentId: '759',
        petitionVal: '2',
        sortValue: '3',
        code: 'reportmode_762',
        name: '来访',
        children: []
      },
      {
        id: '763',
        parentId: '759',
        petitionVal: '4',
        sortValue: '2',
        code: 'reportmode_763',
        name: '网络举报',
        children: []
      },
      {
        id: '764',
        parentId: '759',
        petitionVal: '9',
        sortValue: '1',
        code: 'reportmode_764',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '765',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'dealresult',
    name: '办理结果（线索用）',
    children: [{
        id: '766',
        parentId: '765',
        petitionVal: '',
        sortValue: '4',
        code: 'dealresult_766',
        name: '暂无',
        children: []
      },
      {
        id: '767',
        parentId: '765',
        petitionVal: '',
        sortValue: '3',
        code: 'dealresult_767',
        name: '了结',
        children: []
      },
      {
        id: '768',
        parentId: '765',
        petitionVal: '',
        sortValue: '2',
        code: 'dealresult_768',
        name: '转立案',
        children: []
      },
      {
        id: '769',
        parentId: '765',
        petitionVal: '',
        sortValue: '1',
        code: 'dealresult_769',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '770',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'clueconclusion',
    name: '了结结论（线索用）',
    children: [{
        id: '771',
        parentId: '770',
        petitionVal: '',
        sortValue: '2',
        code: 'clueconclusion_771',
        name: '失实',
        children: []
      },
      {
        id: '772',
        parentId: '770',
        petitionVal: '',
        sortValue: '1',
        code: 'clueconclusion_772',
        name: '属实',
        children: []
      }
    ]
  },
  {
    id: '773',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'clueorigin',
    name: '线索来源（线索用）',
    children: [{
        id: '774',
        parentId: '773',
        petitionVal: '',
        sortValue: '7',
        code: 'clueorigin_774',
        name: '信访举报',
        children: []
      },
      {
        id: '775',
        parentId: '773',
        petitionVal: '',
        sortValue: '6',
        code: 'clueorigin_775',
        name: '纪律审查中发现',
        children: []
      },
      {
        id: '776',
        parentId: '773',
        petitionVal: '',
        sortValue: '5',
        code: 'clueorigin_776',
        name: '巡视中发现',
        children: []
      },
      {
        id: '777',
        parentId: '773',
        petitionVal: '',
        sortValue: '4',
        code: 'clueorigin_777',
        name: '执法，纠风等工作中发现',
        children: []
      },
      {
        id: '778',
        parentId: '773',
        petitionVal: '',
        sortValue: '3',
        code: 'clueorigin_778',
        name: '公检法等机关移送',
        children: []
      },
      {
        id: '779',
        parentId: '773',
        petitionVal: '',
        sortValue: '2',
        code: 'clueorigin_779',
        name: '审计中发现',
        children: []
      },
      {
        id: '780',
        parentId: '773',
        petitionVal: '',
        sortValue: '1',
        code: 'clueorigin_780',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '781',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'tryunit',
    name: '审理机关',
    children: [{
        id: '782',
        parentId: '781',
        petitionVal: '',
        sortValue: '13',
        code: 'tryunit_782',
        name: '中央纪委监察部',
        children: []
      },
      {
        id: '783',
        parentId: '781',
        petitionVal: '',
        sortValue: '12',
        code: 'tryunit_783',
        name: '省区市纪委监察厅局',
        children: []
      },
      {
        id: '784',
        parentId: '781',
        petitionVal: '',
        sortValue: '11',
        code: 'tryunit_784',
        name: '地市州纪委监察局',
        children: []
      },
      {
        id: '785',
        parentId: '781',
        petitionVal: '',
        sortValue: '10',
        code: 'tryunit_785',
        name: '县市区纪委监察局',
        children: []
      },
      {
        id: '786',
        parentId: '781',
        petitionVal: '',
        sortValue: '9',
        code: 'tryunit_786',
        name: '乡镇街道纪（工）委',
        children: []
      },
      {
        id: '787',
        parentId: '781',
        petitionVal: '',
        sortValue: '8',
        code: 'tryunit_787',
        name: '军队纪委',
        children: []
      },
      {
        id: '788',
        parentId: '781',
        petitionVal: '',
        sortValue: '7',
        code: 'tryunit_788',
        name: '中央纪委派驻纪检组',
        children: []
      },
      {
        id: '789',
        parentId: '781',
        petitionVal: '',
        sortValue: '6',
        code: 'tryunit_789',
        name: '省区市纪委派驻纪检组',
        children: []
      },
      {
        id: '790',
        parentId: '781',
        petitionVal: '',
        sortValue: '5',
        code: 'tryunit_790',
        name: '地市州纪委派驻纪检组',
        children: []
      },
      {
        id: '791',
        parentId: '781',
        petitionVal: '',
        sortValue: '4',
        code: 'tryunit_791',
        name: '县市区纪委派驻纪检组',
        children: []
      },
      {
        id: '792',
        parentId: '781',
        petitionVal: '',
        sortValue: '3',
        code: 'tryunit_792',
        name: '企业单位纪检监察机构',
        children: []
      },
      {
        id: '793',
        parentId: '781',
        petitionVal: '',
        sortValue: '2',
        code: 'tryunit_793',
        name: '事业单位纪检监察机构',
        children: []
      },
      { id: '794', parentId: '781', petitionVal: '', sortValue: '1', code: 'tryunit_794', name: '其他', children: [] }
    ]
  },
  {
    id: '795',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'exeunit',
    name: '实施机关',
    children: [{
        id: '796',
        parentId: '795',
        petitionVal: '',
        sortValue: '13',
        code: 'exeunit_796',
        name: '中央纪委监察部',
        children: []
      },
      {
        id: '797',
        parentId: '795',
        petitionVal: '',
        sortValue: '12',
        code: 'exeunit_797',
        name: '省区市纪委监察厅局',
        children: []
      },
      {
        id: '798',
        parentId: '795',
        petitionVal: '',
        sortValue: '11',
        code: 'exeunit_798',
        name: '地市州纪委监察局',
        children: []
      },
      {
        id: '799',
        parentId: '795',
        petitionVal: '',
        sortValue: '10',
        code: 'exeunit_799',
        name: '县市区纪委监察局',
        children: []
      },
      {
        id: '800',
        parentId: '795',
        petitionVal: '',
        sortValue: '9',
        code: 'exeunit_800',
        name: '乡镇街道纪（工）委',
        children: []
      },
      {
        id: '801',
        parentId: '795',
        petitionVal: '',
        sortValue: '8',
        code: 'exeunit_801',
        name: '军队纪委',
        children: []
      },
      {
        id: '802',
        parentId: '795',
        petitionVal: '',
        sortValue: '7',
        code: 'exeunit_802',
        name: '中央纪委派驻纪检组',
        children: []
      },
      {
        id: '803',
        parentId: '795',
        petitionVal: '',
        sortValue: '6',
        code: 'exeunit_803',
        name: '省区市纪委派驻纪检组',
        children: []
      },
      {
        id: '804',
        parentId: '795',
        petitionVal: '',
        sortValue: '5',
        code: 'exeunit_804',
        name: '地市州纪委派驻纪检组',
        children: []
      },
      {
        id: '805',
        parentId: '795',
        petitionVal: '',
        sortValue: '4',
        code: 'exeunit_805',
        name: '县市区纪委派驻纪检组',
        children: []
      },
      {
        id: '806',
        parentId: '795',
        petitionVal: '',
        sortValue: '3',
        code: 'exeunit_806',
        name: '企业单位纪检监察机构',
        children: []
      },
      {
        id: '807',
        parentId: '795',
        petitionVal: '',
        sortValue: '2',
        code: 'exeunit_807',
        name: '事业单位纪检监察机构',
        children: []
      },
      { id: '808', parentId: '795', petitionVal: '', sortValue: '1', code: 'exeunit_808', name: '其他', children: [] }
    ]
  },
  {
    id: '809',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'sex',
    name: '性别',
    children: [
      { id: '810', parentId: '809', petitionVal: '1', sortValue: '3', code: 'sex_810', name: '男', children: [] },
      { id: '811', parentId: '809', petitionVal: '2', sortValue: '2', code: 'sex_811', name: '女', children: [] },
      { id: '812', parentId: '809', petitionVal: '3', sortValue: '1', code: 'sex_812', name: '不详', children: [] }
    ]
  },
  {
    id: '814',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'ldckyear',
    name: '留党察看年限',
    children: [{
        id: '815',
        parentId: '814',
        petitionVal: '',
        sortValue: '2',
        code: 'ldckyear_815',
        name: '一年',
        children: []
      },
      {
        id: '816',
        parentId: '814',
        petitionVal: '',
        sortValue: '1',
        code: 'ldckyear_816',
        name: '两年',
        children: []
      }
    ]
  },
  {
    id: '817',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'rwlx',
    name: '专项报送任务分类',
    children: [
      { id: '818', parentId: '817', petitionVal: '', sortValue: '', code: 'rwlx_818', name: '一次性报送', children: [] },
      { id: '819', parentId: '817', petitionVal: '', sortValue: '', code: 'rwlx_819', name: '月报', children: [] },
      { id: '820', parentId: '817', petitionVal: '', sortValue: '', code: 'rwlx_820', name: '季报', children: [] },
      { id: '821', parentId: '817', petitionVal: '', sortValue: '', code: 'rwlx_821', name: '年报', children: [] }
    ]
  },
  {
    id: '822',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'auditstate',
    name: '数据审核状态',
    children: [{
        id: '823',
        parentId: '822',
        petitionVal: '',
        sortValue: '',
        code: 'auditstate_823',
        name: '未审核',
        children: []
      },
      {
        id: '824',
        parentId: '822',
        petitionVal: '',
        sortValue: '',
        code: 'auditstate_824',
        name: '审核中',
        children: []
      },
      {
        id: '825',
        parentId: '822',
        petitionVal: '',
        sortValue: '',
        code: 'auditstate_825',
        name: '已审核',
        children: []
      },
      {
        id: '826',
        parentId: '822',
        petitionVal: '',
        sortValue: '',
        code: 'auditstate_826',
        name: '撤销审核',
        children: []
      },
      {
        id: '827',
        parentId: '822',
        petitionVal: '',
        sortValue: '',
        code: 'auditstate_827',
        name: '已锁定',
        children: []
      },
      {
        id: '828',
        parentId: '822',
        petitionVal: '',
        sortValue: '',
        code: 'auditstate_828',
        name: '已退回',
        children: []
      },
      {
        id: '829',
        parentId: '822',
        petitionVal: '',
        sortValue: '',
        code: 'auditstate_829',
        name: '已修改',
        children: []
      },
      {
        id: '830',
        parentId: '822',
        petitionVal: '',
        sortValue: '',
        code: 'auditstate_830',
        name: '已删除',
        children: []
      },
      {
        id: '847',
        parentId: '822',
        petitionVal: '',
        sortValue: '',
        code: 'auditstate_847',
        name: '已修改待审核',
        children: []
      }
    ]
  },
  {
    id: '831',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'taskstate',
    name: '专项报送任务状态',
    children: [{
        id: '832',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_832',
        name: '删除',
        children: []
      },
      {
        id: '833',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_833',
        name: '未发布',
        children: []
      },
      {
        id: '834',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_834',
        name: '已发布',
        children: []
      },
      {
        id: '835',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_835',
        name: '已撤销',
        children: []
      },
      {
        id: '836',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_836',
        name: '未接收',
        children: []
      },
      {
        id: '837',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_837',
        name: '已接收',
        children: []
      },
      {
        id: '838',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_838',
        name: '未上报',
        children: []
      },
      {
        id: '839',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_839',
        name: '已上报',
        children: []
      },
      {
        id: '840',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_840',
        name: '未转发',
        children: []
      },
      {
        id: '841',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_841',
        name: '已转发',
        children: []
      },
      {
        id: '842',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_842',
        name: '未汇总',
        children: []
      },
      {
        id: '843',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_843',
        name: '已汇总',
        children: []
      },
      {
        id: '844',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_844',
        name: '未录入',
        children: []
      },
      {
        id: '845',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_845',
        name: '已录入',
        children: []
      },
      {
        id: '846',
        parentId: '831',
        petitionVal: '',
        sortValue: '',
        code: 'taskstate_846',
        name: '无名单',
        children: []
      }
    ]
  },
  {
    id: '875',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'saxx',
    name: '涉案信息',
    children: [
      { id: '876', parentId: '875', petitionVal: '', sortValue: '3', code: 'saxx_876', name: '行贿人', children: [] },
      { id: '877', parentId: '875', petitionVal: '', sortValue: '2', code: 'saxx_877', name: '经手人', children: [] },
      { id: '878', parentId: '875', petitionVal: '', sortValue: '1', code: 'saxx_878', name: '参与人', children: [] }
    ]
  },
  {
    id: '899',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'dutyType',
    name: '职务类型',
    children: [{
        id: '900',
        parentId: '899',
        petitionVal: '',
        sortValue: '',
        code: 'dutyType_900',
        name: '纪委书记',
        children: []
      },
      {
        id: '901',
        parentId: '899',
        petitionVal: '',
        sortValue: '',
        code: 'dutyType_901',
        name: '监察机关正职',
        children: []
      },
      {
        id: '902',
        parentId: '899',
        petitionVal: '',
        sortValue: '',
        code: 'dutyType_902',
        name: '纪检监察机关副职',
        children: []
      },
      {
        id: '903',
        parentId: '899',
        petitionVal: '',
        sortValue: '',
        code: 'dutyType_903',
        name: '纪检组长',
        children: []
      },
      {
        id: '904',
        parentId: '899',
        petitionVal: '',
        sortValue: '',
        code: 'dutyType_904',
        name: '纪检组副组长(监察室主任)',
        children: []
      },
      {
        id: '905',
        parentId: '899',
        petitionVal: '',
        sortValue: '',
        code: 'dutyType_905',
        name: '纪检监察机关内设机构正副职',
        children: []
      },
      { id: '906', parentId: '899', petitionVal: '', sortValue: '', code: 'dutyType_906', name: '其他', children: [] }
    ]
  },
  {
    id: '907',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'workPostType',
    name: '单位类型',
    children: [{
        id: '908',
        parentId: '907',
        petitionVal: '',
        sortValue: '',
        code: 'workPostType_908',
        name: '机关性质的纪检监察机构',
        children: [{
            id: '912',
            parentId: '908',
            petitionVal: '',
            sortValue: '',
            code: 'workPostType_912',
            name: '纪检监察机关',
            children: [{
                id: '915',
                parentId: '912',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_915',
                name: '中央纪委监察部',
                children: []
              },
              {
                id: '916',
                parentId: '912',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_916',
                name: '省区市纪委监察厅局',
                children: []
              },
              {
                id: '917',
                parentId: '912',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_917',
                name: '地市州盟纪检监察机关',
                children: []
              },
              {
                id: '918',
                parentId: '912',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_918',
                name: '县市区旗纪检监察机关',
                children: []
              },
              {
                id: '919',
                parentId: '912',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_919',
                name: '乡镇纪委(街道纪工委)',
                children: []
              }
            ]
          },
          {
            id: '913',
            parentId: '908',
            petitionVal: '',
            sortValue: '',
            code: 'workPostType_913',
            name: '派驻机构',
            children: [{
                id: '920',
                parentId: '913',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_920',
                name: '中央纪委监察部派驻(派出)机构',
                children: []
              },
              {
                id: '921',
                parentId: '913',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_921',
                name: '省级纪检监察机关派驻(派出)机构',
                children: []
              },
              {
                id: '922',
                parentId: '913',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_922',
                name: '市级纪检监察机关派驻(派出)机构',
                children: []
              },
              {
                id: '923',
                parentId: '913',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_923',
                name: '县级纪检监察机关派驻(派出)机构',
                children: []
              }
            ]
          },
          {
            id: '914',
            parentId: '908',
            petitionVal: '',
            sortValue: '',
            code: 'workPostType_914',
            name: '内设纪检监察机构',
            children: [{
                id: '924',
                parentId: '914',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_924',
                name: '中央和国家机关内设纪检监察机构',
                children: []
              },
              {
                id: '925',
                parentId: '914',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_925',
                name: '省直机关内设纪检监察机构',
                children: []
              },
              {
                id: '926',
                parentId: '914',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_926',
                name: '市直机关内设纪检监察机构',
                children: []
              },
              {
                id: '927',
                parentId: '914',
                petitionVal: '',
                sortValue: '',
                code: 'workPostType_927',
                name: '县直机关内设纪检监察机构',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '909',
        parentId: '907',
        petitionVal: '',
        sortValue: '',
        code: 'workPostType_909',
        name: '企业单位纪检监察机构',
        children: []
      },
      {
        id: '910',
        parentId: '907',
        petitionVal: '',
        sortValue: '',
        code: 'workPostType_910',
        name: '事业单位纪检监察机构',
        children: []
      },
      {
        id: '911',
        parentId: '907',
        petitionVal: '',
        sortValue: '',
        code: 'workPostType_911',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '928',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'breakCause',
    name: '因分管或从事哪方面工作违纪',
    children: [{
        id: '929',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_929',
        name: '综合协调',
        children: []
      },
      {
        id: '930',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_930',
        name: '政策法规研究',
        children: []
      },
      {
        id: '931',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_931',
        name: '宣传教育',
        children: []
      },
      {
        id: '932',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_932',
        name: '党风政风监督',
        children: []
      },
      {
        id: '933',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_933',
        name: '巡视',
        children: []
      },
      {
        id: '934',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_934',
        name: '执法效能监督',
        children: []
      },
      {
        id: '935',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_935',
        name: '信访举报',
        children: []
      },
      {
        id: '936',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_936',
        name: '案件检查',
        children: []
      },
      {
        id: '937',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_937',
        name: '案件管理',
        children: []
      },
      {
        id: '938',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_938',
        name: '案件审理',
        children: []
      },
      {
        id: '939',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_939',
        name: '组织人事',
        children: []
      },
      {
        id: '940',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_940',
        name: '后勤保障',
        children: []
      },
      {
        id: '941',
        parentId: '928',
        petitionVal: '',
        sortValue: '',
        code: 'breakCause_941',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '942',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'breakLinkCount',
    name: '专项违纪环节统计',
    children: [{
        id: '943',
        parentId: '942',
        petitionVal: '',
        sortValue: '',
        code: 'breakLinkCount_943',
        name: '办理信访中违纪',
        children: []
      },
      {
        id: '944',
        parentId: '942',
        petitionVal: '',
        sortValue: '',
        code: 'breakLinkCount_944',
        name: '查办案件中违纪',
        children: []
      },
      {
        id: '945',
        parentId: '942',
        petitionVal: '',
        sortValue: '',
        code: 'breakLinkCount_945',
        name: '监督检查中违纪',
        children: []
      }
    ]
  },
  {
    id: '958',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'onjob',
    name: '是否在职',
    children: [
      { id: '959', parentId: '958', petitionVal: '', sortValue: '3', code: 'onjob_959', name: '在职', children: [] },
      { id: '960', parentId: '958', petitionVal: '', sortValue: '2', code: 'onjob_960', name: '离休', children: [] },
      { id: '961', parentId: '958', petitionVal: '', sortValue: '1', code: 'onjob_961', name: '退休', children: [] }
    ]
  },
  {
    id: '977',
    parentId: '',
    petitionVal: '0',
    sortValue: '0',
    code: 'wjxw',
    name: '违纪行为',
    children: [{
        id: '978',
        parentId: '977',
        petitionVal: '0121',
        sortValue: '6',
        code: 'wjxw_978',
        name: '违反政治纪律',
        children: [{
            id: '984',
            parentId: '978',
            petitionVal: '0',
            sortValue: '7',
            code: 'wjxw_984',
            name: '发表危害党的言论',
            children: [{
                id: '1015',
                parentId: '984',
                petitionVal: '0',
                sortValue: '12',
                code: 'wjxw_1015',
                name: '公开发表反对四项基本原则、改革开放决策言论',
                children: []
              },
              {
                id: '1016',
                parentId: '984',
                petitionVal: '0',
                sortValue: '11',
                code: 'wjxw_1016',
                name: '传播或帮助传播公开发表反对四项基本原则、改革开放决策言论',
                children: []
              },
              {
                id: '1017',
                parentId: '984',
                petitionVal: '0',
                sortValue: '10',
                code: 'wjxw_1017',
                name: '公开发表违背四项基本原则言论',
                children: []
              },
              {
                id: '1018',
                parentId: '984',
                petitionVal: '0',
                sortValue: '9',
                code: 'wjxw_1018',
                name: '公开发表违背、歪曲改革开放决策言论',
                children: []
              },
              {
                id: '1019',
                parentId: '984',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1019',
                name: '公开发表其他有严重政治问题言论',
                children: []
              },
              {
                id: '1020',
                parentId: '984',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1020',
                name: '妄议中央大政方针',
                children: []
              },
              {
                id: '1021',
                parentId: '984',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1021',
                name: '丑化党和国家形象',
                children: []
              },
              {
                id: '1022',
                parentId: '984',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1022',
                name: '诋毁、污蔑党和国家领导人',
                children: []
              },
              {
                id: '1023',
                parentId: '984',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1023',
                name: '歪曲党史、军史',
                children: []
              },
              {
                id: '1024',
                parentId: '984',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1024',
                name: '传播或帮助传播违背四项基本原则、改革开放决策等言论',
                children: []
              },
              {
                id: '1025',
                parentId: '984',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1025',
                name: '制作、贩卖、传播政治类有害资料',
                children: []
              },
              {
                id: '1026',
                parentId: '984',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1026',
                name: '私自携带、寄递政治类有害资料入出境',
                children: []
              }
            ]
          },
          {
            id: '985',
            parentId: '978',
            petitionVal: '0',
            sortValue: '6',
            code: 'wjxw_985',
            name: '破坏党的团结统一',
            children: [{
                id: '1027',
                parentId: '985',
                petitionVal: '0',
                sortValue: '9',
                code: 'wjxw_1027',
                name: '组织、参加反党集会、游行、示威等活动',
                children: []
              },
              {
                id: '1028',
                parentId: '985',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1028',
                name: '参加反党讲座、论坛、报告会、座谈会等',
                children: []
              },
              {
                id: '1029',
                parentId: '985',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1029',
                name: '支持反党活动',
                children: []
              },
              {
                id: '1030',
                parentId: '985',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1030',
                name: '未经批准参加其他集会、游行、示威等活动',
                children: []
              },
              {
                id: '1031',
                parentId: '985',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1031',
                name: '组织、参加反党、反社会主义或敌视政府等组织',
                children: []
              },
              {
                id: '1032',
                parentId: '985',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1032',
                name: '组织、参加会道门或邪教组织',
                children: []
              },
              {
                id: '1033',
                parentId: '985',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1033',
                name: '组织、参加分裂党的活动',
                children: []
              },
              {
                id: '1034',
                parentId: '985',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1034',
                name: '在党内搞团团伙伙、拉帮结派等活动',
                children: []
              },
              {
                id: '1035',
                parentId: '985',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1035',
                name: '捞取政治资本',
                children: []
              }
            ]
          },
          {
            id: '986',
            parentId: '978',
            petitionVal: '0',
            sortValue: '5',
            code: 'wjxw_986',
            name: '损害中央权威妨碍党和国家方针政策实施',
            children: [{
                id: '1036',
                parentId: '986',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1036',
                name: '拒不执行党和国家的方针政策及决策部署',
                children: []
              },
              {
                id: '1037',
                parentId: '986',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1037',
                name: '故意作出违背党和国家的方针政策及决策部署的决定',
                children: []
              },
              {
                id: '1038',
                parentId: '986',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1038',
                name: '擅自对应由中央决定的重大政策问题作出决定和对外发表主张',
                children: []
              },
              {
                id: '1039',
                parentId: '986',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1039',
                name: '挑拨民族关系制造事端或参加民族分裂活动',
                children: []
              },
              {
                id: '1040',
                parentId: '986',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1040',
                name: '其他违反党和国家民族政策行为',
                children: []
              },
              {
                id: '1041',
                parentId: '986',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1041',
                name: '组织、利用宗教活动反党',
                children: []
              },
              {
                id: '1042',
                parentId: '986',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1042',
                name: '其他违反党和国家宗教政策行为',
                children: []
              },
              {
                id: '1043',
                parentId: '986',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1043',
                name: '组织、利用宗族势力对抗党和政府',
                children: []
              }
            ]
          },
          {
            id: '987',
            parentId: '978',
            petitionVal: '0',
            sortValue: '4',
            code: 'wjxw_987',
            name: '对抗组织审查',
            children: [{
                id: '1044',
                parentId: '987',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1044',
                name: '串供或伪造、销毁、转移、隐匿证据',
                children: []
              },
              {
                id: '1045',
                parentId: '987',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1045',
                name: '阻止他人揭发检举、提供证据材料',
                children: []
              },
              {
                id: '1046',
                parentId: '987',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1046',
                name: '包庇同案人员',
                children: []
              },
              {
                id: '1047',
                parentId: '987',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1047',
                name: '提供虚假情况掩盖事实',
                children: []
              },
              {
                id: '1048',
                parentId: '987',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1048',
                name: '其他对抗组织审查行为',
                children: []
              }
            ]
          },
          {
            id: '988',
            parentId: '978',
            petitionVal: '0',
            sortValue: '3',
            code: 'wjxw_988',
            name: '组织参加迷信活动',
            children: [{
                id: '1049',
                parentId: '988',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1049',
                name: '组织迷信活动',
                children: []
              },
              {
                id: '1050',
                parentId: '988',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1050',
                name: '参加迷信活动',
                children: []
              }
            ]
          },
          {
            id: '989',
            parentId: '978',
            petitionVal: '0',
            sortValue: '2',
            code: 'wjxw_989',
            name: '叛逃及在涉外活动中损害党和国家尊严利益',
            children: [{
                id: '1051',
                parentId: '989',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1051',
                name: '申请政治避难',
                children: []
              },
              {
                id: '1052',
                parentId: '989',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1052',
                name: '叛逃',
                children: []
              },
              {
                id: '1053',
                parentId: '989',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1053',
                name: '在国（境）外公开发表反对党和政府言论',
                children: []
              },
              {
                id: '1054',
                parentId: '989',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1054',
                name: '故意为叛逃国（境）外等行为提供方便条件',
                children: []
              },
              {
                id: '1055',
                parentId: '989',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1055',
                name: '涉外活动造成恶劣政治影响',
                children: []
              }
            ]
          },
          {
            id: '990',
            parentId: '978',
            petitionVal: '0',
            sortValue: '1',
            code: 'wjxw_990',
            name: '违反政治规矩',
            children: [{
                id: '1056',
                parentId: '990',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1056',
                name: '搞无原则一团和气',
                children: []
              },
              {
                id: '1057',
                parentId: '990',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1057',
                name: '违反党的优良传统和工作惯例等规矩',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '979',
        parentId: '977',
        petitionVal: '0122',
        sortValue: '5',
        code: 'wjxw_979',
        name: '违反组织纪律',
        children: [{
            id: '991',
            parentId: '979',
            petitionVal: '0',
            sortValue: '4',
            code: 'wjxw_991',
            name: '违反民主集中制原则',
            children: [{
                id: '1058',
                parentId: '991',
                petitionVal: '0',
                sortValue: '12',
                code: 'wjxw_1058',
                name: '拒不执行或擅自改变党组织重大决定',
                children: []
              },
              {
                id: '1059',
                parentId: '991',
                petitionVal: '0',
                sortValue: '11',
                code: 'wjxw_1059',
                name: '个人或少数人违反议事规则决定重大问题',
                children: []
              },
              {
                id: '1060',
                parentId: '991',
                petitionVal: '0',
                sortValue: '10',
                code: 'wjxw_1060',
                name: '下级党组织拒不执行或擅自改变上级党组织决定',
                children: []
              },
              {
                id: '1061',
                parentId: '991',
                petitionVal: '0',
                sortValue: '9',
                code: 'wjxw_1061',
                name: '拒不执行党组织分配、调动、交流等决定',
                children: []
              },
              {
                id: '1062',
                parentId: '991',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1062',
                name: '不按规定或要求向组织请示报告重大问题、重大事项',
                children: []
              },
              {
                id: '1063',
                parentId: '991',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1063',
                name: '不按要求报告或不如实报告个人去向',
                children: []
              },
              {
                id: '1064',
                parentId: '991',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1064',
                name: '不报告、不如实报告个人有关事项',
                children: []
              },
              {
                id: '1065',
                parentId: '991',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1065',
                name: '谈话、函询时不如实说明问题',
                children: []
              },
              {
                id: '1066',
                parentId: '991',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1066',
                name: '不如实填报个人档案资料',
                children: []
              },
              {
                id: '1067',
                parentId: '991',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1067',
                name: '篡改、伪造个人档案资料',
                children: []
              },
              {
                id: '1068',
                parentId: '991',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1068',
                name: '隐瞒入党前严重错误',
                children: []
              },
              {
                id: '1069',
                parentId: '991',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1069',
                name: '违规组织、参加自发成立的老乡会、校友会、战友会等',
                children: []
              }
            ]
          },
          {
            id: '992',
            parentId: '979',
            petitionVal: '0',
            sortValue: '3',
            code: 'wjxw_992',
            name: '侵犯党员权利',
            children: [{
                id: '1070',
                parentId: '992',
                petitionVal: '0',
                sortValue: '9',
                code: 'wjxw_1070',
                name: '诬告陷害',
                children: []
              },
              {
                id: '1071',
                parentId: '992',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1071',
                name: '侵犯党员表决权、选举权和被选举权',
                children: []
              },
              {
                id: '1072',
                parentId: '992',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1072',
                name: '妨害党员自主行使表决权、选举权和被选举权',
                children: []
              },
              {
                id: '1073',
                parentId: '992',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1073',
                name: '侵犯他人批评权、检举权、控告权',
                children: []
              },
              {
                id: '1074',
                parentId: '992',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1074',
                name: '压制党员申辩、辩护、作证等权利',
                children: []
              },
              {
                id: '1075',
                parentId: '992',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1075',
                name: '压制或不按规定处理党员申诉',
                children: []
              },
              {
                id: '1076',
                parentId: '992',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1076',
                name: '打击报复',
                children: []
              },
              {
                id: '1077',
                parentId: '992',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1077',
                name: '党组织侵犯党员权利',
                children: []
              },
              {
                id: '1078',
                parentId: '992',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1078',
                name: '其他侵犯党员权利行为',
                children: []
              }
            ]
          },
          {
            id: '993',
            parentId: '979',
            petitionVal: '0',
            sortValue: '2',
            code: 'wjxw_993',
            name: '违反组织工作原则',
            children: [{
                id: '1079',
                parentId: '993',
                petitionVal: '0',
                sortValue: '10',
                code: 'wjxw_1079',
                name: '在民主推荐、民主测评、组织考察和党内选举中搞非组织活动',
                children: []
              },
              {
                id: '1080',
                parentId: '993',
                petitionVal: '0',
                sortValue: '9',
                code: 'wjxw_1080',
                name: '在法定投票选举中搞非组织活动',
                children: []
              },
              {
                id: '1081',
                parentId: '993',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1081',
                name: '在选举中搞其他违规活动',
                children: []
              },
              {
                id: '1082',
                parentId: '993',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1082',
                name: '违规选拔任用干部',
                children: []
              },
              {
                id: '1083',
                parentId: '993',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1083',
                name: '用人失察失误',
                children: []
              },
              {
                id: '1084',
                parentId: '993',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1084',
                name: '在干部、职工录用、考核等工作中为本人或他人谋利',
                children: []
              },
              {
                id: '1085',
                parentId: '993',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1085',
                name: '骗取职务、待遇、学历、荣誉等',
                children: []
              },
              {
                id: '1086',
                parentId: '993',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1086',
                name: '把不符合党员条件的人发展为党员',
                children: []
              },
              {
                id: '1087',
                parentId: '993',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1087',
                name: '为非党员出具党员身份证明',
                children: []
              },
              {
                id: '1088',
                parentId: '993',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1088',
                name: '违法程序发展党员',
                children: []
              }
            ]
          },
          {
            id: '994',
            parentId: '979',
            petitionVal: '0',
            sortValue: '1',
            code: 'wjxw_994',
            name: '违规办理因私出国（境）证件和在国（境）外擅自脱离组织',
            children: [{
                id: '1089',
                parentId: '994',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1089',
                name: '违规取得外国国籍、国（境）外居留资格',
                children: []
              },
              {
                id: '1090',
                parentId: '994',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1090',
                name: '违规办理因私出国（境）证件等',
                children: []
              },
              {
                id: '1091',
                parentId: '994',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1091',
                name: '未经批准出入国（边）境',
                children: []
              },
              {
                id: '1092',
                parentId: '994',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1092',
                name: '在国（境）外擅自脱离组织',
                children: []
              },
              {
                id: '1093',
                parentId: '994',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1093',
                name: '在国（境）外违规交往',
                children: []
              },
              {
                id: '1094',
                parentId: '994',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1094',
                name: '在国（境）外脱离组织出走',
                children: []
              },
              {
                id: '1095',
                parentId: '994',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1095',
                name: '故意为他人脱离组织出走提供方便条件',
                children: []
              }
            ]
          }
        ]
      },
      {
        id: '980',
        parentId: '977',
        petitionVal: '0123',
        sortValue: '4',
        code: 'wjxw_980',
        name: '违反廉洁纪律',
        children: [{
            id: '995',
            parentId: '980',
            petitionVal: '0',
            sortValue: '8',
            code: 'wjxw_995',
            name: '以权谋私',
            children: [{
                id: '1096',
                parentId: '995',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1096',
                name: '为他人谋利、本人亲属和特定关系人收受对方财物',
                children: []
              },
              {
                id: '1097',
                parentId: '995',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1097',
                name: '权权交易',
                children: []
              },
              {
                id: '1098',
                parentId: '995',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1098',
                name: '纵容、默许亲属和身边工作人员违规谋利',
                children: []
              },
              {
                id: '1099',
                parentId: '995',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1099',
                name: '对亲属违规取酬知情未予纠正',
                children: []
              }
            ]
          },
          {
            id: '996',
            parentId: '980',
            petitionVal: '0',
            sortValue: '7',
            code: 'wjxw_996',
            name: '违规接受礼品礼金和服务',
            children: [{
                id: '1100',
                parentId: '996',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1100',
                name: '收受可能影响公正执行公务的礼品、礼金、消费卡等',
                children: []
              },
              {
                id: '1101',
                parentId: '996',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1101',
                name: '收受明显超出正常礼尚往来的礼品、礼金、消费卡等',
                children: []
              },
              {
                id: '1102',
                parentId: '996',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1102',
                name: '向从事公务的人员及其亲属和特定关系人违规赠送礼品、礼金、消费卡等',
                children: []
              },
              {
                id: '1103',
                parentId: '996',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1103',
                name: '利用职权或职务上的影响操办婚丧喜庆事宜',
                children: []
              },
              {
                id: '1104',
                parentId: '996',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1104',
                name: '在操办婚丧喜庆事宜中借机敛财等',
                children: []
              },
              {
                id: '1105',
                parentId: '996',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1105',
                name: '接受可能影响公正执行公务的宴请、旅游等',
                children: []
              },
              {
                id: '1106',
                parentId: '996',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1106',
                name: '违规取得、持有、使用消费卡',
                children: []
              },
              {
                id: '1107',
                parentId: '996',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1107',
                name: '违规出入私人会所',
                children: []
              }
            ]
          },
          {
            id: '997',
            parentId: '980',
            petitionVal: '0',
            sortValue: '6',
            code: 'wjxw_997',
            name: '违规从事营利性活动',
            children: [{
                id: '1108',
                parentId: '997',
                petitionVal: '0',
                sortValue: '14',
                code: 'wjxw_1108',
                name: '违规经商办企业',
                children: []
              },
              {
                id: '1109',
                parentId: '997',
                petitionVal: '0',
                sortValue: '13',
                code: 'wjxw_1109',
                name: '违规拥有非上市公司（企业）股份或证券',
                children: []
              },
              {
                id: '1110',
                parentId: '997',
                petitionVal: '0',
                sortValue: '12',
                code: 'wjxw_1110',
                name: '违规买卖股票或其他证劵投资',
                children: []
              },
              {
                id: '1111',
                parentId: '997',
                petitionVal: '0',
                sortValue: '11',
                code: 'wjxw_1111',
                name: '违规从事有偿中介活动',
                children: []
              },
              {
                id: '1112',
                parentId: '997',
                petitionVal: '0',
                sortValue: '10',
                code: 'wjxw_1112',
                name: '违规在国（境）外注册公司或投资入股',
                children: []
              },
              {
                id: '1113',
                parentId: '997',
                petitionVal: '0',
                sortValue: '9',
                code: 'wjxw_1113',
                name: '违规为亲属和特定关系人经营活动谋利',
                children: []
              },
              {
                id: '1114',
                parentId: '997',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1114',
                name: '违规兼职',
                children: []
              },
              {
                id: '1115',
                parentId: '997',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1115',
                name: '兼职取酬',
                children: []
              },
              {
                id: '1116',
                parentId: '997',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1116',
                name: '离职或退（离）休后违规接受聘任',
                children: []
              },
              {
                id: '1117',
                parentId: '997',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1117',
                name: '离职或退（离）休后违规从事营利活动',
                children: []
              },
              {
                id: '1118',
                parentId: '997',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1118',
                name: '离职或退（离）休后违规担任独立董事、独立监事',
                children: []
              },
              {
                id: '1119',
                parentId: '997',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1119',
                name: '对亲属违反从业限制规定应予纠正而拒不纠正',
                children: []
              },
              {
                id: '1120',
                parentId: '997',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1120',
                name: '党和国家机关违规经商办企业',
                children: []
              },
              {
                id: '1121',
                parentId: '997',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1121',
                name: '其他违规从事营利活动',
                children: []
              }
            ]
          },
          {
            id: '998',
            parentId: '980',
            petitionVal: '0',
            sortValue: '5',
            code: 'wjxw_998',
            name: '违反工作生活待遇规定',
            children: [{
                id: '1122',
                parentId: '998',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1122',
                name: '违规谋求特殊待遇',
                children: []
              },
              {
                id: '1123',
                parentId: '998',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1123',
                name: '在分配、购买住房中侵犯国家、集体利益',
                children: []
              }
            ]
          },
          {
            id: '999',
            parentId: '980',
            petitionVal: '0',
            sortValue: '4',
            code: 'wjxw_999',
            name: '违规占有使用公款公物',
            children: [{
                id: '1124',
                parentId: '999',
                petitionVal: '0',
                sortValue: '10',
                code: 'wjxw_1124',
                name: '侵占非本人经营的公私财物等',
                children: []
              },
              {
                id: '1125',
                parentId: '999',
                petitionVal: '0',
                sortValue: '9',
                code: 'wjxw_1125',
                name: '以象征性支付钱款等方式侵占公私财物',
                children: []
              },
              {
                id: '1126',
                parentId: '999',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1126',
                name: '无偿、象征性支付报酬接受服务、使用劳务',
                children: []
              },
              {
                id: '1127',
                parentId: '999',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1127',
                name: '违规支付、报销应由本人或亲属承担的费用',
                children: []
              },
              {
                id: '1128',
                parentId: '999',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1128',
                name: '违规占用公物归个人使用',
                children: []
              },
              {
                id: '1129',
                parentId: '999',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1129',
                name: '占用公物进行营利活动',
                children: []
              },
              {
                id: '1130',
                parentId: '999',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1130',
                name: '将公物借给他人进行营利活动',
                children: []
              },
              {
                id: '1131',
                parentId: '999',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1131',
                name: '违规组织、参加公款宴请、高消费娱乐、健身活动',
                children: []
              },
              {
                id: '1132',
                parentId: '999',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1132',
                name: '违规用公款购买赠送、发放礼品',
                children: []
              },
              {
                id: '1133',
                parentId: '999',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1133',
                name: '违规自定薪酬或滥发津贴、补贴、奖金等',
                children: []
              }
            ]
          },
          {
            id: '1000',
            parentId: '980',
            petitionVal: '0',
            sortValue: '3',
            code: 'wjxw_1000',
            name: '违反厉行节约反对浪费规定',
            children: [{
                id: '1134',
                parentId: '1000',
                petitionVal: '0',
                sortValue: '10',
                code: 'wjxw_1134',
                name: '公款旅游或变相公款旅游',
                children: []
              },
              {
                id: '1135',
                parentId: '1000',
                petitionVal: '0',
                sortValue: '9',
                code: 'wjxw_1135',
                name: '变相用公款出国（境）旅游',
                children: []
              },
              {
                id: '1136',
                parentId: '1000',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1136',
                name: '违规接待或借机大吃大喝',
                children: []
              },
              {
                id: '1137',
                parentId: '1000',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1137',
                name: '违反公务用车管理规定',
                children: []
              },
              {
                id: '1138',
                parentId: '1000',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1138',
                name: '违规到禁止开会的风景名胜区开会',
                children: []
              },
              {
                id: '1139',
                parentId: '1000',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1139',
                name: '违规决定或批准举办节会、庆典活动',
                children: []
              },
              {
                id: '1140',
                parentId: '1000',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1140',
                name: '擅自举办评比表彰活动或借机收费',
                children: []
              },
              {
                id: '1141',
                parentId: '1000',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1141',
                name: '违规决定或批准兴建、装修楼堂馆所等',
                children: []
              },
              {
                id: '1142',
                parentId: '1000',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1142',
                name: '超标准配备、使用办公用房',
                children: []
              },
              {
                id: '1143',
                parentId: '1000',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1143',
                name: '违规用公款包租、占用客房等供个人使用',
                children: []
              }
            ]
          },
          {
            id: '1001',
            parentId: '980',
            petitionVal: '0',
            sortValue: '2',
            code: 'wjxw_1001',
            name: '权色或钱色交易',
            children: []
          },
          {
            id: '1002',
            parentId: '980',
            petitionVal: '0',
            sortValue: '1',
            code: 'wjxw_1002',
            name: '其他违反廉洁纪律行为',
            children: []
          }
        ]
      },
      {
        id: '981',
        parentId: '977',
        petitionVal: '0124',
        sortValue: '3',
        code: 'wjxw_981',
        name: '违反群众纪律',
        children: [{
            id: '1003',
            parentId: '981',
            petitionVal: '0',
            sortValue: '4',
            code: 'wjxw_1003',
            name: '侵害群众利益',
            children: [{
                id: '1144',
                parentId: '1003',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1144',
                name: '超标准、超范围筹资筹劳、摊派费用',
                children: []
              },
              {
                id: '1145',
                parentId: '1003',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1145',
                name: '违规扣留、收缴群众款物或处罚群众',
                children: []
              },
              {
                id: '1146',
                parentId: '1003',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1146',
                name: '克扣群众财物或违规拖欠群众钱款',
                children: []
              },
              {
                id: '1147',
                parentId: '1003',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1147',
                name: '在管理、服务中违规收费',
                children: []
              },
              {
                id: '1148',
                parentId: '1003',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1148',
                name: '在工作中刁难群众、吃拿卡要',
                children: []
              },
              {
                id: '1149',
                parentId: '1003',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1149',
                name: '干涉群众生产经营自主权',
                children: []
              },
              {
                id: '1150',
                parentId: '1003',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1150',
                name: '在社会保障等事项中优亲厚友、显失公平',
                children: []
              },
              {
                id: '1151',
                parentId: '1003',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1151',
                name: '其他侵害群众利益行为',
                children: []
              }
            ]
          },
          {
            id: '1004',
            parentId: '981',
            petitionVal: '0',
            sortValue: '3',
            code: 'wjxw_1004',
            name: '漠视群众利益',
            children: [{
                id: '1152',
                parentId: '1004',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1152',
                name: '对群众切身利益问题能解决而不及时解决',
                children: []
              },
              {
                id: '1153',
                parentId: '1004',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1153',
                name: '对符合政策的群众诉求消极应付、推诿扯皮',
                children: []
              },
              {
                id: '1154',
                parentId: '1004',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1154',
                name: '对待群众态度恶劣、简单粗暴',
                children: []
              },
              {
                id: '1155',
                parentId: '1004',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1155',
                name: '弄虚作假、欺上瞒下',
                children: []
              },
              {
                id: '1156',
                parentId: '1004',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1156',
                name: '盲目铺摊子、上项目',
                children: []
              },
              {
                id: '1157',
                parentId: '1004',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1157',
                name: '遇险能救而不救',
                children: []
              }
            ]
          },
          {
            id: '1005',
            parentId: '981',
            petitionVal: '0',
            sortValue: '2',
            code: 'wjxw_1005',
            name: '侵犯群众知情权',
            children: []
          },
          {
            id: '1006',
            parentId: '981',
            petitionVal: '0',
            sortValue: '1',
            code: 'wjxw_1006',
            name: '其他违反群众纪律行为',
            children: []
          }
        ]
      },
      {
        id: '982',
        parentId: '977',
        petitionVal: '0125',
        sortValue: '2',
        code: 'wjxw_982',
        name: '违反工作纪律',
        children: [{
            id: '1007',
            parentId: '982',
            petitionVal: '0',
            sortValue: '5',
            code: 'wjxw_1007',
            name: '党组织失职',
            children: [{
                id: '1158',
                parentId: '1007',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1158',
                name: '不传达贯彻、不检查督促落实党和国家方针政策及决策部署',
                children: []
              },
              {
                id: '1159',
                parentId: '1007',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1159',
                name: '作出违背党和国家方针政策及决策部署的错误决策',
                children: []
              },
              {
                id: '1160',
                parentId: '1007',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1160',
                name: '管辖范围发生公开反对党和国家方针政策及决策部署行为',
                children: []
              },
              {
                id: '1161',
                parentId: '1007',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1161',
                name: '不履行或履行全面从严治党主体责任不力',
                children: []
              },
              {
                id: '1162',
                parentId: '1007',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1162',
                name: '不按规定给予党纪处分',
                children: []
              },
              {
                id: '1163',
                parentId: '1007',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1163',
                name: '不按规定落实党纪处分决定或申诉复查决定',
                children: []
              },
              {
                id: '1164',
                parentId: '1007',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1164',
                name: '不按规定对受处分党员开展教育、管理和监督',
                children: []
              }
            ]
          },
          {
            id: '1008',
            parentId: '982',
            petitionVal: '0',
            sortValue: '4',
            code: 'wjxw_1008',
            name: '滥用职权和玩忽职守',
            children: [{
                id: '1165',
                parentId: '1008',
                petitionVal: '0',
                sortValue: '10',
                code: 'wjxw_1165',
                name: '失职致所管理人员叛逃',
                children: []
              },
              {
                id: '1166',
                parentId: '1008',
                petitionVal: '0',
                sortValue: '9',
                code: 'wjxw_1166',
                name: '失职致所管理人员出走',
                children: []
              },
              {
                id: '1167',
                parentId: '1008',
                petitionVal: '0',
                sortValue: '8',
                code: 'wjxw_1167',
                name: '工作中不向或不如实向上级报告情况',
                children: []
              },
              {
                id: '1168',
                parentId: '1008',
                petitionVal: '0',
                sortValue: '7',
                code: 'wjxw_1168',
                name: '违规干预和插手建设工程、政府采购、房地产、矿产资源开发等',
                children: []
              },
              {
                id: '1169',
                parentId: '1008',
                petitionVal: '0',
                sortValue: '6',
                code: 'wjxw_1169',
                name: '违规干预和插手国企重组改制、兼并、破产、重大项目投资等',
                children: []
              },
              {
                id: '1170',
                parentId: '1008',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1170',
                name: '违规干预和插手批办行政许可和资金借贷等',
                children: []
              },
              {
                id: '1171',
                parentId: '1008',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1171',
                name: '违规干预和插手经济纠纷',
                children: []
              },
              {
                id: '1172',
                parentId: '1008',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1172',
                name: '违规干预和插手集体三资使用、分配、承办、租赁等',
                children: []
              },
              {
                id: '1173',
                parentId: '1008',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1173',
                name: '违规干预和插手司法、执纪执法活动等',
                children: []
              },
              {
                id: '1174',
                parentId: '1008',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1174',
                name: '违规干预和插手财政资金分配、使用等',
                children: []
              }
            ]
          },
          {
            id: '1009',
            parentId: '982',
            petitionVal: '0',
            sortValue: '3',
            code: 'wjxw_1009',
            name: '失泄密',
            children: [{
                id: '1175',
                parentId: '1009',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1175',
                name: '泄露、扩散或窃取党组织秘密',
                children: []
              },
              {
                id: '1176',
                parentId: '1009',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1176',
                name: '私存党组织的相关资料',
                children: []
              },
              {
                id: '1177',
                parentId: '1009',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1177',
                name: '在考试、录取工作中泄露试题等',
                children: []
              }
            ]
          },
          {
            id: '1010',
            parentId: '982',
            petitionVal: '0',
            sortValue: '2',
            code: 'wjxw_1010',
            name: '违反外事工作纪律',
            children: [{
                id: '1178',
                parentId: '1010',
                petitionVal: '0',
                sortValue: '5',
                code: 'wjxw_1178',
                name: '以不正当方式谋求公款出国（境)',
                children: []
              },
              {
                id: '1179',
                parentId: '1010',
                petitionVal: '0',
                sortValue: '4',
                code: 'wjxw_1179',
                name: '擅自延长出国（境）期限',
                children: []
              },
              {
                id: '1180',
                parentId: '1010',
                petitionVal: '0',
                sortValue: '3',
                code: 'wjxw_1180',
                name: '擅自变更出国（境）路线',
                children: []
              },
              {
                id: '1181',
                parentId: '1010',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1181',
                name: '触犯驻在国家、地区法律、法令',
                children: []
              },
              {
                id: '1182',
                parentId: '1010',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1182',
                name: '不尊重驻在国家、地区宗教习俗',
                children: []
              }
            ]
          },
          {
            id: '1011',
            parentId: '982',
            petitionVal: '0',
            sortValue: '1',
            code: 'wjxw_1011',
            name: '其他违反工作纪律行为',
            children: []
          }
        ]
      },
      {
        id: '983',
        parentId: '977',
        petitionVal: '0126',
        sortValue: '1',
        code: 'wjxw_983',
        name: '违反生活纪律',
        children: [{
            id: '1012',
            parentId: '983',
            petitionVal: '0',
            sortValue: '3',
            code: 'wjxw_1012',
            name: '生活奢靡',
            children: []
          },
          {
            id: '1013',
            parentId: '983',
            petitionVal: '0',
            sortValue: '2',
            code: 'wjxw_1013',
            name: '违背家庭伦理和社会道德',
            children: [{
                id: '1183',
                parentId: '1013',
                petitionVal: '0',
                sortValue: '2',
                code: 'wjxw_1183',
                name: '与他人发生不正当性关系',
                children: []
              },
              {
                id: '1184',
                parentId: '1013',
                petitionVal: '0',
                sortValue: '1',
                code: 'wjxw_1184',
                name: '违背社会公序良俗',
                children: []
              }
            ]
          },
          {
            id: '1014',
            parentId: '983',
            petitionVal: '0',
            sortValue: '1',
            code: 'wjxw_1014',
            name: '其他违反生活纪律行为',
            children: []
          }
        ]
      }
    ]
  },
  {
    id: '1185',
    parentId: '',
    petitionVal: '0',
    sortValue: '0',
    code: 'sfxw',
    name: '涉法行为',
    children: [{
        id: '1186',
        parentId: '1185',
        petitionVal: '0131',
        sortValue: '6',
        code: 'sfxw_1186',
        name: '贪污贿赂',
        children: [{
            id: '1192',
            parentId: '1186',
            petitionVal: '0',
            sortValue: '7',
            code: 'sfxw_1192',
            name: '贪污',
            children: []
          },
          {
            id: '1193',
            parentId: '1186',
            petitionVal: '0',
            sortValue: '6',
            code: 'sfxw_1193',
            name: '私分国有资产',
            children: []
          },
          {
            id: '1194',
            parentId: '1186',
            petitionVal: '0',
            sortValue: '5',
            code: 'sfxw_1194',
            name: '受贿',
            children: [{
                id: '1215',
                parentId: '1194',
                petitionVal: '0',
                sortValue: '3',
                code: 'sfxw_1215',
                name: '受贿',
                children: []
              },
              {
                id: '1216',
                parentId: '1194',
                petitionVal: '0',
                sortValue: '2',
                code: 'sfxw_1216',
                name: '单位受贿',
                children: []
              },
              {
                id: '1217',
                parentId: '1194',
                petitionVal: '0',
                sortValue: '1',
                code: 'sfxw_1217',
                name: '利用影响力受贿',
                children: []
              }
            ]
          },
          {
            id: '1195',
            parentId: '1186',
            petitionVal: '0',
            sortValue: '4',
            code: 'sfxw_1195',
            name: '行贿',
            children: [{
                id: '1218',
                parentId: '1195',
                petitionVal: '0',
                sortValue: '5',
                code: 'sfxw_1218',
                name: '行贿',
                children: []
              },
              {
                id: '1219',
                parentId: '1195',
                petitionVal: '0',
                sortValue: '4',
                code: 'sfxw_1219',
                name: '对有影响力的人行贿',
                children: []
              },
              {
                id: '1220',
                parentId: '1195',
                petitionVal: '0',
                sortValue: '3',
                code: 'sfxw_1220',
                name: '对单位行贿',
                children: []
              },
              {
                id: '1221',
                parentId: '1195',
                petitionVal: '0',
                sortValue: '2',
                code: 'sfxw_1221',
                name: '介绍贿赂',
                children: []
              },
              {
                id: '1222',
                parentId: '1195',
                petitionVal: '0',
                sortValue: '1',
                code: 'sfxw_1222',
                name: '单位行贿',
                children: []
              }
            ]
          },
          {
            id: '1196',
            parentId: '1186',
            petitionVal: '0',
            sortValue: '3',
            code: 'sfxw_1196',
            name: '挪用公款',
            children: []
          },
          {
            id: '1197',
            parentId: '1186',
            petitionVal: '0',
            sortValue: '2',
            code: 'sfxw_1197',
            name: '巨额财产来源不明',
            children: []
          },
          {
            id: '1198',
            parentId: '1186',
            petitionVal: '0',
            sortValue: '1',
            code: 'sfxw_1198',
            name: '其他贪污贿赂行为',
            children: []
          }
        ]
      },
      {
        id: '1187',
        parentId: '1185',
        petitionVal: '0133',
        sortValue: '5',
        code: 'sfxw_1187',
        name: '破坏社会主义经济秩序',
        children: [{
            id: '1199',
            parentId: '1187',
            petitionVal: '0',
            sortValue: '5',
            code: 'sfxw_1199',
            name: '挪用资金',
            children: []
          },
          {
            id: '1200',
            parentId: '1187',
            petitionVal: '0',
            sortValue: '4',
            code: 'sfxw_1200',
            name: '职务侵占',
            children: []
          },
          {
            id: '1201',
            parentId: '1187',
            petitionVal: '0',
            sortValue: '3',
            code: 'sfxw_1201',
            name: '非国家工作人员受贿',
            children: []
          },
          {
            id: '1202',
            parentId: '1187',
            petitionVal: '0',
            sortValue: '2',
            code: 'sfxw_1202',
            name: '私设“小金库”',
            children: []
          },
          {
            id: '1203',
            parentId: '1187',
            petitionVal: '0',
            sortValue: '1',
            code: 'sfxw_1203',
            name: '其他破坏社会主义经济秩序行为',
            children: []
          }
        ]
      },
      {
        id: '1188',
        parentId: '1185',
        petitionVal: '0132',
        sortValue: '4',
        code: 'sfxw_1188',
        name: '失职渎职',
        children: [{
            id: '1204',
            parentId: '1188',
            petitionVal: '0',
            sortValue: '5',
            code: 'sfxw_1204',
            name: '滥用职权',
            children: []
          },
          {
            id: '1205',
            parentId: '1188',
            petitionVal: '0',
            sortValue: '4',
            code: 'sfxw_1205',
            name: '玩忽职守',
            children: []
          },
          {
            id: '1206',
            parentId: '1188',
            petitionVal: '0',
            sortValue: '3',
            code: 'sfxw_1206',
            name: '徇私枉法',
            children: []
          },
          {
            id: '1207',
            parentId: '1188',
            petitionVal: '0',
            sortValue: '2',
            code: 'sfxw_1207',
            name: '安全责任事故',
            children: []
          },
          {
            id: '1208',
            parentId: '1188',
            petitionVal: '0',
            sortValue: '1',
            code: 'sfxw_1208',
            name: '其他失职渎职行为',
            children: []
          }
        ]
      },
      {
        id: '1189',
        parentId: '1185',
        petitionVal: '0134',
        sortValue: '3',
        code: 'sfxw_1189',
        name: '侵犯公民人身权利民主权利',
        children: []
      },
      {
        id: '1190',
        parentId: '1185',
        petitionVal: '0135',
        sortValue: '2',
        code: 'sfxw_1190',
        name: '妨害社会管理秩序',
        children: [{
            id: '1209',
            parentId: '1190',
            petitionVal: '0',
            sortValue: '6',
            code: 'sfxw_1209',
            name: '嫖娼',
            children: []
          },
          {
            id: '1210',
            parentId: '1190',
            petitionVal: '0',
            sortValue: '5',
            code: 'sfxw_1210',
            name: '赌博',
            children: []
          },
          {
            id: '1211',
            parentId: '1190',
            petitionVal: '0',
            sortValue: '4',
            code: 'sfxw_1211',
            name: '妨碍司法',
            children: []
          },
          {
            id: '1212',
            parentId: '1190',
            petitionVal: '0',
            sortValue: '3',
            code: 'sfxw_1212',
            name: '扰乱公共秩序',
            children: []
          },
          {
            id: '1213',
            parentId: '1190',
            petitionVal: '0',
            sortValue: '2',
            code: 'sfxw_1213',
            name: '违反人口与计划生育法规',
            children: []
          },
          {
            id: '1214',
            parentId: '1190',
            petitionVal: '0',
            sortValue: '1',
            code: 'sfxw_1214',
            name: '其他妨害社会管理秩序行为',
            children: []
          }
        ]
      },
      {
        id: '1191',
        parentId: '1185',
        petitionVal: '0136',
        sortValue: '1',
        code: 'sfxw_1191',
        name: '其他涉法行为',
        children: []
      }
    ]
  },
  {
    id: '1238',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'enterprisepost',
    name: '企业岗位',
    children: [{
        id: '1239',
        parentId: '1238',
        petitionVal: '',
        sortValue: '10',
        code: 'enterprisepost_1239',
        name: '生产经营',
        children: []
      },
      {
        id: '1240',
        parentId: '1238',
        petitionVal: '',
        sortValue: '9',
        code: 'enterprisepost_1240',
        name: '销售采购',
        children: []
      },
      {
        id: '1241',
        parentId: '1238',
        petitionVal: '',
        sortValue: '8',
        code: 'enterprisepost_1241',
        name: '项目管理',
        children: []
      },
      {
        id: '1242',
        parentId: '1238',
        petitionVal: '',
        sortValue: '7',
        code: 'enterprisepost_1242',
        name: '财会管理',
        children: []
      },
      {
        id: '1243',
        parentId: '1238',
        petitionVal: '',
        sortValue: '6',
        code: 'enterprisepost_1243',
        name: '涉外管理',
        children: []
      },
      {
        id: '1244',
        parentId: '1238',
        petitionVal: '',
        sortValue: '5',
        code: 'enterprisepost_1244',
        name: '监督管理',
        children: []
      },
      {
        id: '1245',
        parentId: '1238',
        petitionVal: '',
        sortValue: '4',
        code: 'enterprisepost_1245',
        name: '组织人事',
        children: []
      },
      {
        id: '1246',
        parentId: '1238',
        petitionVal: '',
        sortValue: '3',
        code: 'enterprisepost_1246',
        name: '党群政工',
        children: []
      },
      {
        id: '1247',
        parentId: '1238',
        petitionVal: '',
        sortValue: '2',
        code: 'enterprisepost_1247',
        name: '综合管理',
        children: []
      },
      {
        id: '1248',
        parentId: '1238',
        petitionVal: '',
        sortValue: '1',
        code: 'enterprisepost_1248',
        name: '其他岗位',
        children: []
      }
    ]
  },
  {
    id: '1268',
    parentId: '',
    petitionVal: '1',
    sortValue: '0',
    code: 'beduty',
    name: '是否责任追究',
    children: [{
      id: '1269',
      parentId: '1268',
      petitionVal: '',
      sortValue: '1',
      code: 'beduty_1269',
      name: '是',
      children: []
    }]
  },
  {
    id: '1270',
    parentId: '',
    petitionVal: '1',
    sortValue: '0',
    code: 'besecond',
    name: '二次申诉件',
    children: [{
        id: '1271',
        parentId: '1270',
        petitionVal: '',
        sortValue: '2',
        code: 'besecond_1271',
        name: '是',
        children: []
      },
      {
        id: '1272',
        parentId: '1270',
        petitionVal: '',
        sortValue: '1',
        code: 'besecond_1272',
        name: '否',
        children: []
      }
    ]
  },
  {
    id: '1273',
    parentId: '',
    petitionVal: '1',
    sortValue: '0',
    code: 'besupervis',
    name: '是否监察对象',
    children: [{
        id: '1274',
        parentId: '1273',
        petitionVal: '',
        sortValue: '2',
        code: 'besupervis_1274',
        name: '是',
        children: []
      },
      {
        id: '1275',
        parentId: '1273',
        petitionVal: '',
        sortValue: '1',
        code: 'besupervis_1275',
        name: '否',
        children: []
      }
    ]
  },
  {
    id: '1276',
    parentId: '',
    petitionVal: '1',
    sortValue: '0',
    code: 'casetype',
    name: '是否单位或事件',
    children: [{
        id: '1277',
        parentId: '1276',
        petitionVal: '',
        sortValue: '2',
        code: 'casetype_1277',
        name: '是',
        children: []
      },
      {
        id: '1278',
        parentId: '1276',
        petitionVal: '',
        sortValue: '1',
        code: 'casetype_1278',
        name: '否',
        children: []
      }
    ]
  },
  {
    id: '1279',
    parentId: '',
    petitionVal: '1',
    sortValue: '0',
    code: 'isdelay',
    name: '是否延期',
    children: [{
        id: '1280',
        parentId: '1279',
        petitionVal: '',
        sortValue: '2',
        code: 'isdelay_1280',
        name: '是',
        children: []
      },
      {
        id: '1281',
        parentId: '1279',
        petitionVal: '',
        sortValue: '1',
        code: 'isdelay_1281',
        name: '否',
        children: []
      }
    ]
  },
  {
    id: '1282',
    parentId: '',
    petitionVal: '1',
    sortValue: '0',
    code: 'mainmark',
    name: '统计标志记录',
    children: [{
      id: '1283',
      parentId: '1282',
      petitionVal: '',
      sortValue: '1',
      code: 'mainmark_1283',
      name: '是',
      children: []
    }]
  },
  {
    id: '1284',
    parentId: '',
    petitionVal: '1',
    sortValue: '0',
    code: 'repeated',
    name: '重复线索标识',
    children: [{
      id: '1285',
      parentId: '1284',
      petitionVal: '',
      sortValue: '1',
      code: 'repeated_1285',
      name: '是',
      children: []
    }]
  },
  {
    id: '1286',
    parentId: '',
    petitionVal: '1',
    sortValue: '0',
    code: 'servant',
    name: '公务员',
    children: [{
        id: '1287',
        parentId: '1286',
        petitionVal: '',
        sortValue: '2',
        code: 'servant_1287',
        name: '是',
        children: []
      },
      {
        id: '1288',
        parentId: '1286',
        petitionVal: '',
        sortValue: '1',
        code: 'servant_1288',
        name: '否',
        children: []
      }
    ]
  },
  {
    id: '1295',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'marriage',
    name: '婚姻状况',
    children: [{
        id: '1296',
        parentId: '1295',
        petitionVal: '',
        sortValue: '4',
        code: 'marriage_1296',
        name: '未婚',
        children: []
      },
      {
        id: '1298',
        parentId: '1295',
        petitionVal: '',
        sortValue: '3',
        code: 'marriage_1298',
        name: '已婚',
        children: []
      },
      {
        id: '1299',
        parentId: '1295',
        petitionVal: '',
        sortValue: '2',
        code: 'marriage_1299',
        name: '离异',
        children: []
      },
      {
        id: '1300',
        parentId: '1295',
        petitionVal: '',
        sortValue: '1',
        code: 'marriage_1300',
        name: '丧偶',
        children: []
      }
    ]
  },
  {
    id: '1301',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'job_status',
    name: '在职状态',
    children: [{
        id: '1302',
        parentId: '1301',
        petitionVal: '',
        sortValue: '2',
        code: 'job_status_1302',
        name: '在职',
        children: []
      },
      {
        id: '1303',
        parentId: '1301',
        petitionVal: '',
        sortValue: '1',
        code: 'job_status_1303',
        name: '离岗未退',
        children: []
      }
    ]
  },
  {
    id: '1304',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'company_type',
    name: '企业类型',
    children: [{
        id: '1305',
        parentId: '1304',
        petitionVal: '',
        sortValue: '4',
        code: 'company_type_1305',
        name: '个体工商户',
        children: []
      },
      {
        id: '1306',
        parentId: '1304',
        petitionVal: '',
        sortValue: '3',
        code: 'company_type_1306',
        name: '个人独资企业',
        children: []
      },
      {
        id: '1307',
        parentId: '1304',
        petitionVal: '',
        sortValue: '2',
        code: 'company_type_1307',
        name: '合伙企业',
        children: []
      },
      {
        id: '1308',
        parentId: '1304',
        petitionVal: '',
        sortValue: '1',
        code: 'company_type_1308',
        name: '农民专业合作社',
        children: []
      }
    ]
  },
  {
    id: '1309',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'check_result',
    name: '考核结果',
    children: [{
        id: '1310',
        parentId: '1309',
        petitionVal: '',
        sortValue: '4',
        code: 'check_result_1310',
        name: '优秀',
        children: []
      },
      {
        id: '1311',
        parentId: '1309',
        petitionVal: '',
        sortValue: '3',
        code: 'check_result_1311',
        name: '称职（合格）',
        children: []
      },
      {
        id: '1312',
        parentId: '1309',
        petitionVal: '',
        sortValue: '2',
        code: 'check_result_1312',
        name: '基本称职（基本合格）',
        children: []
      },
      {
        id: '1313',
        parentId: '1309',
        petitionVal: '',
        sortValue: '1',
        code: 'check_result_1313',
        name: '不称职（不合格）',
        children: []
      }
    ]
  },
  {
    id: '1314',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'law_info',
    name: '法律追究情况',
    children: [{
        id: '1315',
        parentId: '1314',
        petitionVal: '',
        sortValue: '2',
        code: 'law_info_1315',
        name: '移送',
        children: []
      },
      {
        id: '1316',
        parentId: '1314',
        petitionVal: '',
        sortValue: '1',
        code: 'law_info_1316',
        name: '判刑',
        children: []
      }
    ]
  },
  {
    id: '1317',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'unit_type',
    name: '单位性质',
    children: [{
        id: '1585',
        parentId: '1317',
        petitionVal: '',
        sortValue: '12',
        code: 'unit_type_1585',
        name: '无业',
        children: []
      },
      {
        id: '1327',
        parentId: '1317',
        petitionVal: '',
        sortValue: '11',
        code: 'unit_type_1327',
        name: '国境外',
        children: []
      },
      {
        id: '1326',
        parentId: '1317',
        petitionVal: '',
        sortValue: '10',
        code: 'unit_type_1326',
        name: '其他职业',
        children: []
      },
      {
        id: '1603',
        parentId: '1317',
        petitionVal: '',
        sortValue: '9',
        code: 'unit_type_1603',
        name: '境外非政府组织的境内代表机构',
        children: []
      },
      {
        id: '1321',
        parentId: '1317',
        petitionVal: '',
        sortValue: '8',
        code: 'unit_type_1321',
        name: '中外合资企业',
        children: []
      },
      {
        id: '1322',
        parentId: '1317',
        petitionVal: '',
        sortValue: '7',
        code: 'unit_type_1322',
        name: '外商独资企业',
        children: []
      },
      {
        id: '1323',
        parentId: '1317',
        petitionVal: '',
        sortValue: '6',
        code: 'unit_type_1323',
        name: '私营企业',
        children: []
      },
      {
        id: '1325',
        parentId: '1317',
        petitionVal: '',
        sortValue: '5',
        code: 'unit_type_1325',
        name: '学生',
        children: []
      },
      {
        id: '1324',
        parentId: '1317',
        petitionVal: '',
        sortValue: '4',
        code: 'unit_type_1324',
        name: '军队',
        children: []
      },
      {
        id: '1320',
        parentId: '1317',
        petitionVal: '',
        sortValue: '3',
        code: 'unit_type_1320',
        name: '国有企业',
        children: []
      },
      {
        id: '1319',
        parentId: '1317',
        petitionVal: '',
        sortValue: '2',
        code: 'unit_type_1319',
        name: '事业单位',
        children: []
      },
      {
        id: '1318',
        parentId: '1317',
        petitionVal: '',
        sortValue: '1',
        code: 'unit_type_1318',
        name: '党政机关',
        children: []
      }
    ]
  },
  {
    id: '1328',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'family_type',
    name: '与本人关系',
    children: [{
        id: '1444',
        parentId: '1328',
        petitionVal: '',
        sortValue: '22',
        code: 'family_title_1444',
        name: '本人',
        children: []
      },
      {
        id: '1332',
        parentId: '1328',
        petitionVal: '',
        sortValue: '21',
        code: 'family_type_1332',
        name: '配偶',
        children: []
      },
      {
        id: '1626',
        parentId: '1328',
        petitionVal: '',
        sortValue: '20',
        code: 'family_type_1626',
        name: '父亲',
        children: []
      },
      {
        id: '1627',
        parentId: '1328',
        petitionVal: '',
        sortValue: '19',
        code: 'family_type_1627',
        name: '母亲',
        children: []
      },
      {
        id: '1628',
        parentId: '1328',
        petitionVal: '',
        sortValue: '18',
        code: 'family_type_1628',
        name: '岳父',
        children: []
      },
      {
        id: '1629',
        parentId: '1328',
        petitionVal: '',
        sortValue: '17',
        code: 'family_type_1629',
        name: '岳母',
        children: []
      },
      {
        id: '1630',
        parentId: '1328',
        petitionVal: '',
        sortValue: '16',
        code: 'family_type_1630',
        name: '公公',
        children: []
      },
      {
        id: '1631',
        parentId: '1328',
        petitionVal: '',
        sortValue: '15',
        code: 'family_type_1631',
        name: '婆婆',
        children: []
      },
      {
        id: '1632',
        parentId: '1328',
        petitionVal: '',
        sortValue: '14',
        code: 'family_type_1632',
        name: '哥哥',
        children: []
      },
      {
        id: '1633',
        parentId: '1328',
        petitionVal: '',
        sortValue: '13',
        code: 'family_type_1633',
        name: '弟弟',
        children: []
      },
      {
        id: '1634',
        parentId: '1328',
        petitionVal: '',
        sortValue: '12',
        code: 'family_type_1634',
        name: '姐姐',
        children: []
      },
      {
        id: '1635',
        parentId: '1328',
        petitionVal: '',
        sortValue: '11',
        code: 'family_type_1635',
        name: '妹妹',
        children: []
      },
      {
        id: '1329',
        parentId: '1328',
        petitionVal: '',
        sortValue: '10',
        code: 'family_type_1329',
        name: '父母',
        children: []
      },
      {
        id: '1330',
        parentId: '1328',
        petitionVal: '',
        sortValue: '9',
        code: 'family_type_1330',
        name: '岳父母（公婆）',
        children: []
      },
      {
        id: '1331',
        parentId: '1328',
        petitionVal: '',
        sortValue: '8',
        code: 'family_type_1331',
        name: '兄弟姐妹',
        children: []
      },
      {
        id: '1333',
        parentId: '1328',
        petitionVal: '',
        sortValue: '7',
        code: 'family_type_1333',
        name: '子女',
        children: []
      },
      {
        id: '1334',
        parentId: '1328',
        petitionVal: '',
        sortValue: '6',
        code: 'family_type_1334',
        name: '子女配偶',
        children: []
      },
      {
        id: '1531',
        parentId: '1328',
        petitionVal: '',
        sortValue: '4',
        code: 'family_type_1531',
        name: '儿子',
        children: []
      },
      {
        id: '1532',
        parentId: '1328',
        petitionVal: '',
        sortValue: '3',
        code: 'family_type_1532',
        name: '女儿',
        children: []
      },
      {
        id: '1597',
        parentId: '1328',
        petitionVal: '',
        sortValue: '2',
        code: 'family_type_1597',
        name: '儿媳',
        children: []
      },
      {
        id: '1599',
        parentId: '1328',
        petitionVal: '',
        sortValue: '1',
        code: 'family_type_1599',
        name: '女婿',
        children: []
      }
    ]
  },
  {
    id: '1335',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'family_title',
    name: '称谓',
    children: [{
        id: '1336',
        parentId: '1335',
        petitionVal: '',
        sortValue: '3',
        code: 'family_title_1336',
        name: '配偶',
        children: []
      },
      {
        id: '1337',
        parentId: '1335',
        petitionVal: '',
        sortValue: '2',
        code: 'family_title_1337',
        name: '儿子',
        children: []
      },
      {
        id: '1338',
        parentId: '1335',
        petitionVal: '',
        sortValue: '1',
        code: 'family_title_1338',
        name: '女儿',
        children: []
      }
    ]
  },
  {
    id: '1339',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'property_change',
    name: '房产来源(去向);',
    children: [{
        id: '1340',
        parentId: '1339',
        petitionVal: '',
        sortValue: '7',
        code: 'property_change_1340',
        name: '购买',
        children: []
      },
      {
        id: '1341',
        parentId: '1339',
        petitionVal: '',
        sortValue: '6',
        code: 'property_change_1341',
        name: '继承',
        children: []
      },
      {
        id: '1342',
        parentId: '1339',
        petitionVal: '',
        sortValue: '5',
        code: 'property_change_1342',
        name: '接收赠与',
        children: []
      },
      {
        id: '1343',
        parentId: '1339',
        petitionVal: '',
        sortValue: '4',
        code: 'property_change_1343',
        name: '其他来源',
        children: []
      },
      {
        id: '1344',
        parentId: '1339',
        petitionVal: '',
        sortValue: '3',
        code: 'property_change_1344',
        name: '出售',
        children: []
      },
      {
        id: '1345',
        parentId: '1339',
        petitionVal: '',
        sortValue: '2',
        code: 'property_change_1345',
        name: '赠与他人',
        children: []
      },
      {
        id: '1346',
        parentId: '1339',
        petitionVal: '',
        sortValue: '1',
        code: 'property_change_1346',
        name: '其他去向',
        children: []
      }
    ]
  },
  {
    id: '1347',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'property_type',
    name: '产权性质',
    children: [{
        id: '1348',
        parentId: '1347',
        petitionVal: '',
        sortValue: '7',
        code: 'property_type_1348',
        name: '商品房',
        children: []
      },
      {
        id: '1349',
        parentId: '1347',
        petitionVal: '',
        sortValue: '6',
        code: 'property_type_1349',
        name: '福利房',
        children: []
      },
      {
        id: '1350',
        parentId: '1347',
        petitionVal: '',
        sortValue: '5',
        code: 'property_type_1350',
        name: '经济适用房',
        children: []
      },
      {
        id: '1351',
        parentId: '1347',
        petitionVal: '',
        sortValue: '4',
        code: 'property_type_1351',
        name: '限价房',
        children: []
      },
      {
        id: '1352',
        parentId: '1347',
        petitionVal: '',
        sortValue: '3',
        code: 'property_type_1352',
        name: '自建房',
        children: []
      },
      {
        id: '1353',
        parentId: '1347',
        petitionVal: '',
        sortValue: '2',
        code: 'property_type_1353',
        name: '车库、车位、储藏间',
        children: []
      },
      {
        id: '1354',
        parentId: '1347',
        petitionVal: '',
        sortValue: '1',
        code: 'property_type_1354',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '1328',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'gbglqx',
    name: '干部管理权限',
    children: [{
        id: '454',
        parentId: '1328',
        petitionVal: '',
        sortValue: '5',
        code: 'gbglqx_454',
        name: '中管干部',
        children: []
      },
      {
        id: '455',
        parentId: '1328',
        petitionVal: '',
        sortValue: '4',
        code: 'gbglqx_455',
        name: '省管干部',
        children: []
      },
      {
        id: '456',
        parentId: '1328',
        petitionVal: '',
        sortValue: '3',
        code: 'gbglqx_456',
        name: '市管干部',
        children: []
      },
      {
        id: '457',
        parentId: '1328',
        petitionVal: '',
        sortValue: '2',
        code: 'gbglqx_457',
        name: '县管干部',
        children: []
      },
      {
        id: '458',
        parentId: '1328',
        petitionVal: '',
        sortValue: '1',
        code: 'gbglqx_458',
        name: '均不是',
        children: []
      }
    ]
  },
  {
    code: 'rank_detail_province',
    id: '9190',
    name: '职级详情',
    parentId: '0',
    children: [
      { code: 'rank_detail_9191', id: '9191', name: '省管正职', parentId: '9190' },
      { code: 'rank_detail_9192', id: '9192', name: '省管副职', parentId: '9190' },
      { code: 'rank_detail_9193', id: '9193', name: '其他省管干部', parentId: '9190' },
      { code: 'rank_detail_9194', id: '9194', name: '非省管干部', parentId: '9190' }
    ],
  },
  { // 任职情况
    code: 'rank_position',
    id: '9230',
    name: '任职情况',
    parentId: '0',
    children: [{
        code: 'rank_position_9231',
        id: '9231',
        name: '现职',
        parentId: '9230'
      },
      {
        code: 'rank_position_9232',
        id: '9232',
        name: '前任职',
        parentId: '9230'
      },
      {
        code: 'rank_position_9233',
        id: '9233',
        name: '退休',
        parentId: '9230'
      }
    ],
  },
  {
    code: 'ccp_representative',
    id: '1559',
    name: '中共党代表',
    parentId: '0',
    children: [{
        code: 'ccp_representative_1561',
        id: '1561',
        name: '否',
        parentId: '1559'
      },
      {
        code: 'ccp_representative_1562',
        id: '1562',
        name: '全国党代会代表',
        parentId: '1559'
      },
      {
        code: 'ccp_representative_1563',
        id: '1563',
        name: '省级党代会代表',
        parentId: '1559'
      },
      {
        code: 'ccp_representative_1564',
        id: '1564',
        name: '市级党代会代表',
        parentId: '1559'
      },
      {
        code: 'ccp_representative_1565',
        id: '1565',
        name: '县级党代会代表',
        parentId: '1559'
      },
      {
        code: 'ccp_representative_1566',
        id: '1566',
        name: '乡级党代会代表',
        parentId: '1559'
      }
    ],
  },
  {
    code: 'is_supervisory_party',
    id: '1511',
    name: '是否非党员非监察对象',
    parentId: '0',
    children: [{
        code: 'is_supervisory_party_1515',
        id: '1515',
        name: '涉嫌行贿的人员',
        parentId: '1512'
      },
      {
        code: 'is_supervisory_party_1516',
        id: '1516',
        name: '涉嫌共同职务违法犯罪的人员',
        parentId: '1512'
      },
      {
        code: 'is_supervisory_party_1517',
        id: '1517',
        name: '其他',
        parentId: '1512'
      }
    ],
  },
  {
    code: 'is_supervisory',
    id: '1612',
    name: '是否国家监察对象',
    parentId: '0',
    children: [{
        code: 'second_supervisory_1505',
        id: '1505',
        name: '公务员及参公管理人员',
        parentId: '1613'
      },
      {
        code: 'second_supervisory_1506',
        id: '1506',
        name: '授权或受委托从事公务人员',
        parentId: '1613'
      },
      {
        code: 'second_supervisory_1507',
        id: '1507',
        name: '国有企业管理人员',
        parentId: '1613'
      },
      {
        code: 'second_supervisory_1508',
        id: '1508',
        name: '公办事业单位管理人员',
        parentId: '1613'
      },
      {
        code: 'second_supervisory_1509',
        id: '1509',
        name: '自治组织管理人员',
        parentId: '1613'
      },
      {
        code: 'second_supervisory_1510',
        id: '1510',
        name: '其他履行公职人员',
        parentId: '1613'
      },
      {
        code: 'second_supervisory_1514',
        id: '1514',
        name: '非监察对象',
        parentId: '1613'
      }
    ],

  },
  {
    code: 'rank',
    id: '331',
    name: '职级',
    parentId: '0',
    children: [{
        code: 'rank_332',
        id: '332',
        name: '省部级及以上',
        parentId: '331',
        children: [{
            'code': 'rank_338',
            'id': '338',
            'name': '领导职务正级',
            'parentId': '332'
          },
          {
            'code': 'rank_339',
            'id': '339',
            'name': '非领导职务正级',
            'parentId': '332'
          },
          {
            'code': 'rank_340',
            'id': '340',
            'name': '领导职务副级',
            'parentId': '332'
          },
          {
            'code': 'rank_341',
            'id': '341',
            'name': '非领导职务副级',
            'parentId': '332'
          },
          {
            'code': 'rank_848',
            'id': '848',
            'name': '正级',
            'parentId': '332'
          },
          {
            'code': 'rank_849',
            'id': '849',
            'name': '副级',
            'parentId': '332'
          },
          {
            'code': 'cluesecondrank_946',
            'id': '946',
            'name': '正省部级以上',
            'parentId': '332'
          },
          {
            'code': 'cluesecondrank_947',
            'id': '947',
            'name': '正省部级',
            'parentId': '332'
          },
          {
            'code': 'cluesecondrank_948',
            'id': '948',
            'name': '副省部级',
            'parentId': '332'
          },
          {
            'code': 'cluesecondrank_949',
            'id': '949',
            'name': '中管企业主要负责人',
            'parentId': '332'
          },
          {
            'code': 'cluesecondrank_950',
            'id': '950',
            'name': '中央金融机构正职',
            'parentId': '332'
          },
          {
            'code': 'cluesecondrank_951',
            'id': '951',
            'name': '中央金融机构副职',
            'parentId': '332'
          }
        ]
      },
      {
        code: 'rank_333',
        id: '333',
        name: '厅局级',
        parentId: '331',
        children: [{
            'code': 'rank_342',
            'id': '342',
            'name': '领导职务正级',
            'parentId': '333'
          },
          {
            'code': 'rank_343',
            'id': '343',
            'name': '非领导职务正级',
            'parentId': '333'
          },
          {
            'code': 'rank_344',
            'id': '344',
            'name': '领导职务副级',
            'parentId': '333'
          },
          {
            'code': 'rank_345',
            'id': '345',
            'name': '非领导职务副级',
            'parentId': '333'
          },
          {
            'code': 'rank_850',
            'id': '850',
            'name': '正级',
            'parentId': '333'
          },
          {
            'code': 'rank_851',
            'id': '851',
            'name': '副级',
            'parentId': '333'
          },
          {
            'code': 'cluesecondrank_952',
            'id': '952',
            'name': '正地厅级',
            'parentId': '333'
          },
          {
            'code': 'cluesecondrank_953',
            'id': '953',
            'name': '副地厅级',
            'parentId': '333'
          }
        ]
      },
      {
        code: 'rank_334',
        id: '334',
        name: '县处级',
        parentId: '331',
        children: [{
            'code': 'rank_346',
            'id': '346',
            'name': '领导职务正级',
            'parentId': '334'
          },
          {
            'code': 'rank_347',
            'id': '347',
            'name': '非领导职务正级',
            'parentId': '334'
          },
          {
            'code': 'rank_348',
            'id': '348',
            'name': '领导职务副级',
            'parentId': '334'
          },
          {
            'code': 'rank_349',
            'id': '349',
            'name': '非领导职务副级',
            'parentId': '334'
          },
          {
            'code': 'rank_852',
            'id': '852',
            'name': '正级',
            'parentId': '334'
          },
          {
            'code': 'rank_853',
            'id': '853',
            'name': '副级',
            'parentId': '334'
          },
          {
            'code': 'cluesecondrank_954',
            'id': '954',
            'name': '正县处级',
            'parentId': '334'
          },
          {
            'code': 'cluesecondrank_955',
            'id': '955',
            'name': '副县处级',
            'parentId': '334'
          }
        ]
      },
      {
        code: 'rank_335',
        id: '335',
        name: '乡科级',
        parentId: '331',
        children: [
          { 'code': 'rank_350', 'id': '350', 'name': '领导职务正级', 'parentId': '335' },
          { 'code': 'rank_351', 'id': '351', 'name': '非领导职务正级', 'parentId': '335' },
          { 'code': 'rank_352', 'id': '352', 'name': '领导职务副级', 'parentId': '335' },
          { 'code': 'rank_353', 'id': '353', 'name': '非领导职务副级', 'parentId': '335' },
          { 'code': 'rank_854', 'id': '854', 'name': '正级', 'parentId': '335' },
          { 'code': 'rank_855', 'id': '855', 'name': '副级', 'parentId': '335' },
          { 'code': 'cluesecondrank_956', 'id': '956', 'name': '正乡科级', 'parentId': '335' },
          { 'code': 'cluesecondrank_957', 'id': '957', 'name': '副乡科级', 'parentId': '335' }
        ]
      },
      { code: 'rank_336', id: '336', name: '一般干部', parentId: '331', children: [] },
      {
        code: 'rank_337',
        id: '337',
        name: '其他人员',
        parentId: '331',
        children: [{
            'code': 'rank_354',
            'id': '354',
            'name': '军队',
            'parentId': '337'
          },
          {
            'code': 'rank_355',
            'id': '355',
            'name': '企业',
            'parentId': '337'
          },
          {
            'code': 'rank_356',
            'id': '356',
            'name': '农村',
            'parentId': '337'
          },
          {
            'code': 'rank_357',
            'id': '357',
            'name': '其他',
            'parentId': '337'
          }
        ]
      }
    ],
  },
  {
    id: '1361',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'cer_type',
    name: '证件类型',
    children: [{
        id: '1362',
        parentId: '1361',
        petitionVal: '',
        sortValue: '4',
        code: 'cer_type_1362',
        name: '普通护照',
        children: []
      },
      {
        id: '1363',
        parentId: '1361',
        petitionVal: '',
        sortValue: '3',
        code: 'cer_type_1363',
        name: '内地居民往来港澳通行证',
        children: []
      },
      {
        id: '1364',
        parentId: '1361',
        petitionVal: '',
        sortValue: '2',
        code: 'cer_type_1364',
        name: '大陆居民往来台湾通行证',
        children: []
      },
      {
        id: '1365',
        parentId: '1361',
        petitionVal: '',
        sortValue: '1',
        code: 'cer_type_1365',
        name: '其他出国（境）证件',
        children: []
      }
    ]
  },
  {
    id: '1366',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'imm_type',
    name: '移居类别',
    children: [{
        id: '1604',
        parentId: '1366',
        petitionVal: '',
        sortValue: '4',
        code: 'imm_type_1604',
        name: '未移居国（境）外，但连续在国（境）外工作、生活(含学习)一年以上',
        children: []
      },
      {
        id: '1369',
        parentId: '1366',
        petitionVal: '',
        sortValue: '3',
        code: 'imm_type_1369',
        name: '长期居留许可',
        children: []
      },
      {
        id: '1368',
        parentId: '1366',
        petitionVal: '',
        sortValue: '2',
        code: 'imm_type_1368',
        name: '永久居住资格',
        children: []
      },
      {
        id: '1367',
        parentId: '1366',
        petitionVal: '',
        sortValue: '1',
        code: 'imm_type_1367',
        name: '外国国籍',
        children: []
      }
    ]
  },
  {
    id: '1370',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'handle_stage',
    name: '处理阶段',
    children: [{
        id: '1371',
        parentId: '1370',
        petitionVal: '',
        sortValue: '6',
        code: 'handle_stage_1371',
        name: '立案侦查',
        children: []
      },
      {
        id: '1372',
        parentId: '1370',
        petitionVal: '',
        sortValue: '5',
        code: 'handle_stage_1372',
        name: '审查起诉',
        children: []
      },
      {
        id: '1373',
        parentId: '1370',
        petitionVal: '',
        sortValue: '4',
        code: 'handle_stage_1373',
        name: '刑事审判',
        children: []
      },
      {
        id: '1374',
        parentId: '1370',
        petitionVal: '',
        sortValue: '3',
        code: 'handle_stage_1374',
        name: '刑罚执行',
        children: []
      },
      {
        id: '1605',
        parentId: '1370',
        petitionVal: '',
        sortValue: '2',
        code: 'handle_stage_1605',
        name: '执行完毕',
        children: []
      },
      {
        id: '1375',
        parentId: '1370',
        petitionVal: '',
        sortValue: '1',
        code: 'handle_stage_1375',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '1376',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'accountability_stauts',
    name: '责任追究情况',
    children: [{
        id: '1377',
        parentId: '1376',
        petitionVal: '',
        sortValue: '3',
        code: 'accountability_stauts_1377',
        name: '党纪处分',
        children: []
      },
      {
        id: '1378',
        parentId: '1376',
        petitionVal: '',
        sortValue: '2',
        code: 'accountability_stauts_1378',
        name: '政务处分',
        children: []
      },
      {
        id: '1379',
        parentId: '1376',
        petitionVal: '',
        sortValue: '1',
        code: 'accountability_stauts_1379',
        name: '组织处理',
        children: []
      }
    ]
  },
  {
    id: '1380',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'is_team',
    name: '班子成员',
    children: [{
        id: '1381',
        parentId: '1380',
        petitionVal: '',
        sortValue: '2',
        code: 'is_team_1381',
        name: '是',
        children: []
      },
      {
        id: '1382',
        parentId: '1380',
        petitionVal: '',
        sortValue: '1',
        code: 'is_team_1382',
        name: '否',
        children: []
      }
    ]
  },
  {
    id: '1383',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'change_flag',
    name: '有无变化',
    children: [{
        id: '1384',
        parentId: '1383',
        petitionVal: '',
        sortValue: '2',
        code: 'change_flag_1384',
        name: '是',
        children: []
      },
      {
        id: '1385',
        parentId: '1383',
        petitionVal: '',
        sortValue: '1',
        code: 'change_flag_1385',
        name: '否',
        children: []
      }
    ]
  },
  {
    id: '1421',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'stock_type',
    name: '金融理财产品类型',
    children: [{
        id: '1422',
        parentId: '1421',
        petitionVal: '',
        sortValue: '4',
        code: 'stock_type_1422',
        name: '股票',
        children: []
      },
      {
        id: '1423',
        parentId: '1421',
        petitionVal: '',
        sortValue: '3',
        code: 'stock_type_1423',
        name: '基金',
        children: []
      },
      {
        id: '1424',
        parentId: '1421',
        petitionVal: '',
        sortValue: '2',
        code: 'stock_type_1424',
        name: '保险',
        children: []
      },
      {
        id: '1425',
        parentId: '1421',
        petitionVal: '',
        sortValue: '1',
        code: 'stock_type_1425',
        name: '其他理财产品',
        children: []
      }
    ]
  },
  {
    id: '1426',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'issue_type',
    name: '问题归类',
    children: [{
        id: '1427',
        parentId: '1426',
        petitionVal: '',
        sortValue: '7',
        code: 'issue_type_1427',
        name: '政治纪律',
        children: []
      },
      {
        id: '1428',
        parentId: '1426',
        petitionVal: '',
        sortValue: '6',
        code: 'issue_type_1428',
        name: '组织纪律',
        children: []
      },
      {
        id: '1429',
        parentId: '1426',
        petitionVal: '',
        sortValue: '5',
        code: 'issue_type_1429',
        name: '廉洁纪律',
        children: []
      },
      {
        id: '1430',
        parentId: '1426',
        petitionVal: '',
        sortValue: '4',
        code: 'issue_type_1430',
        name: '群众纪律',
        children: []
      },
      {
        id: '1431',
        parentId: '1426',
        petitionVal: '',
        sortValue: '3',
        code: 'issue_type_1431',
        name: '工作纪律',
        children: []
      },
      {
        id: '1432',
        parentId: '1426',
        petitionVal: '',
        sortValue: '2',
        code: 'issue_type_1432',
        name: '生活纪律',
        children: []
      },
      {
        id: '1433',
        parentId: '1426',
        petitionVal: '',
        sortValue: '1',
        code: 'issue_type_1433',
        name: '涉法行为',
        children: []
      }
    ]
  },
  {
    id: '1434',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'organize_handle',
    name: '组织处理',
    children: [{
        id: '1435',
        parentId: '1434',
        petitionVal: '',
        sortValue: '4',
        code: 'organize_handle_1435',
        name: '批评教育',
        children: []
      },
      {
        id: '1436',
        parentId: '1434',
        petitionVal: '',
        sortValue: '3',
        code: 'organize_handle_1436',
        name: '警示谈话',
        children: []
      },
      {
        id: '1437',
        parentId: '1434',
        petitionVal: '',
        sortValue: '2',
        code: 'organize_handle_1437',
        name: '停职检查',
        children: []
      },
      {
        id: '1438',
        parentId: '1434',
        petitionVal: '',
        sortValue: '1',
        code: 'organize_handle_1438',
        name: '免职',
        children: []
      }
    ]
  },
  {
    id: '1439',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'appraisal',
    name: '测评情况',
    children: [{
        id: '1440',
        parentId: '1439',
        petitionVal: '',
        sortValue: '4',
        code: 'appraisal_1440',
        name: '优',
        children: []
      },
      {
        id: '1441',
        parentId: '1439',
        petitionVal: '',
        sortValue: '3',
        code: 'appraisal_1441',
        name: '良',
        children: []
      },
      {
        id: '1442',
        parentId: '1439',
        petitionVal: '',
        sortValue: '2',
        code: 'appraisal_1442',
        name: '一般',
        children: []
      },
      {
        id: '1443',
        parentId: '1439',
        petitionVal: '',
        sortValue: '1',
        code: 'appraisal_1443',
        name: '差',
        children: []
      }
    ]
  },
  {
    id: '1445',
    parentId: '',
    petitionVal: '',
    sortValue: '0',
    code: 'trade',
    name: '行业',
    children: [{
        id: '1480',
        parentId: '1445',
        petitionVal: '',
        sortValue: '35',
        code: 'trade_1480',
        name: '国土',
        children: [{
            id: '1777',
            parentId: '1480',
            petitionVal: '',
            sortValue: '4',
            code: 'khpjjg_1777',
            name: '较差',
            children: []
          },
          {
            id: '1776',
            parentId: '1480',
            petitionVal: '',
            sortValue: '3',
            code: 'khpjjg_1776',
            name: '一般',
            children: []
          },
          {
            id: '1775',
            parentId: '1480',
            petitionVal: '',
            sortValue: '2',
            code: 'khpjjg_1775',
            name: '较好',
            children: []
          },
          {
            id: '1774',
            parentId: '1480',
            petitionVal: '',
            sortValue: '1',
            code: 'khpjjg_1774',
            name: '好',
            children: []
          }
        ]
      },
      {
        id: '1481',
        parentId: '1445',
        petitionVal: '',
        sortValue: '34',
        code: 'trade_1481',
        name: '交通',
        children: []
      },
      {
        id: '1482',
        parentId: '1445',
        petitionVal: '',
        sortValue: '33',
        code: 'trade_1482',
        name: '教育',
        children: []
      },
      {
        id: '1483',
        parentId: '1445',
        petitionVal: '',
        sortValue: '32',
        code: 'trade_1483',
        name: '卫生',
        children: []
      },
      {
        id: '1484',
        parentId: '1445',
        petitionVal: '',
        sortValue: '31',
        code: 'trade_1484',
        name: '社保',
        children: []
      },
      {
        id: '1485',
        parentId: '1445',
        petitionVal: '',
        sortValue: '30',
        code: 'trade_1485',
        name: '财政',
        children: []
      },
      {
        id: '1486',
        parentId: '1445',
        petitionVal: '',
        sortValue: '29',
        code: 'trade_1486',
        name: '公安',
        children: []
      },
      {
        id: '1487',
        parentId: '1445',
        petitionVal: '',
        sortValue: '28',
        code: 'trade_1487',
        name: '检察',
        children: []
      },
      {
        id: '1488',
        parentId: '1445',
        petitionVal: '',
        sortValue: '27',
        code: 'trade_1488',
        name: '法院',
        children: []
      },
      {
        id: '1489',
        parentId: '1445',
        petitionVal: '',
        sortValue: '26',
        code: 'trade_1489',
        name: '工商',
        children: []
      },
      {
        id: '1490',
        parentId: '1445',
        petitionVal: '',
        sortValue: '25',
        code: 'trade_1490',
        name: '税务',
        children: []
      },
      {
        id: '1491',
        parentId: '1445',
        petitionVal: '',
        sortValue: '24',
        code: 'trade_1491',
        name: '住建',
        children: []
      },
      {
        id: '1492',
        parentId: '1445',
        petitionVal: '',
        sortValue: '23',
        code: 'trade_1492',
        name: '财政',
        children: []
      },
      {
        id: '1493',
        parentId: '1445',
        petitionVal: '',
        sortValue: '22',
        code: 'trade_1493',
        name: '水利',
        children: []
      },
      {
        id: '1494',
        parentId: '1445',
        petitionVal: '',
        sortValue: '21',
        code: 'trade_1494',
        name: '民政',
        children: []
      },
      {
        id: '1446',
        parentId: '1445',
        petitionVal: '',
        sortValue: '20',
        code: 'trade_1446',
        name: '农、林、牧、渔业',
        children: []
      },
      {
        id: '1447',
        parentId: '1445',
        petitionVal: '',
        sortValue: '19',
        code: 'trade_1447',
        name: '采矿业',
        children: []
      },
      {
        id: '1448',
        parentId: '1445',
        petitionVal: '',
        sortValue: '18',
        code: 'trade_1448',
        name: '制造业',
        children: []
      },
      {
        id: '1449',
        parentId: '1445',
        petitionVal: '',
        sortValue: '17',
        code: 'trade_1449',
        name: '电力、热力、燃气及水生产和供应业',
        children: []
      },
      {
        id: '1450',
        parentId: '1445',
        petitionVal: '',
        sortValue: '16',
        code: 'trade_1450',
        name: '建筑业',
        children: []
      },
      {
        id: '1451',
        parentId: '1445',
        petitionVal: '',
        sortValue: '15',
        code: 'trade_1451',
        name: '批发和零售业',
        children: []
      },
      {
        id: '1452',
        parentId: '1445',
        petitionVal: '',
        sortValue: '14',
        code: 'trade_1452',
        name: '交通运输、仓储和邮政业',
        children: []
      },
      {
        id: '1453',
        parentId: '1445',
        petitionVal: '',
        sortValue: '13',
        code: 'trade_1453',
        name: '住宿和餐饮业',
        children: []
      },
      {
        id: '1454',
        parentId: '1445',
        petitionVal: '',
        sortValue: '12',
        code: 'trade_1454',
        name: '信息传输、软件和信息技术服务业',
        children: []
      },
      {
        id: '1455',
        parentId: '1445',
        petitionVal: '',
        sortValue: '11',
        code: 'trade_1455',
        name: '金融业',
        children: []
      },
      {
        id: '1456',
        parentId: '1445',
        petitionVal: '',
        sortValue: '10',
        code: 'trade_1456',
        name: '房地产业',
        children: []
      },
      {
        id: '1457',
        parentId: '1445',
        petitionVal: '',
        sortValue: '9',
        code: 'trade_1457',
        name: '租赁和商务服务业',
        children: []
      },
      {
        id: '1458',
        parentId: '1445',
        petitionVal: '',
        sortValue: '8',
        code: 'trade_1458',
        name: '科学研究和技术服务业',
        children: []
      },
      {
        id: '1459',
        parentId: '1445',
        petitionVal: '',
        sortValue: '7',
        code: 'trade_1459',
        name: '水利、环境和公共设施管理业',
        children: []
      },
      {
        id: '1460',
        parentId: '1445',
        petitionVal: '',
        sortValue: '6',
        code: 'trade_1460',
        name: '居民服务、修理和其他服务业',
        children: []
      },
      {
        id: '1461',
        parentId: '1445',
        petitionVal: '',
        sortValue: '5',
        code: 'trade_1461',
        name: '教育',
        children: []
      },
      {
        id: '1462',
        parentId: '1445',
        petitionVal: '',
        sortValue: '4',
        code: 'trade_1462',
        name: '卫生和社会工作',
        children: []
      },
      {
        id: '1463',
        parentId: '1445',
        petitionVal: '',
        sortValue: '3',
        code: 'trade_1463',
        name: '文化、体育和娱乐业',
        children: []
      },
      {
        id: '1464',
        parentId: '1445',
        petitionVal: '',
        sortValue: '2',
        code: 'trade_1464',
        name: '公共管理、社会保障和社会组织',
        children: []
      },
      {
        id: '1465',
        parentId: '1445',
        petitionVal: '',
        sortValue: '1',
        code: 'trade_1465',
        name: '国际组织',
        children: []
      }
    ]
  },
  {
    id: '1495',
    parentId: '',
    petitionVal: '',
    sortValue: '0',
    code: 'deposit',
    name: '存款类型',
    children: [{
        id: '1496',
        parentId: '1495',
        petitionVal: '',
        sortValue: '2',
        code: 'deposit_1496',
        name: '国内存款',
        children: []
      },
      {
        id: '1497',
        parentId: '1495',
        petitionVal: '',
        sortValue: '1',
        code: 'deposit_1497',
        name: '国外存款',
        children: []
      }
    ]
  },
  {
    id: '1500',
    parentId: '',
    petitionVal: '',
    sortValue: '0',
    code: 'pccm',
    name: '党委委员',
    children: [{
        id: '1501',
        parentId: '1500',
        petitionVal: '',
        sortValue: '10',
        code: 'pccm_1501',
        name: '否',
        children: []
      },
      {
        id: '1502',
        parentId: '1500',
        petitionVal: '',
        sortValue: '9',
        code: 'pccm_1502',
        name: '中央委员',
        children: []
      },
      {
        id: '1503',
        parentId: '1500',
        petitionVal: '',
        sortValue: '8',
        code: 'pccm_1503',
        name: '中央候补委员',
        children: []
      },
      {
        id: '1504',
        parentId: '1500',
        petitionVal: '',
        sortValue: '7',
        code: 'pccm_1504',
        name: '省委委员',
        children: []
      },
      {
        id: '1505',
        parentId: '1500',
        petitionVal: '',
        sortValue: '6',
        code: 'pccm_1505',
        name: '省委候补委员',
        children: []
      },
      {
        id: '1506',
        parentId: '1500',
        petitionVal: '',
        sortValue: '5',
        code: 'pccm_1506',
        name: '市委委员',
        children: []
      },
      {
        id: '1507',
        parentId: '1500',
        petitionVal: '',
        sortValue: '4',
        code: 'pccm_1507',
        name: '市委候补委员',
        children: []
      },
      {
        id: '1508',
        parentId: '1500',
        petitionVal: '',
        sortValue: '3',
        code: 'pccm_1508',
        name: '县委委员',
        children: []
      },
      {
        id: '1509',
        parentId: '1500',
        petitionVal: '',
        sortValue: '2',
        code: 'pccm_1509',
        name: '县委候补委员',
        children: []
      },
      {
        id: '1510',
        parentId: '1500',
        petitionVal: '',
        sortValue: '1',
        code: 'pccm_1510',
        name: '乡镇党委委员',
        children: []
      }
    ]
  },
  {
    id: '1511',
    parentId: '',
    petitionVal: '',
    sortValue: '0',
    code: 'diccm',
    name: '纪委委员',
    children: [{
        id: '1512',
        parentId: '1511',
        petitionVal: '',
        sortValue: '6',
        code: 'diccm_1512',
        name: '否',
        children: []
      },
      {
        id: '1513',
        parentId: '1511',
        petitionVal: '',
        sortValue: '5',
        code: 'diccm_1513',
        name: '中央纪委委员',
        children: []
      },
      {
        id: '1514',
        parentId: '1511',
        petitionVal: '',
        sortValue: '4',
        code: 'diccm_1514',
        name: '省纪委委员',
        children: []
      },
      {
        id: '1515',
        parentId: '1511',
        petitionVal: '',
        sortValue: '3',
        code: 'diccm_1515',
        name: '市纪委委员',
        children: []
      },
      {
        id: '1516',
        parentId: '1511',
        petitionVal: '',
        sortValue: '2',
        code: 'diccm_1516',
        name: '县纪委委员',
        children: []
      },
      {
        id: '1517',
        parentId: '1511',
        petitionVal: '',
        sortValue: '1',
        code: 'diccm_1517',
        name: '乡镇纪委委员',
        children: []
      }
    ]
  },
  {
    id: '1518',
    parentId: '',
    petitionVal: '',
    sortValue: '0',
    code: 'scccm',
    name: '监委委员',
    children: [{
        id: '1519',
        parentId: '1518',
        petitionVal: '',
        sortValue: '6',
        code: 'scccm_1519',
        name: '否',
        children: []
      },
      {
        id: '1520',
        parentId: '1518',
        petitionVal: '',
        sortValue: '5',
        code: 'scccm_1520',
        name: '中央监委委员',
        children: []
      },
      {
        id: '1521',
        parentId: '1518',
        petitionVal: '',
        sortValue: '4',
        code: 'scccm_1521',
        name: '省监委委员',
        children: []
      },
      {
        id: '1522',
        parentId: '1518',
        petitionVal: '',
        sortValue: '3',
        code: 'scccm_1522',
        name: '市监委委员',
        children: []
      },
      {
        id: '1523',
        parentId: '1518',
        petitionVal: '',
        sortValue: '2',
        code: 'scccm_1523',
        name: '县监委委员',
        children: []
      },
      {
        id: '1524',
        parentId: '1518',
        petitionVal: '',
        sortValue: '1',
        code: 'scccm_1524',
        name: '乡镇监委委员',
        children: []
      }
    ]
  },
  {
    id: '1525',
    parentId: '',
    petitionVal: '',
    sortValue: '0',
    code: 'jljb',
    name: '奖励级别',
    children: [{
        id: '1526',
        parentId: '1525',
        petitionVal: '',
        sortValue: '5',
        code: 'jljb_1526',
        name: '国家级',
        children: []
      },
      {
        id: '1527',
        parentId: '1525',
        petitionVal: '',
        sortValue: '4',
        code: 'jljb_1527',
        name: '省级',
        children: []
      },
      {
        id: '1528',
        parentId: '1525',
        petitionVal: '',
        sortValue: '3',
        code: 'jljb_1528',
        name: '市级',
        children: []
      },
      {
        id: '1529',
        parentId: '1525',
        petitionVal: '',
        sortValue: '2',
        code: 'jljb_1529',
        name: '县级',
        children: []
      },
      { id: '1530', parentId: '1525', petitionVal: '', sortValue: '1', code: 'jljb_1530', name: '乡级', children: [] }
    ]
  },
  {
    id: '1578',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'duty',
    name: '因职务犯罪受到法律追究情况',
    children: [{
        id: '1569',
        parentId: '1578',
        petitionVal: '',
        sortValue: '2',
        code: 'duty_1569',
        name: '移送司法机关',
        children: []
      },
      {
        id: '1570',
        parentId: '1578',
        petitionVal: '',
        sortValue: '1',
        code: 'duty_1570',
        name: '判处刑罚',
        children: []
      }
    ]
  },
  {
    id: '1579',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'company_type',
    name: '企业或其他市场主体类型',
    children: [{
        id: '1571',
        parentId: '1579',
        petitionVal: '',
        sortValue: '7',
        code: 'company_type_1571',
        name: '股份有限公司',
        children: []
      },
      {
        id: '1572',
        parentId: '1579',
        petitionVal: '',
        sortValue: '6',
        code: 'company_type_1572',
        name: '有限责任公司',
        children: []
      },
      {
        id: '1573',
        parentId: '1579',
        petitionVal: '',
        sortValue: '5',
        code: 'company_type_1573',
        name: '个体工商户',
        children: []
      },
      {
        id: '1574',
        parentId: '1579',
        petitionVal: '',
        sortValue: '4',
        code: 'company_type_1574',
        name: '个人独资企业',
        children: []
      },
      {
        id: '1575',
        parentId: '1579',
        petitionVal: '',
        sortValue: '3',
        code: 'company_type_1575',
        name: '合伙企业',
        children: []
      },
      {
        id: '1576',
        parentId: '1579',
        petitionVal: '',
        sortValue: '2',
        code: 'company_type_1576',
        name: '在国（境）外注册公司或者投资入股',
        children: []
      },
      {
        id: '1577',
        parentId: '1579',
        petitionVal: '',
        sortValue: '1',
        code: 'company_type_1577',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '1580',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'change_flag',
    name: '婚姻变化情况',
    children: [{
        id: '1606',
        parentId: '1580',
        petitionVal: '',
        sortValue: '4',
        code: 'change_flag_1606',
        name: '结婚',
        children: []
      },
      {
        id: '1607',
        parentId: '1580',
        petitionVal: '',
        sortValue: '3',
        code: 'change_flag_1607',
        name: '离婚',
        children: []
      },
      {
        id: '1608',
        parentId: '1580',
        petitionVal: '',
        sortValue: '2',
        code: 'change_flag_1608',
        name: '丧偶',
        children: []
      },
      {
        id: '1609',
        parentId: '1580',
        petitionVal: '',
        sortValue: '1',
        code: 'change_flag_1609',
        name: '再婚',
        children: []
      }
    ]
  },
  {
    id: '1581',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'xw',
    name: '学位',
    children: [
      { id: '1589', parentId: '1581', petitionVal: '', sortValue: '4', code: 'xw_1589', name: '博士', children: [] },
      { id: '1590', parentId: '1581', petitionVal: '', sortValue: '3', code: 'xw_1590', name: '硕士', children: [] },
      { id: '1591', parentId: '1581', petitionVal: '', sortValue: '2', code: 'xw_1591', name: '学士', children: [] },
      { id: '1592', parentId: '1581', petitionVal: '', sortValue: '1', code: 'xw_1592', name: '无', children: [] }
    ]
  },
  {
    id: '1582',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'is_user_car',
    name: '有无公务用车情况',
    children: [{
        id: '1593',
        parentId: '1582',
        petitionVal: '',
        sortValue: '2',
        code: 'is_user_car_1593',
        name: '有此类情况',
        children: []
      },
      {
        id: '1594',
        parentId: '1582',
        petitionVal: '',
        sortValue: '1',
        code: 'is_user_car_1594',
        name: '无此类情况',
        children: []
      }
    ]
  },
  {
    id: '1583',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'adm_punish',
    name: '有无公务用车情况',
    children: [{
        id: '1610',
        parentId: '1583',
        petitionVal: '',
        sortValue: '6',
        code: 'adm_punish_1610',
        name: '警告',
        children: []
      },
      {
        id: '1611',
        parentId: '1583',
        petitionVal: '',
        sortValue: '5',
        code: 'adm_punish_1611',
        name: '记过',
        children: []
      },
      {
        id: '1612',
        parentId: '1583',
        petitionVal: '',
        sortValue: '4',
        code: 'adm_punish_1612',
        name: '记大过',
        children: []
      },
      {
        id: '1613',
        parentId: '1583',
        petitionVal: '',
        sortValue: '3',
        code: 'adm_punish_1613',
        name: '降级',
        children: []
      },
      {
        id: '1614',
        parentId: '1583',
        petitionVal: '',
        sortValue: '2',
        code: 'adm_punish_1614',
        name: '撤职',
        children: []
      },
      {
        id: '1616',
        parentId: '1583',
        petitionVal: '',
        sortValue: '1',
        code: 'adm_punish_1616',
        name: '开除',
        children: []
      }
    ]
  },
  {
    id: '2053',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'build_organ',
    name: '纪委办理机关',
    children: [{
        id: '2039',
        parentId: '2053',
        petitionVal: '',
        sortValue: '14',
        code: 'build_organ_2039',
        name: '中央纪委',
        children: []
      },
      {
        id: '2040',
        parentId: '2053',
        petitionVal: '',
        sortValue: '13',
        code: 'build_organ_2040',
        name: '省区市纪委',
        children: []
      },
      {
        id: '2041',
        parentId: '2053',
        petitionVal: '',
        sortValue: '12',
        code: 'build_organ_2041',
        name: '地市州盟纪委',
        children: []
      },
      {
        id: '2042',
        parentId: '2053',
        petitionVal: '',
        sortValue: '11',
        code: 'build_organ_2042',
        name: '县市区旗纪委',
        children: []
      },
      {
        id: '2043',
        parentId: '2053',
        petitionVal: '',
        sortValue: '10',
        code: 'build_organ_2043',
        name: '乡镇纪委',
        children: []
      },
      {
        id: '2044',
        parentId: '2053',
        petitionVal: '',
        sortValue: '9',
        code: 'build_organ_2044',
        name: '军队纪委',
        children: []
      },
      {
        id: '2045',
        parentId: '2053',
        petitionVal: '',
        sortValue: '8',
        code: 'build_organ_2045',
        name: '中央纪委派驻纪检组',
        children: []
      },
      {
        id: '2046',
        parentId: '2053',
        petitionVal: '',
        sortValue: '7',
        code: 'build_organ_2046',
        name: '省区市纪委派驻纪检组',
        children: []
      },
      {
        id: '2047',
        parentId: '2053',
        petitionVal: '',
        sortValue: '6',
        code: 'build_organ_2047',
        name: '地市州盟纪委派驻纪检组',
        children: []
      },
      {
        id: '2048',
        parentId: '2053',
        petitionVal: '',
        sortValue: '5',
        code: 'build_organ_2048',
        name: '县市区旗纪委派驻纪检组',
        children: []
      },
      {
        id: '2049',
        parentId: '2053',
        petitionVal: '',
        sortValue: '4',
        code: 'build_organ_2049',
        name: '企业单位纪检机构',
        children: []
      },
      {
        id: '2050',
        parentId: '2053',
        petitionVal: '',
        sortValue: '3',
        code: 'build_organ_2050',
        name: '事业单位纪检机构',
        children: []
      },
      {
        id: '2051',
        parentId: '2053',
        petitionVal: '',
        sortValue: '2',
        code: 'build_organ_2051',
        name: '其他',
        children: []
      },
      {
        id: '2052',
        parentId: '2053',
        petitionVal: '',
        sortValue: '1',
        code: 'build_organ_2052',
        name: '机关纪委',
        children: []
      }
    ]
  },
  {
    id: '2054',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'sc_build_organ',
    name: '监委办理机关',
    children: [{
        id: '2055',
        parentId: '2054',
        petitionVal: '',
        sortValue: '12',
        code: 'sc_build_organ_2055',
        name: '国家监委',
        children: []
      },
      {
        id: '2056',
        parentId: '2054',
        petitionVal: '',
        sortValue: '11',
        code: 'sc_build_organ_2056',
        name: '省区市监委',
        children: []
      },
      {
        id: '2057',
        parentId: '2054',
        petitionVal: '',
        sortValue: '10',
        code: 'sc_build_organ_2057',
        name: '地市州盟监委',
        children: []
      },
      {
        id: '2058',
        parentId: '2054',
        petitionVal: '',
        sortValue: '9',
        code: 'sc_build_organ_2058',
        name: '县市区旗监委',
        children: []
      },
      {
        id: '2059',
        parentId: '2054',
        petitionVal: '',
        sortValue: '8',
        code: 'sc_build_organ_2059',
        name: '军队监委',
        children: []
      },
      {
        id: '2060',
        parentId: '2054',
        petitionVal: '',
        sortValue: '7',
        code: 'sc_build_organ_2060',
        name: '国家监委派驻监察组',
        children: []
      },
      {
        id: '2061',
        parentId: '2054',
        petitionVal: '',
        sortValue: '6',
        code: 'sc_build_organ_2061',
        name: '省区市监委派驻监察组',
        children: []
      },
      {
        id: '2062',
        parentId: '2054',
        petitionVal: '',
        sortValue: '5',
        code: 'sc_build_organ_2062',
        name: '地市州盟监委派驻监察组',
        children: []
      },
      {
        id: '2063',
        parentId: '2054',
        petitionVal: '',
        sortValue: '4',
        code: 'sc_build_organ_2063',
        name: '县市区旗监委派驻监察组',
        children: []
      },
      {
        id: '2064',
        parentId: '2054',
        petitionVal: '',
        sortValue: '3',
        code: 'sc_build_organ_2064',
        name: '企业单位监察机构',
        children: []
      },
      {
        id: '2065',
        parentId: '2054',
        petitionVal: '',
        sortValue: '2',
        code: 'sc_build_organ_2065',
        name: '事业单位监察机构',
        children: []
      },
      {
        id: '2066',
        parentId: '2054',
        petitionVal: '',
        sortValue: '1',
        code: 'sc_build_organ_2066',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '2067',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'partyPunish',
    name: '党纪处分',
    children: [{
        id: '2068',
        parentId: '2067',
        petitionVal: '',
        sortValue: '5',
        code: 'partyDiscipline_2068',
        name: '警告',
        children: []
      },
      {
        id: '2069',
        parentId: '2067',
        petitionVal: '',
        sortValue: '4',
        code: 'partyDiscipline_2069',
        name: '严重警告',
        children: []
      },
      {
        id: '2070',
        parentId: '2067',
        petitionVal: '',
        sortValue: '3',
        code: 'partyDiscipline_2070',
        name: '撤销党内职务',
        children: []
      },
      {
        id: '2071',
        parentId: '2067',
        petitionVal: '',
        sortValue: '2',
        code: 'partyDiscipline_2071',
        name: '留党察看',
        children: []
      },
      {
        id: '2072',
        parentId: '2067',
        petitionVal: '',
        sortValue: '1',
        code: 'partyDiscipline_2072',
        name: '开除党籍',
        children: []
      }
    ]
  },
  {
    id: '2073',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'admPunish',
    name: '政务处分',
    children: [{
        id: '2074',
        parentId: '2073',
        petitionVal: '',
        sortValue: '8',
        code: 'politicaDiscipline_2074',
        name: '警告',
        children: []
      },
      {
        id: '2075',
        parentId: '2073',
        petitionVal: '',
        sortValue: '7',
        code: 'politicaDiscipline_2075',
        name: '记过',
        children: []
      },
      {
        id: '2076',
        parentId: '2073',
        petitionVal: '',
        sortValue: '6',
        code: 'politicaDiscipline_2076',
        name: '记大过',
        children: []
      },
      {
        id: '2077',
        parentId: '2073',
        petitionVal: '',
        sortValue: '5',
        code: 'politicaDiscipline_2077',
        name: '降级',
        children: []
      },
      {
        id: '2078',
        parentId: '2073',
        petitionVal: '',
        sortValue: '4',
        code: 'politicaDiscipline_2078',
        name: '降职',
        children: []
      },
      {
        id: '2079',
        parentId: '2073',
        petitionVal: '',
        sortValue: '3',
        code: 'politicaDiscipline_2079',
        name: '撤职',
        children: []
      },
      {
        id: '2080',
        parentId: '2073',
        petitionVal: '',
        sortValue: '2',
        code: 'politicaDiscipline_2080',
        name: '开除留用察看',
        children: []
      },
      {
        id: '2081',
        parentId: '2073',
        petitionVal: '',
        sortValue: '1',
        code: 'politicaDiscipline_2081',
        name: '开除',
        children: []
      }
    ]
  },
  {
    id: '2082',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'organizational_process',
    name: '组织措施',
    children: [{
        id: '2083',
        parentId: '2082',
        petitionVal: '',
        sortValue: '34',
        code: 'organizational_process_2083',
        name: '提醒谈话',
        children: []
      },
      {
        id: '2084',
        parentId: '2082',
        petitionVal: '',
        sortValue: '33',
        code: 'organizational_process_2084',
        name: '警示谈话',
        children: []
      },
      {
        id: '2085',
        parentId: '2082',
        petitionVal: '',
        sortValue: '32',
        code: 'organizational_process_2085',
        name: '批评教育',
        children: []
      },
      {
        id: '2086',
        parentId: '2082',
        petitionVal: '',
        sortValue: '31',
        code: 'organizational_process_2086',
        name: '纠正或责令停止违纪行为',
        children: []
      },
      {
        id: '2087',
        parentId: '2082',
        petitionVal: '',
        sortValue: '30',
        code: 'organizational_process_2087',
        name: '责成退出违纪所得',
        children: []
      },
      {
        id: '2088',
        parentId: '2082',
        petitionVal: '',
        sortValue: '29',
        code: 'organizational_process_2088',
        name: '限期整改',
        children: []
      },
      {
        id: '2089',
        parentId: '2082',
        petitionVal: '',
        sortValue: '28',
        code: 'organizational_process_2089',
        name: '责令作出口头或书面检查',
        children: []
      },
      {
        id: '2090',
        parentId: '2082',
        petitionVal: '',
        sortValue: '27',
        code: 'organizational_process_2090',
        name: '召开民主生活会批评帮助',
        children: []
      },
      {
        id: '2091',
        parentId: '2082',
        petitionVal: '',
        sortValue: '26',
        code: 'organizational_process_2091',
        name: '责令公开道歉（检讨）',
        children: []
      },
      {
        id: '2092',
        parentId: '2082',
        petitionVal: '',
        sortValue: '25',
        code: 'organizational_process_2092',
        name: '通报（通报批评）',
        children: []
      },
      {
        id: '2093',
        parentId: '2082',
        petitionVal: '',
        sortValue: '24',
        code: 'organizational_process_2093',
        name: '诫勉（诫勉谈话）',
        children: []
      },
      {
        id: '2094',
        parentId: '2082',
        petitionVal: '',
        sortValue: '23',
        code: 'organizational_process_2094',
        name: '其它批评教育类措施',
        children: []
      },
      {
        id: '2095',
        parentId: '2082',
        petitionVal: '',
        sortValue: '22',
        code: 'organizational_process_2095',
        name: '取消荣誉称号',
        children: []
      },
      {
        id: '2096',
        parentId: '2082',
        petitionVal: '',
        sortValue: '21',
        code: 'organizational_process_2096',
        name: '撤销政协委员资格 ',
        children: []
      },
      {
        id: '2097',
        parentId: '2082',
        petitionVal: '',
        sortValue: '20',
        code: 'organizational_process_2097',
        name: '终止（罢免、撤销、责令辞去）人大代表资格',
        children: []
      },
      {
        id: '2098',
        parentId: '2082',
        petitionVal: '',
        sortValue: '19',
        code: 'organizational_process_2098',
        name: '取消预备党员资格',
        children: []
      },
      {
        id: '2099',
        parentId: '2082',
        petitionVal: '',
        sortValue: '18',
        code: 'organizational_process_2099',
        name: '取消（罢免）当选资格',
        children: []
      },
      {
        id: '2100',
        parentId: '2082',
        petitionVal: '',
        sortValue: '17',
        code: 'organizational_process_2100',
        name: '终止党代表资格',
        children: []
      },
      {
        id: '2101',
        parentId: '2082',
        petitionVal: '',
        sortValue: '16',
        code: 'organizational_process_2101',
        name: '停职（停职检查）',
        children: []
      },
      {
        id: '2102',
        parentId: '2082',
        petitionVal: '',
        sortValue: '15',
        code: 'organizational_process_2102',
        name: '调整（调离）职务（岗位）',
        children: []
      },
      {
        id: '2103',
        parentId: '2082',
        petitionVal: '',
        sortValue: '14',
        code: 'organizational_process_2103',
        name: '免职',
        children: []
      },
      {
        id: '2104',
        parentId: '2082',
        petitionVal: '',
        sortValue: '13',
        code: 'organizational_process_2104',
        name: '引咎辞职',
        children: []
      },
      {
        id: '2105',
        parentId: '2082',
        petitionVal: '',
        sortValue: '12',
        code: 'organizational_process_2105',
        name: '责令辞职',
        children: []
      },
      {
        id: '2106',
        parentId: '2082',
        petitionVal: '',
        sortValue: '11',
        code: 'organizational_process_2106',
        name: '改任非领导职务',
        children: []
      },
      {
        id: '2107',
        parentId: '2082',
        petitionVal: '',
        sortValue: '10',
        code: 'organizational_process_2107',
        name: '安排提前退休',
        children: []
      },
      {
        id: '2108',
        parentId: '2082',
        petitionVal: '',
        sortValue: '9',
        code: 'organizational_process_2108',
        name: '降低退休待遇',
        children: []
      },
      {
        id: '2109',
        parentId: '2082',
        petitionVal: '',
        sortValue: '8',
        code: 'organizational_process_2109',
        name: '其它组织调整类措施',
        children: []
      },
      {
        id: '2110',
        parentId: '2082',
        petitionVal: '',
        sortValue: '7',
        code: 'organizational_process_2110',
        name: '降职',
        children: []
      },
      {
        id: '2111',
        parentId: '2082',
        petitionVal: '',
        sortValue: '6',
        code: 'organizational_process_2111',
        name: '取消退休待遇',
        children: []
      },
      {
        id: '2112',
        parentId: '2082',
        petitionVal: '',
        sortValue: '5',
        code: 'organizational_process_2112',
        name: '解聘',
        children: []
      },
      {
        id: '2113',
        parentId: '2082',
        petitionVal: '',
        sortValue: '4',
        code: 'organizational_process_2113',
        name: '解除劳动合同',
        children: []
      },
      {
        id: '2114',
        parentId: '2082',
        petitionVal: '',
        sortValue: '3',
        code: 'organizational_process_2114',
        name: '辞退',
        children: []
      },
      {
        id: '2115',
        parentId: '2082',
        petitionVal: '',
        sortValue: '2',
        code: 'organizational_process_2115',
        name: '组织除名（劝退）',
        children: []
      },
      {
        id: '2116',
        parentId: '2082',
        petitionVal: '',
        sortValue: '1',
        code: 'organizational_process_2116',
        name: '其它重大职务调整类措施',
        children: []
      }
    ]
  },
  {
    id: '2117',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'issueType',
    name: '问题归类',
    children: [{
        id: '2118',
        parentId: '2117',
        petitionVal: '',
        sortValue: '17',
        code: 'issueType_2118',
        name: '违反政治纪律',
        children: []
      },
      {
        id: '2119',
        parentId: '2117',
        petitionVal: '',
        sortValue: '16',
        code: 'issueType_2119',
        name: '违反组织纪律',
        children: []
      },
      {
        id: '2120',
        parentId: '2117',
        petitionVal: '',
        sortValue: '15',
        code: 'issueType_2120',
        name: '违反廉洁纪律',
        children: []
      },
      {
        id: '2121',
        parentId: '2117',
        petitionVal: '',
        sortValue: '14',
        code: 'issueType_2121',
        name: '违反群众纪律',
        children: []
      },
      {
        id: '2122',
        parentId: '2117',
        petitionVal: '',
        sortValue: '13',
        code: 'issueType_2122',
        name: '违反工作纪律',
        children: []
      },
      {
        id: '2123',
        parentId: '2117',
        petitionVal: '',
        sortValue: '12',
        code: 'issueType_2123',
        name: '违反生活纪律',
        children: []
      },
      {
        id: '2124',
        parentId: '2117',
        petitionVal: '',
        sortValue: '11',
        code: 'issueType_2124',
        name: '贪污贿赂',
        children: []
      },
      {
        id: '2125',
        parentId: '2117',
        petitionVal: '',
        sortValue: '10',
        code: 'issueType_2125',
        name: '滥用职权',
        children: []
      },
      {
        id: '2126',
        parentId: '2117',
        petitionVal: '',
        sortValue: '9',
        code: 'issueType_2126',
        name: '玩忽职守',
        children: []
      },
      {
        id: '2127',
        parentId: '2117',
        petitionVal: '',
        sortValue: '8',
        code: 'issueType_2127',
        name: '徇私舞弊',
        children: []
      },
      {
        id: '2128',
        parentId: '2117',
        petitionVal: '',
        sortValue: '7',
        code: 'issueType_2128',
        name: '重大责任事故',
        children: []
      },
      {
        id: '2129',
        parentId: '2117',
        petitionVal: '',
        sortValue: '6',
        code: 'issueType_2129',
        name: '行使公权力过程中发生的其他犯罪行为',
        children: []
      },
      {
        id: '2130',
        parentId: '2117',
        petitionVal: '',
        sortValue: '5',
        code: 'issueType_2130',
        name: '侵犯财产',
        children: []
      },
      {
        id: '2131',
        parentId: '2117',
        petitionVal: '',
        sortValue: '4',
        code: 'issueType_2131',
        name: '破坏社会主义市场经济秩序',
        children: []
      },
      {
        id: '2132',
        parentId: '2117',
        petitionVal: '',
        sortValue: '3',
        code: 'issueType_2132',
        name: '妨害社会管理秩序',
        children: []
      },
      {
        id: '2133',
        parentId: '2117',
        petitionVal: '',
        sortValue: '2',
        code: 'issueType_2133',
        name: '侵犯公民人身权利民主权利',
        children: []
      },
      {
        id: '2134',
        parentId: '2117',
        petitionVal: '',
        sortValue: '1',
        code: 'issueType_2134',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '2135',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'handleUnit',
    name: '办理机关',
    children: [{
        id: '2136',
        parentId: '2135',
        petitionVal: '',
        sortValue: '14',
        code: 'handleUnit_2136',
        name: '中央纪委国家监委',
        children: []
      },
      {
        id: '2137',
        parentId: '2135',
        petitionVal: '',
        sortValue: '13',
        code: 'handleUnit_2137',
        name: '省区市纪委监委',
        children: []
      },
      {
        id: '2138',
        parentId: '2135',
        petitionVal: '',
        sortValue: '12',
        code: 'handleUnit_2138',
        name: '地市州盟纪委监委',
        children: []
      },
      {
        id: '2139',
        parentId: '2135',
        petitionVal: '',
        sortValue: '11',
        code: 'handleUnit_2139',
        name: '县市区旗纪委监委',
        children: []
      },
      {
        id: '2140',
        parentId: '2135',
        petitionVal: '',
        sortValue: '10',
        code: 'handleUnit_2140',
        name: '乡镇纪委',
        children: []
      },
      {
        id: '2141',
        parentId: '2135',
        petitionVal: '',
        sortValue: '9',
        code: 'handleUnit_2141',
        name: '军队纪委监委',
        children: []
      },
      {
        id: '2142',
        parentId: '2135',
        petitionVal: '',
        sortValue: '8',
        code: 'handleUnit_2142',
        name: '中央纪委国家监委派驻纪检监察组',
        children: []
      },
      {
        id: '2143',
        parentId: '2135',
        petitionVal: '',
        sortValue: '7',
        code: 'handleUnit_2143',
        name: '省区市纪委监委派驻纪检监察组',
        children: []
      },
      {
        id: '2144',
        parentId: '2135',
        petitionVal: '',
        sortValue: '6',
        code: 'handleUnit_2144',
        name: '地市州盟纪委监委派驻纪检监察组',
        children: []
      },
      {
        id: '2145',
        parentId: '2135',
        petitionVal: '',
        sortValue: '5',
        code: 'handleUnit_2145',
        name: '县市区旗纪委监委派驻纪检监察组',
        children: []
      },
      {
        id: '2146',
        parentId: '2135',
        petitionVal: '',
        sortValue: '4',
        code: 'handleUnit_2146',
        name: '企业单位纪检监察机构',
        children: []
      },
      {
        id: '2147',
        parentId: '2135',
        petitionVal: '',
        sortValue: '3',
        code: 'handleUnit_2147',
        name: '事业单位纪检监察机构',
        children: []
      },
      {
        id: '2148',
        parentId: '2135',
        petitionVal: '',
        sortValue: '2',
        code: 'handleUnit_2148',
        name: '机关纪委',
        children: []
      },
      {
        id: '2149',
        parentId: '2135',
        petitionVal: '',
        sortValue: '1',
        code: 'handleUnit_2149',
        name: '其他',
        children: []
      }
    ]
  },
  {
    id: '2150',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'handleType',
    name: '处置方式',
    children: [{
        id: '2151',
        parentId: '2150',
        petitionVal: '',
        sortValue: '5',
        code: 'handleType_2151',
        name: '拟立案',
        children: []
      },
      {
        id: '2152',
        parentId: '2150',
        petitionVal: '',
        sortValue: '4',
        code: 'handleType_2152',
        name: '初步核实',
        children: []
      },
      {
        id: '2153',
        parentId: '2150',
        petitionVal: '',
        sortValue: '3',
        code: 'handleType_2153',
        name: '暂存',
        children: []
      },
      {
        id: '2154',
        parentId: '2150',
        petitionVal: '',
        sortValue: '2',
        code: 'handleType_2154',
        name: '了结',
        children: []
      },
      {
        id: '2155',
        parentId: '2150',
        petitionVal: '',
        sortValue: '1',
        code: 'handleType_2155',
        name: '谈话函询',
        children: []
      }
    ]
  },
  { id: '4000', parentId: '', petitionVal: '', sortValue: '', code: 'involvedType', name: '涉案情形', children: [] },
  {
    id: '4009',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'companyType',
    name: '涉案企业类型',
    children: [{
        id: '4010',
        parentId: '4009',
        petitionVal: '',
        sortValue: '2',
        code: 'companyType_4010',
        name: '国有',
        children: []
      },
      {
        id: '4011',
        parentId: '4009',
        petitionVal: '',
        sortValue: '1',
        code: 'companyType_4011',
        name: '民营',
        children: []
      }
    ]
  },
  {
    id: '4018',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'ywbh',
    name: '有无变化',
    children: [{
        id: '4017',
        parentId: '4018',
        petitionVal: '',
        sortValue: '2',
        code: 'ywbh_4017',
        name: '有变化',
        children: []
      },
      {
        id: '4016',
        parentId: '4018',
        petitionVal: '',
        sortValue: '1',
        code: 'ywbh_4016',
        name: '无变化',
        children: []
      }
    ]
  },
  {
    id: '4022',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'zjlx',
    name: '证件类型',
    children: [{
        id: '4023',
        parentId: '4022',
        petitionVal: '',
        sortValue: '1',
        code: 'zjlx_4023',
        name: '身份证',
        children: []
      },
      {
        id: '4024',
        parentId: '4022',
        petitionVal: '',
        sortValue: '2',
        code: 'zjlx_4024',
        name: '军官证',
        children: []
      },
      { id: '4025', parentId: '4022', petitionVal: '', sortValue: '3', code: 'zjlx_4025', name: '其他', children: [] }
    ]
  },
  {
    id: '4025',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'gjzw',
    name: '是否担任高级职务',
    children: [
      { id: '4011', parentId: '4025', petitionVal: '', sortValue: '1', code: 'gjzw_4011', name: '是', children: [] },
      { id: '4012', parentId: '4025', petitionVal: '', sortValue: '2', code: 'gjzw_4012', name: '否', children: [] }
    ]
  },
  {
    id: '4026',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'jwqy',
    name: '是否为境外企业',
    children: [
      { id: '4021', parentId: '4026', petitionVal: '', sortValue: '1', code: 'gjzw_4021', name: '是', children: [] },
      { id: '4022', parentId: '4026', petitionVal: '', sortValue: '2', code: 'gjzw_4022', name: '否', children: [] }
    ]
  },
  {
    id: '4027',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'personrank',
    name: '职级',
    children: [{
        id: '4028',
        parentId: '4027',
        petitionVal: '',
        sortValue: '1',
        code: 'personrank_332',
        name: '省部级',
        children: []
      },
      {
        id: '4029',
        parentId: '4027',
        petitionVal: '',
        sortValue: '2',
        code: 'personrank_333',
        name: '厅局级',
        children: []
      },
      {
        id: '4030',
        parentId: '4027',
        petitionVal: '',
        sortValue: '3',
        code: 'personrank_334',
        name: '县处级',
        children: []
      },
      {
        id: '4031',
        parentId: '4027',
        petitionVal: '',
        sortValue: '4',
        code: 'personrank_335',
        name: '乡科级',
        children: []
      },
      {
        id: '4032',
        parentId: '4027',
        petitionVal: '',
        sortValue: '5',
        code: 'personrank_336',
        name: '一般干部',
        children: []
      },
      {
        id: '4033',
        parentId: '4027',
        petitionVal: '',
        sortValue: '6',
        code: 'personrank_337',
        name: '其他人员',
        children: []
      },
    ]
  },
  {
    id: '4034',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'InspectionUnitType',
    name: '地市类型',
    children: [
      { id: '4035', parentId: '4034', petitionVal: '', sortValue: '1', code: '1', name: '地市', children: [] },
      { id: '4036', parentId: '4034', petitionVal: '', sortValue: '2', code: '2', name: '区县', children: [] },
      { id: '4037', parentId: '4034', petitionVal: '', sortValue: '2', code: '3', name: '省直单位', children: [] },
      { id: '4038', parentId: '4034', petitionVal: '', sortValue: '2', code: '4', name: '省属高校', children: [] },
      { id: '4039', parentId: '4034', petitionVal: '', sortValue: '2', code: '5', name: '省属企业', children: [] },
      { id: '4040', parentId: '4034', petitionVal: '', sortValue: '2', code: '6', name: '其他', children: [] },

    ]
  },
  {
    id: '4041',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'dutyTypeInfo',
    name: '违规违纪行为',
    children: [{
        id: '4042',
        parentId: '4041',
        petitionVal: '',
        sortValue: '1',
        code: 'dutyTypeInfo_1',
        name: '违反政治纪律',
        children: []
      },
      {
        id: '4043',
        parentId: '4041',
        petitionVal: '',
        sortValue: '2',
        code: 'dutyTypeInfo_2',
        name: '违反组织纪律',
        children: []
      },
      {
        id: '4044',
        parentId: '4041',
        petitionVal: '',
        sortValue: '3',
        code: 'dutyTypeInfo_3',
        name: '违反廉洁纪律',
        children: []
      },
      {
        id: '4045',
        parentId: '4041',
        petitionVal: '',
        sortValue: '4',
        code: 'dutyTypeInfo_4',
        name: '违反群众纪律',
        children: []
      },
      {
        id: '4046',
        parentId: '4041',
        petitionVal: '',
        sortValue: '5',
        code: 'dutyTypeInfo_5',
        name: '违反工作纪律',
        children: []
      },
      {
        id: '4047',
        parentId: '4041',
        petitionVal: '',
        sortValue: '6',
        code: 'dutyTypeInfo_6',
        name: '违反生活纪律',
        children: []
      },
      {
        id: '4048',
        parentId: '4041',
        petitionVal: '',
        sortValue: '7',
        code: 'dutyTypeInfo_7',
        name: '违反八项规定精神',
        children: []
      },
      {
        id: '4049',
        parentId: '4041',
        petitionVal: '',
        sortValue: '8',
        code: 'dutyTypeInfo_8',
        name: '四风问题',
        children: []
      },
    ]
  },
  {
    id: '4050',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'wtlxej',
    name: '问题类型二级',
    children: [{
        id: '4051',
        parentId: '4050',
        petitionVal: '',
        sortValue: '1',
        code: '1',
        // name: '落实党的理论和路线方针政策以及中央重大决策、省委部署情况',
        name: '贯彻落实党的理论路线方针政策和党中央决策部署,省委工作要求情况',
        logogram: '落实党的方针政策',
        children: []
      },
      {
        id: '4052',
        parentId: '4050',
        petitionVal: '',
        sortValue: '2',
        code: '2',
        // name: '落实全面从严治党战略部署情况',
        name: '贯彻落实全面从严治党战略部署情况',
        logogram: '落实全面从严治党战略部署情况',
        children: []
      },
      {
        id: '4053',
        parentId: '4050',
        petitionVal: '',
        sortValue: '3',
        code: '3',
        // name: '落实新时代党的组织路线情况',
        name: '贯彻落实新时代党的组织路线情况',
        logogram: '落实新时代党的组织路线情况',
        children: []
      },
      {
        id: '4054',
        parentId: '4050',
        petitionVal: '',
        sortValue: '4',
        code: '4',
        // name: '落实省委巡视、审计等监督发现问题和“不忘初心、牢记使命”主题教育整改情况',
        name: '对巡视，纪检监察建议，审计，统计督查，环保督察等监督发现问题整改落实情况',
        logogram: '落实上一轮巡视整改',
        children: []
      },
      // {
      //   id: '4055',
      //   parentId: '4050',
      //   petitionVal: '',
      //   sortValue: '5',
      //   code: '5',
      //   name: '聚焦党的理论路线方针政策和党中央重大决策部署在基层贯彻落实情况',
      //   logogram: '聚焦党的方针政策',
      //   children: []
      // },
      // {
      //   id: '4056',
      //   parentId: '4050',
      //   petitionVal: '',
      //   sortValue: '6',
      //   code: '6',
      //   name: '聚焦群众身边腐败和作风问题',
      //   logogram: '聚焦群众身边腐败和作风问题',
      //   children: []
      // },
      // {
      //   id: '4057',
      //   parentId: '4050',
      //   petitionVal: '',
      //   sortValue: '7',
      //   code: '7',
      //   name: '聚焦基层党组织建设情况',
      //   logogram: '聚焦基层党组织建设情况',
      //   children: []
      // },
      // {
      //   id: '4057',
      //   parentId: '4050',
      //   petitionVal: '',
      //   sortValue: '8',
      //   code: '8',
      //   name: '落实巡视巡察、审计等监督发现问题和“不忘初心、牢记使命”主题教育整改情况',
      //   logogram: '落实上一轮巡察整改',
      //   children: []
      // },
    ]
  },
  {
    id: '4055',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'level',
    name: '职务',
    children: [{
        id: '4056',
        parentId: '4055',
        petitionVal: '',
        sortValue: '1',
        code: 'groupPersonType_1',
        name: '组长',
        logogram: '',
        children: []
      },
      {
        id: '4057',
        parentId: '4055',
        petitionVal: '',
        sortValue: '2',
        code: 'groupPersonType_2',
        name: '正厅级巡视专员',
        logogram: '',
        children: []
      },
      {
        id: '4058',
        parentId: '4055',
        petitionVal: '',
        sortValue: '3',
        code: 'groupPersonType_3',
        name: '副组长',
        logogram: '',
        children: []
      },
      {
        id: '4059',
        parentId: '4055',
        petitionVal: '',
        sortValue: '4',
        code: 'groupPersonType_4',
        name: '副厅级巡视专员',
        logogram: '',
        children: []
      },
      {
        id: '4060',
        parentId: '4055',
        petitionVal: '',
        sortValue: '5',
        code: 'groupPersonType_5',
        name: '正处级巡视专员',
        logogram: '',
        children: []
      },
      {
        id: '4061',
        parentId: '4055',
        petitionVal: '',
        sortValue: '6',
        code: 'groupPersonType_6',
        name: '副处级巡视专员',
        logogram: '',
        children: []
      },
      {
        id: '4062',
        parentId: '4055',
        petitionVal: '',
        sortValue: '7',
        code: 'groupPersonType_7',
        name: '一级巡视员',
        logogram: '',
        children: []
      },
      {
        id: '4063',
        parentId: '4055',
        petitionVal: '',
        sortValue: '8',
        code: 'groupPersonType_8',
        name: '二级巡视员',
        logogram: '',
        children: []
      },
      {
        id: '4064',
        parentId: '4055',
        petitionVal: '',
        sortValue: '9',
        code: 'groupPersonType_9',
        name: '一级调研员',
        logogram: '',
        children: []
      },
      {
        id: '4065',
        parentId: '4055',
        petitionVal: '',
        sortValue: '10',
        code: 'groupPersonType_10',
        name: '二级调研员',
        logogram: '',
        children: []
      },
      {
        id: '4066',
        parentId: '4055',
        petitionVal: '',
        sortValue: '11',
        code: 'groupPersonType_11',
        name: '三级调研员',
        logogram: '',
        children: []
      },
      {
        id: '4067',
        parentId: '4055',
        petitionVal: '',
        sortValue: '12',
        code: 'groupPersonType_12',
        name: '四级调研员',
        logogram: '',
        children: []
      },
      {
        id: '4068',
        parentId: '4055',
        petitionVal: '',
        sortValue: '13',
        code: 'groupPersonType_13',
        name: '组员',
        logogram: '',
        children: []
      }
    ]
  },
  {
    id: '4055',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'questionType',
    name: '问题分类',
    children: [
      { id: '4056', parentId: '4055', petitionVal: '', sortValue: '1', code: '1', name: '巡视发现主要问题', children: [] },
      { id: '4057', parentId: '4055', petitionVal: '', sortValue: '2', code: '2', name: '开展巡察工作专项检查发现问题',children: []},
      // { id: '4058', parentId: '4055', petitionVal: '', sortValue: '3', code: '3', name: '省委巡察指导督导反馈意见建议', children: [] },
      // { id: '4059', parentId: '4055', petitionVal: '', sortValue: '4', code: '4', name: '移交问题线索', children: [] },
    ]
  },
  {
    id: '4060',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'establishment',
    name: '建章立制类型',
    children: [{
        id: '4061',
        parentId: '4055',
        petitionVal: '',
        sortValue: '1',
        code: 'ccAddNum',
        name: '新建制度',
        children: []
      },
      {
        id: '4062',
        parentId: '4055',
        petitionVal: '',
        sortValue: '2',
        code: 'ccFinishNum',
        name: '完善制度',
        children: []
      },
    ]
  },
  {
    id: '4065',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'inspectionMethod',
    name: '巡视巡察方式',
    children: [
      { id: '4066', parentId: '4065', petitionVal: '', sortValue: '1', code: '1', name: '常规巡视（巡察）', children: [] },
      { id: '4067', parentId: '4065', petitionVal: '', sortValue: '2', code: '2', name: '专项巡视（巡察）', children: [] },
      { id: '4068', parentId: '4065', petitionVal: '', sortValue: '3', code: '3', name: '“机动式”巡视（巡察）', children: [] },
      { id: '4069', parentId: '4065', petitionVal: '', sortValue: '4', code: '4', name: '巡视（巡察）“回头看”', children: []},
      { id: '4070', parentId: '4065', petitionVal: '', sortValue: '5', code: '5', name: '提级巡视（巡察）', children: [] },
    ]
  },
  {
    id: '4066',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'xsstatus',
    name: '线索类型',
    children: [
      { id: '4071', parentId: '4066', petitionVal: '', sortValue: '1', code: '1', name: '待签收', children: [] },
      { id: '4072', parentId: '4066', petitionVal: '', sortValue: '2', code: '2', name: '办理中', children: [] },
      { id: '4073', parentId: '4066', petitionVal: '', sortValue: '3', code: '3', name: '已办结', children: [] },
      { id: '4074', parentId: '4066', petitionVal: '', sortValue: '4', code: '4', name: '已退回', children: [] },
      { id: '4075', parentId: '4066', petitionVal: '', sortValue: '5', code: '5', name: '判重', children: [] },
    ]
  },
  {
    id: '4022',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'zjlx2',
    name: '证件类型',
    children: [{
        id: '4023',
        parentId: '4022',
        petitionVal: '',
        sortValue: '1',
        code: 'id_card_type_1519',
        name: '身份证',
        children: []
      },
      {
        id: '4024',
        parentId: '4022',
        petitionVal: '',
        sortValue: '2',
        code: 'id_card_type_1520',
        name: '其他',
        children: []
      },
    ]
  },
  {
    id: '4022',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'territory',
    name: '地域',
    children: [
      { id: '4023', parentId: '4022', petitionVal: '', sortValue: '0', code: '0', name: '省直', children: [] },
      { id: '4024', parentId: '4023', petitionVal: '', sortValue: '1', code: '1', name: '地市', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '2', code: '2', name: '区县', children: [] },
      { id: '4026', parentId: '4025', petitionVal: '', sortValue: '3', code: '3', name: '乡镇', children: [] }
    ]
  },
  {
    id: '4022',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'tjly',
    name: '推荐来源',
    children: [
      { id: '4023', parentId: '4022', petitionVal: '', sortValue: '1', code: '1', name: '巡视组推荐', children: [] },
      { id: '4024', parentId: '4023', petitionVal: '', sortValue: '2', code: '2', name: '所在单位推荐', children: [] },
    ]
  },
  {
    id: '4022',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'zytc',
    name: '专业特长',
    children: [
      { id: '4023', parentId: '4022', petitionVal: '', sortValue: '1', code: 'ss_01', name: '纪检监察', children: [] },
      { id: '4024', parentId: '4023', petitionVal: '', sortValue: '2', code: 'ss_02', name: '财务审计', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'ss_03', name: '综合文字', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'ss_04', name: '组织人事', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'ss_05', name: '党建', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'ss_other', name: '其他', children: [] },
    ]
  },
  {
    id: '4044',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'zjds',
    name: '江西地市',
    children: [
      { id: '4023', parentId: '4022', petitionVal: '', sortValue: '1', code: 'zjds_01', name: '南昌市', children: [] },
      { id: '4024', parentId: '4023', petitionVal: '', sortValue: '2', code: 'zjds_02', name: '景德镇市', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'zjds_03', name: '九江市', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'zjds_04', name: '新余市 ', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'zjds_05', name: '鹰潭市', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'zjds_06', name: '赣州市', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'zjds_07', name: '萍乡市', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'zjds_08', name: '吉安市', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'zjds_09', name: '宜春市', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'zjds_10', name: '抚州市', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'zjds_11', name: '上饶市', children: [] },
    ]
  },
  {
    id: '4044',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'resultJudge',
    name: '结果判断',
    children: [
      { id: '4023', parentId: '4022', petitionVal: '', sortValue: '1', code: 'resultJudge_01', name: '查实', children: [] },
      { id: '4024', parentId: '4023', petitionVal: '', sortValue: '2', code: 'resultJudge_02', name: '查否', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'resultJudge_03', name: '部分查实', children: [] },
    ]
  },
  {
    id: '4044',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'inspectionAdvice',
    name: '巡视建议',
    children: [
      { id: '4023', parentId: '4022', petitionVal: '', sortValue: '1', code: 'inspectionAdvice_01', name: '进一步了解关注类', children: [] },
      { id: '4024', parentId: '4023', petitionVal: '', sortValue: '2', code: 'inspectionAdvice_02', name: '了解关注类', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'inspectionAdvice_03', name: '参考类', children: [] },
    ]
  },
  {
    id: '4044',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'clueStatus',
    name: '线索状态',
    children: [
      // { id: '4023', parentId: '4022', petitionVal: '', sortValue: '1', code: 'end_01', name: '立案', children: [] },
      // { id: '4024', parentId: '4023', petitionVal: '', sortValue: '2', code: 'end_02', name: '初步核实', children: [] },
      // { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'end_03', name: '谈话函询', children: [] },
      // { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'end_04', name: '暂存待查', children: [] },
      // { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'end_05', name: '予以了结', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'unPush', name: '未推送', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'unDisposed', name: '未签收', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'unFeedback', name: '未反馈', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'feedback', name: '已反馈', children: [] },
    ]
  },
  {
    id: '4044',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'transferUnit',
    name: '接收单位',
    children: [
      { id: '4023', parentId: '4022', petitionVal: '', sortValue: '1', code: 'transferUnit_01', name: '省纪委案管室', children: [] },
      { id: '4024', parentId: '4023', petitionVal: '', sortValue: '2', code: 'transferUnit_02', name: '派驻纪检监察组', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'transferUnit_03', name: '设区市纪委监委', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '4', code: 'transferUnit_04', name: '县（市、区）纪委监委', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '5', code: 'transferUnit_05', name: '其他部门', children: [] },
    ]
  },
  {
    id: '4044',
    parentId: '',
    petitionVal: '',
    sortValue: '',
    code: 'rankDetail',
    name: '干部级别',
    children: [
      { id: '4023', parentId: '4022', petitionVal: '', sortValue: '1', code: 'rankDetail_01', name: '厅级', children: [] },
      { id: '4024', parentId: '4023', petitionVal: '', sortValue: '2', code: 'rankDetail_02', name: '处级', children: [] },
      { id: '4025', parentId: '4024', petitionVal: '', sortValue: '3', code: 'rankDetail_03', name: '科级及以下', children: [] },
    ]
  },
]



// WEBPACK FOOTER //
// ./src/js/CategoryMapPaiZu.js